export var MapJson = {
  "status": true,
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "adcode": 650100,
        "name": "乌鲁木齐市",
        "center": [
          87.617733,
          43.792818
        ],
        "centroid": [
          87.783748,
          43.739398
        ],
        "childrenNum": 8,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 0,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                87.504658,
                44.066424
              ],
              [
                87.492529,
                44.007757
              ],
              [
                87.508319,
                44.021456
              ],
              [
                87.527542,
                44.093648
              ],
              [
                87.576743,
                44.116541
              ],
              [
                87.564614,
                44.170929
              ],
              [
                87.584066,
                44.239347
              ],
              [
                87.640132,
                44.226561
              ],
              [
                87.652489,
                44.196236
              ],
              [
                87.691163,
                44.221963
              ],
              [
                87.712216,
                44.262902
              ],
              [
                87.716107,
                44.356881
              ],
              [
                87.692765,
                44.370212
              ],
              [
                87.693452,
                44.416633
              ],
              [
                87.663702,
                44.417063
              ],
              [
                87.652718,
                44.450423
              ],
              [
                87.598711,
                44.477756
              ],
              [
                87.59116,
                44.533383
              ],
              [
                87.575141,
                44.583531
              ],
              [
                87.575141,
                44.583531
              ],
              [
                87.58132,
                44.596525
              ],
              [
                87.555461,
                44.665873
              ],
              [
                87.336231,
                45.001874
              ],
              [
                88.004446,
                45.002015
              ],
              [
                87.989114,
                44.961169
              ],
              [
                87.802151,
                44.378238
              ],
              [
                87.794828,
                44.329205
              ],
              [
                87.81611,
                44.288599
              ],
              [
                87.818627,
                44.225268
              ],
              [
                87.774232,
                44.11726
              ],
              [
                87.824348,
                44.123306
              ],
              [
                87.85959,
                44.09624
              ],
              [
                87.866226,
                44.063975
              ],
              [
                87.958449,
                44.009199
              ],
              [
                87.996894,
                43.994632
              ],
              [
                88.018405,
                43.937482
              ],
              [
                88.018405,
                43.874496
              ],
              [
                88.06486,
                43.854257
              ],
              [
                88.090719,
                43.81318
              ],
              [
                88.132826,
                43.817086
              ],
              [
                88.138318,
                43.756869
              ],
              [
                88.169898,
                43.772074
              ],
              [
                88.21086,
                43.758897
              ],
              [
                88.259146,
                43.786985
              ],
              [
                88.247246,
                43.80334
              ],
              [
                88.282487,
                43.830974
              ],
              [
                88.315669,
                43.790604
              ],
              [
                88.33924,
                43.801459
              ],
              [
                88.413842,
                43.791617
              ],
              [
                88.460068,
                43.807681
              ],
              [
                88.512015,
                43.858016
              ],
              [
                88.531466,
                43.801314
              ],
              [
                88.600118,
                43.803919
              ],
              [
                88.626893,
                43.765703
              ],
              [
                88.693485,
                43.759621
              ],
              [
                88.723006,
                43.742964
              ],
              [
                88.704927,
                43.708913
              ],
              [
                88.758476,
                43.706449
              ],
              [
                88.835138,
                43.720797
              ],
              [
                88.936285,
                43.63248
              ],
              [
                88.974273,
                43.55101
              ],
              [
                88.936285,
                43.489943
              ],
              [
                88.93148,
                43.435368
              ],
              [
                88.871523,
                43.413961
              ],
              [
                88.842689,
                43.388466
              ],
              [
                88.753899,
                43.396625
              ],
              [
                88.641538,
                43.353922
              ],
              [
                88.555037,
                43.342549
              ],
              [
                88.53261,
                43.352027
              ],
              [
                88.523457,
                43.262585
              ],
              [
                88.482494,
                43.242139
              ],
              [
                88.430776,
                43.197427
              ],
              [
                88.351597,
                43.227093
              ],
              [
                88.310177,
                43.212188
              ],
              [
                88.247932,
                43.224609
              ],
              [
                88.21887,
                43.271345
              ],
              [
                88.225048,
                43.325193
              ],
              [
                88.164634,
                43.331028
              ],
              [
                88.045408,
                43.318045
              ],
              [
                87.99964,
                43.300245
              ],
              [
                87.974697,
                43.313815
              ],
              [
                87.886135,
                43.29864
              ],
              [
                87.752492,
                43.298056
              ],
              [
                87.587727,
                43.260979
              ],
              [
                87.36804,
                43.281272
              ],
              [
                87.393899,
                43.184124
              ],
              [
                87.385203,
                43.123565
              ],
              [
                87.414266,
                43.105562
              ],
              [
                87.487953,
                43.10278
              ],
              [
                87.597567,
                43.040089
              ],
              [
                87.634411,
                43.036572
              ],
              [
                87.638072,
                42.998162
              ],
              [
                87.755925,
                42.961196
              ],
              [
                87.815424,
                42.925382
              ],
              [
                87.862565,
                42.884551
              ],
              [
                87.931675,
                42.854426
              ],
              [
                87.941515,
                42.827815
              ],
              [
                87.882245,
                42.829873
              ],
              [
                87.789336,
                42.872209
              ],
              [
                87.758213,
                42.898948
              ],
              [
                87.66805,
                42.903207
              ],
              [
                87.569649,
                42.899095
              ],
              [
                87.538069,
                42.908201
              ],
              [
                87.497106,
                42.940062
              ],
              [
                87.403053,
                42.96369
              ],
              [
                87.345156,
                42.999775
              ],
              [
                87.270096,
                43.032322
              ],
              [
                87.111281,
                43.063093
              ],
              [
                87.111052,
                43.046684
              ],
              [
                87.054528,
                43.022941
              ],
              [
                86.926378,
                43.051519
              ],
              [
                86.912189,
                43.074665
              ],
              [
                86.853835,
                43.083452
              ],
              [
                86.797998,
                43.112442
              ],
              [
                86.844681,
                43.159703
              ],
              [
                86.815161,
                43.171403
              ],
              [
                86.85475,
                43.211458
              ],
              [
                86.895942,
                43.302726
              ],
              [
                86.922716,
                43.325047
              ],
              [
                86.940108,
                43.367188
              ],
              [
                86.904867,
                43.393129
              ],
              [
                86.900976,
                43.429398
              ],
              [
                86.97123,
                43.474231
              ],
              [
                86.997318,
                43.530952
              ],
              [
                87.102814,
                43.596188
              ],
              [
                87.169635,
                43.679628
              ],
              [
                87.202588,
                43.698186
              ],
              [
                87.222497,
                43.740212
              ],
              [
                87.278563,
                43.800446
              ],
              [
                87.280852,
                43.865968
              ],
              [
                87.262545,
                43.923764
              ],
              [
                87.28703,
                43.959569
              ],
              [
                87.383144,
                44.044233
              ],
              [
                87.404426,
                44.046827
              ],
              [
                87.404426,
                44.046827
              ],
              [
                87.46278,
                44.078813
              ],
              [
                87.504658,
                44.066424
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 650200,
        "name": "克拉玛依市",
        "center": [
          84.873946,
          45.595886
        ],
        "centroid": [
          85.186723,
          45.512857
        ],
        "childrenNum": 4,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 1,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                84.854225,
                44.685692
              ],
              [
                84.800677,
                44.683554
              ],
              [
                84.782598,
                44.669153
              ],
              [
                84.708454,
                44.733857
              ],
              [
                84.677331,
                44.739839
              ],
              [
                84.626071,
                44.791801
              ],
              [
                84.652388,
                44.791231
              ],
              [
                84.648726,
                44.866316
              ],
              [
                84.635682,
                44.867026
              ],
              [
                84.668864,
                45.158607
              ],
              [
                84.633394,
                45.185888
              ],
              [
                84.58877,
                45.241401
              ],
              [
                84.579388,
                45.31068
              ],
              [
                84.623325,
                45.343808
              ],
              [
                84.651701,
                45.395646
              ],
              [
                84.710742,
                45.451797
              ],
              [
                84.739576,
                45.520819
              ],
              [
                84.783513,
                45.597613
              ],
              [
                84.80594,
                45.608275
              ],
              [
                84.772071,
                45.648658
              ],
              [
                84.791981,
                45.663794
              ],
              [
                84.847589,
                45.631414
              ],
              [
                84.910291,
                45.648938
              ],
              [
                84.956746,
                45.707777
              ],
              [
                85.023796,
                45.721218
              ],
              [
                85.059953,
                45.713098
              ],
              [
                85.129978,
                45.74543
              ],
              [
                85.193825,
                45.802491
              ],
              [
                85.22838,
                45.850136
              ],
              [
                85.258358,
                45.925364
              ],
              [
                85.288565,
                45.967608
              ],
              [
                85.259044,
                45.978199
              ],
              [
                85.293142,
                45.993246
              ],
              [
                85.263392,
                46.053114
              ],
              [
                85.282844,
                46.090811
              ],
              [
                85.380101,
                46.143628
              ],
              [
                85.419462,
                46.128066
              ],
              [
                85.437998,
                46.150296
              ],
              [
                85.557453,
                46.198059
              ],
              [
                85.648302,
                46.211936
              ],
              [
                85.679882,
                46.190842
              ],
              [
                85.791557,
                46.192924
              ],
              [
                85.813754,
                46.178209
              ],
              [
                85.903002,
                46.181819
              ],
              [
                85.993165,
                46.123897
              ],
              [
                86.024288,
                46.068001
              ],
              [
                85.962501,
                46.044764
              ],
              [
                85.95472,
                46.001325
              ],
              [
                85.931836,
                45.975273
              ],
              [
                85.880347,
                45.952973
              ],
              [
                85.886297,
                45.938751
              ],
              [
                85.839613,
                45.921877
              ],
              [
                85.814212,
                45.895369
              ],
              [
                85.642353,
                45.78921
              ],
              [
                85.621299,
                45.763058
              ],
              [
                85.59155,
                45.654404
              ],
              [
                85.596813,
                45.641929
              ],
              [
                85.547384,
                45.593123
              ],
              [
                85.491775,
                45.51267
              ],
              [
                85.434336,
                45.459814
              ],
              [
                85.388111,
                45.436182
              ],
              [
                85.28353,
                45.421406
              ],
              [
                85.239593,
                45.375508
              ],
              [
                85.245772,
                45.329008
              ],
              [
                85.239593,
                45.29305
              ],
              [
                85.201834,
                45.244224
              ],
              [
                85.205953,
                45.207365
              ],
              [
                85.250348,
                45.158607
              ],
              [
                85.238449,
                45.080223
              ],
              [
                85.258358,
                45.031639
              ],
              [
                85.240737,
                45.019735
              ],
              [
                85.171627,
                45.022711
              ],
              [
                85.156066,
                44.970958
              ],
              [
                85.051486,
                44.931793
              ],
              [
                85.027229,
                44.886208
              ],
              [
                85.021965,
                44.814421
              ],
              [
                85.047367,
                44.770167
              ],
              [
                85.010295,
                44.755219
              ],
              [
                84.954,
                44.799911
              ],
              [
                84.898163,
                44.802899
              ],
              [
                84.851021,
                44.826368
              ],
              [
                84.792667,
                44.803752
              ],
              [
                84.854225,
                44.685692
              ]
            ]
          ],
          [
            [
              [
                85.113273,
                44.34369
              ],
              [
                85.108467,
                44.309551
              ],
              [
                85.065445,
                44.317299
              ],
              [
                84.996106,
                44.310699
              ],
              [
                84.969103,
                44.297354
              ],
              [
                84.939354,
                44.252275
              ],
              [
                84.917385,
                44.17927
              ],
              [
                84.830426,
                44.160142
              ],
              [
                84.797244,
                44.161436
              ],
              [
                84.737974,
                44.126185
              ],
              [
                84.792209,
                44.224262
              ],
              [
                84.798159,
                44.258737
              ],
              [
                84.779166,
                44.343546
              ],
              [
                84.77825,
                44.390848
              ],
              [
                84.974595,
                44.384687
              ],
              [
                85.113273,
                44.34369
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 650400,
        "name": "吐鲁番市",
        "center": [
          89.184078,
          42.947613
        ],
        "centroid": [
          89.829374,
          42.398557
        ],
        "childrenNum": 3,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 2,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                91.910299,
                41.271422
              ],
              [
                91.840273,
                41.281066
              ],
              [
                91.765214,
                41.267202
              ],
              [
                91.641182,
                41.226949
              ],
              [
                91.446667,
                41.197687
              ],
              [
                91.194485,
                41.226497
              ],
              [
                91.092651,
                41.251375
              ],
              [
                90.966331,
                41.245797
              ],
              [
                90.905917,
                41.227552
              ],
              [
                90.780512,
                41.225743
              ],
              [
                90.69996,
                41.239314
              ],
              [
                90.65465,
                41.237052
              ],
              [
                90.54023,
                41.250018
              ],
              [
                90.399721,
                41.234187
              ],
              [
                90.315279,
                41.24248
              ],
              [
                90.108636,
                41.252883
              ],
              [
                89.960347,
                41.357416
              ],
              [
                89.834256,
                41.377129
              ],
              [
                89.785742,
                41.34974
              ],
              [
                89.743635,
                41.344622
              ],
              [
                89.698096,
                41.366596
              ],
              [
                89.616629,
                41.355158
              ],
              [
                89.558045,
                41.3678
              ],
              [
                89.460788,
                41.359824
              ],
              [
                89.45644,
                41.375022
              ],
              [
                89.399001,
                41.396385
              ],
              [
                89.338816,
                41.404807
              ],
              [
                89.33607,
                41.389766
              ],
              [
                89.282979,
                41.393076
              ],
              [
                89.204029,
                41.361178
              ],
              [
                89.082057,
                41.409921
              ],
              [
                89.017753,
                41.426912
              ],
              [
                88.990063,
                41.419394
              ],
              [
                88.859624,
                41.42195
              ],
              [
                88.835824,
                41.440892
              ],
              [
                88.735363,
                41.475003
              ],
              [
                88.563275,
                41.477858
              ],
              [
                88.406519,
                41.459828
              ],
              [
                88.318873,
                41.493179
              ],
              [
                88.307889,
                41.513902
              ],
              [
                88.347478,
                41.533567
              ],
              [
                88.33718,
                41.641246
              ],
              [
                88.347936,
                41.67016
              ],
              [
                88.341986,
                41.76804
              ],
              [
                88.293929,
                41.822752
              ],
              [
                88.215437,
                41.871296
              ],
              [
                88.19324,
                41.926965
              ],
              [
                88.168754,
                41.945013
              ],
              [
                88.138775,
                42.004193
              ],
              [
                87.997581,
                42.069867
              ],
              [
                87.923436,
                42.177985
              ],
              [
                87.898264,
                42.248675
              ],
              [
                88.003531,
                42.329218
              ],
              [
                88.122299,
                42.371302
              ],
              [
                88.176534,
                42.439556
              ],
              [
                88.202393,
                42.501674
              ],
              [
                88.166008,
                42.547927
              ],
              [
                88.128935,
                42.572296
              ],
              [
                88.031449,
                42.604035
              ],
              [
                87.981104,
                42.640478
              ],
              [
                87.947922,
                42.635906
              ],
              [
                87.913139,
                42.659355
              ],
              [
                87.9049,
                42.704018
              ],
              [
                87.841054,
                42.768229
              ],
              [
                87.691392,
                42.760721
              ],
              [
                87.589558,
                42.778826
              ],
              [
                87.544019,
                42.777796
              ],
              [
                87.509235,
                42.795601
              ],
              [
                87.543103,
                42.8459
              ],
              [
                87.52594,
                42.865155
              ],
              [
                87.538069,
                42.908201
              ],
              [
                87.569649,
                42.899095
              ],
              [
                87.66805,
                42.903207
              ],
              [
                87.758213,
                42.898948
              ],
              [
                87.789336,
                42.872209
              ],
              [
                87.882245,
                42.829873
              ],
              [
                87.941515,
                42.827815
              ],
              [
                87.931675,
                42.854426
              ],
              [
                87.862565,
                42.884551
              ],
              [
                87.815424,
                42.925382
              ],
              [
                87.755925,
                42.961196
              ],
              [
                87.638072,
                42.998162
              ],
              [
                87.634411,
                43.036572
              ],
              [
                87.597567,
                43.040089
              ],
              [
                87.487953,
                43.10278
              ],
              [
                87.414266,
                43.105562
              ],
              [
                87.385203,
                43.123565
              ],
              [
                87.393899,
                43.184124
              ],
              [
                87.36804,
                43.281272
              ],
              [
                87.587727,
                43.260979
              ],
              [
                87.752492,
                43.298056
              ],
              [
                87.886135,
                43.29864
              ],
              [
                87.974697,
                43.313815
              ],
              [
                87.99964,
                43.300245
              ],
              [
                88.045408,
                43.318045
              ],
              [
                88.164634,
                43.331028
              ],
              [
                88.225048,
                43.325193
              ],
              [
                88.21887,
                43.271345
              ],
              [
                88.247932,
                43.224609
              ],
              [
                88.310177,
                43.212188
              ],
              [
                88.351597,
                43.227093
              ],
              [
                88.430776,
                43.197427
              ],
              [
                88.482494,
                43.242139
              ],
              [
                88.523457,
                43.262585
              ],
              [
                88.53261,
                43.352027
              ],
              [
                88.555037,
                43.342549
              ],
              [
                88.641538,
                43.353922
              ],
              [
                88.753899,
                43.396625
              ],
              [
                88.842689,
                43.388466
              ],
              [
                88.871523,
                43.413961
              ],
              [
                88.93148,
                43.435368
              ],
              [
                88.936285,
                43.489943
              ],
              [
                88.974273,
                43.55101
              ],
              [
                88.936285,
                43.63248
              ],
              [
                88.999903,
                43.607078
              ],
              [
                89.078853,
                43.594445
              ],
              [
                89.138123,
                43.600254
              ],
              [
                89.189154,
                43.580793
              ],
              [
                89.199223,
                43.539673
              ],
              [
                89.226913,
                43.526445
              ],
              [
                89.280233,
                43.552753
              ],
              [
                89.31433,
                43.536185
              ],
              [
                89.326001,
                43.501434
              ],
              [
                89.375659,
                43.490962
              ],
              [
                89.398086,
                43.449344
              ],
              [
                89.519142,
                43.44978
              ],
              [
                89.550265,
                43.433184
              ],
              [
                89.624638,
                43.427505
              ],
              [
                89.67956,
                43.410319
              ],
              [
                89.749127,
                43.426922
              ],
              [
                89.758739,
                43.463899
              ],
              [
                89.896958,
                43.466227
              ],
              [
                89.920071,
                43.452837
              ],
              [
                89.964695,
                43.473794
              ],
              [
                89.966755,
                43.492562
              ],
              [
                90.014125,
                43.490671
              ],
              [
                90.016184,
                43.516704
              ],
              [
                90.057147,
                43.519903
              ],
              [
                90.17294,
                43.55348
              ],
              [
                90.21253,
                43.535022
              ],
              [
                90.269969,
                43.53226
              ],
              [
                90.318025,
                43.504925
              ],
              [
                90.361505,
                43.515686
              ],
              [
                90.385304,
                43.498525
              ],
              [
                90.420546,
                43.526881
              ],
              [
                90.555104,
                43.501434
              ],
              [
                90.635198,
                43.502307
              ],
              [
                90.686916,
                43.523101
              ],
              [
                90.760145,
                43.517867
              ],
              [
                90.790124,
                43.528044
              ],
              [
                90.843443,
                43.522229
              ],
              [
                90.881202,
                43.532842
              ],
              [
                90.948939,
                43.504489
              ],
              [
                91.003632,
                43.515104
              ],
              [
                91.017591,
                43.495325
              ],
              [
                91.104551,
                43.494744
              ],
              [
                91.129952,
                43.483833
              ],
              [
                91.169084,
                43.49518
              ],
              [
                91.15398,
                43.472048
              ],
              [
                91.16588,
                43.442356
              ],
              [
                91.204554,
                43.423282
              ],
              [
                91.225836,
                43.3822
              ],
              [
                91.209131,
                43.356255
              ],
              [
                91.259018,
                43.334236
              ],
              [
                91.255128,
                43.295138
              ],
              [
                91.313025,
                43.135126
              ],
              [
                91.347351,
                43.102048
              ],
              [
                91.384652,
                42.972787
              ],
              [
                91.416232,
                42.835461
              ],
              [
                91.408909,
                42.789716
              ],
              [
                91.429047,
                42.727295
              ],
              [
                91.407307,
                42.671298
              ],
              [
                91.412113,
                42.618792
              ],
              [
                91.431106,
                42.579531
              ],
              [
                91.447354,
                42.49443
              ],
              [
                91.448269,
                42.438372
              ],
              [
                91.472984,
                42.295411
              ],
              [
                91.464288,
                42.246003
              ],
              [
                91.503649,
                42.202795
              ],
              [
                91.637521,
                42.140529
              ],
              [
                91.632715,
                42.075225
              ],
              [
                91.696104,
                42.064508
              ],
              [
                91.737066,
                42.011046
              ],
              [
                91.808693,
                41.841577
              ],
              [
                91.855377,
                41.74336
              ],
              [
                91.833408,
                41.690377
              ],
              [
                91.82128,
                41.57393
              ],
              [
                91.784436,
                41.558778
              ],
              [
                91.785581,
                41.508947
              ],
              [
                91.823797,
                41.498585
              ],
              [
                91.889932,
                41.401799
              ],
              [
                91.905264,
                41.399694
              ],
              [
                91.910299,
                41.271422
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 650500,
        "name": "哈密市",
        "center": [
          93.51316,
          42.833248
        ],
        "centroid": [
          93.512835,
          43.0655
        ],
        "childrenNum": 3,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 3,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                91.518752,
                45.096928
              ],
              [
                91.561545,
                45.075551
              ],
              [
                91.69496,
                45.065355
              ],
              [
                91.803201,
                45.082772
              ],
              [
                91.905722,
                45.078666
              ],
              [
                92.044857,
                45.08447
              ],
              [
                92.100236,
                45.081497
              ],
              [
                92.240287,
                45.015908
              ],
              [
                92.315347,
                45.028947
              ],
              [
                92.348986,
                45.014065
              ],
              [
                92.414206,
                45.018459
              ],
              [
                92.500936,
                45.001165
              ],
              [
                92.547849,
                45.018318
              ],
              [
                92.684009,
                45.025829
              ],
              [
                92.779436,
                45.050624
              ],
              [
                92.847859,
                45.038582
              ],
              [
                92.884245,
                45.0468
              ],
              [
                92.932988,
                45.017325
              ],
              [
                93.002098,
                45.010096
              ],
              [
                93.062283,
                45.018318
              ],
              [
                93.100041,
                45.007403
              ],
              [
                93.173957,
                45.015199
              ],
              [
                93.313779,
                44.980461
              ],
              [
                93.314923,
                44.995068
              ],
              [
                93.376939,
                44.985425
              ],
              [
                93.434378,
                44.95521
              ],
              [
                93.509437,
                44.968262
              ],
              [
                93.613331,
                44.92654
              ],
              [
                93.71608,
                44.894447
              ],
              [
                93.723861,
                44.865321
              ],
              [
                94.066207,
                44.732147
              ],
              [
                94.15248,
                44.685122
              ],
              [
                94.215411,
                44.668155
              ],
              [
                94.279944,
                44.603806
              ],
              [
                94.329831,
                44.582674
              ],
              [
                94.358894,
                44.515657
              ],
              [
                94.390932,
                44.521947
              ],
              [
                94.470797,
                44.509508
              ],
              [
                94.557299,
                44.462589
              ],
              [
                94.606042,
                44.448276
              ],
              [
                94.67355,
                44.396866
              ],
              [
                94.722751,
                44.340822
              ],
              [
                94.768061,
                44.340535
              ],
              [
                94.826187,
                44.320168
              ],
              [
                94.945413,
                44.292762
              ],
              [
                94.998732,
                44.253136
              ],
              [
                95.413621,
                44.298646
              ],
              [
                95.430097,
                44.281709
              ],
              [
                95.410646,
                44.245093
              ],
              [
                95.376091,
                44.227423
              ],
              [
                95.355953,
                44.165895
              ],
              [
                95.351834,
                44.090048
              ],
              [
                95.326661,
                44.028809
              ],
              [
                95.377693,
                44.02607
              ],
              [
                95.426436,
                44.009488
              ],
              [
                95.526897,
                44.007469
              ],
              [
                95.62301,
                43.855703
              ],
              [
                95.645207,
                43.787854
              ],
              [
                95.70585,
                43.670926
              ],
              [
                95.735599,
                43.597495
              ],
              [
                95.858029,
                43.417602
              ],
              [
                95.879769,
                43.280104
              ],
              [
                95.921418,
                43.229722
              ],
              [
                96.363538,
                42.900564
              ],
              [
                96.386193,
                42.727737
              ],
              [
                96.166278,
                42.623366
              ],
              [
                96.103575,
                42.604183
              ],
              [
                96.072453,
                42.569343
              ],
              [
                96.02371,
                42.542462
              ],
              [
                96.017531,
                42.482158
              ],
              [
                95.978628,
                42.436744
              ],
              [
                96.066045,
                42.414543
              ],
              [
                96.041102,
                42.326549
              ],
              [
                96.178406,
                42.217943
              ],
              [
                96.077259,
                42.149598
              ],
              [
                96.139046,
                42.054236
              ],
              [
                96.115933,
                41.98482
              ],
              [
                96.038356,
                41.924727
              ],
              [
                95.883888,
                41.867862
              ],
              [
                95.855741,
                41.849643
              ],
              [
                95.677245,
                41.83097
              ],
              [
                95.571521,
                41.796
              ],
              [
                95.510191,
                41.756374
              ],
              [
                95.394398,
                41.693521
              ],
              [
                95.335357,
                41.644243
              ],
              [
                95.306752,
                41.57168
              ],
              [
                95.250228,
                41.609021
              ],
              [
                95.194162,
                41.695018
              ],
              [
                95.199426,
                41.719418
              ],
              [
                95.164871,
                41.73528
              ],
              [
                95.136266,
                41.772826
              ],
              [
                95.011319,
                41.726302
              ],
              [
                94.968754,
                41.718819
              ],
              [
                94.861886,
                41.668512
              ],
              [
                94.80971,
                41.619365
              ],
              [
                94.750211,
                41.53837
              ],
              [
                94.534186,
                41.505944
              ],
              [
                94.18406,
                41.268558
              ],
              [
                94.010827,
                41.114805
              ],
              [
                93.908307,
                40.9834
              ],
              [
                93.809905,
                40.87933
              ],
              [
                93.696629,
                40.875388
              ],
              [
                93.556807,
                40.957511
              ],
              [
                93.348333,
                40.993995
              ],
              [
                93.261374,
                40.986276
              ],
              [
                93.200731,
                40.990968
              ],
              [
                93.102101,
                41.041045
              ],
              [
                93.062054,
                41.048757
              ],
              [
                92.99569,
                41.079749
              ],
              [
                92.863191,
                41.112992
              ],
              [
                92.742821,
                41.125228
              ],
              [
                92.66204,
                41.115258
              ],
              [
                92.535949,
                41.120847
              ],
              [
                92.505513,
                41.142897
              ],
              [
                92.373243,
                41.165543
              ],
              [
                92.177356,
                41.222727
              ],
              [
                92.070029,
                41.264187
              ],
              [
                92.023346,
                41.272476
              ],
              [
                91.910299,
                41.271422
              ],
              [
                91.905264,
                41.399694
              ],
              [
                91.889932,
                41.401799
              ],
              [
                91.823797,
                41.498585
              ],
              [
                91.785581,
                41.508947
              ],
              [
                91.784436,
                41.558778
              ],
              [
                91.82128,
                41.57393
              ],
              [
                91.833408,
                41.690377
              ],
              [
                91.855377,
                41.74336
              ],
              [
                91.808693,
                41.841577
              ],
              [
                91.737066,
                42.011046
              ],
              [
                91.696104,
                42.064508
              ],
              [
                91.632715,
                42.075225
              ],
              [
                91.637521,
                42.140529
              ],
              [
                91.503649,
                42.202795
              ],
              [
                91.464288,
                42.246003
              ],
              [
                91.472984,
                42.295411
              ],
              [
                91.448269,
                42.438372
              ],
              [
                91.447354,
                42.49443
              ],
              [
                91.431106,
                42.579531
              ],
              [
                91.412113,
                42.618792
              ],
              [
                91.407307,
                42.671298
              ],
              [
                91.429047,
                42.727295
              ],
              [
                91.408909,
                42.789716
              ],
              [
                91.416232,
                42.835461
              ],
              [
                91.384652,
                42.972787
              ],
              [
                91.347351,
                43.102048
              ],
              [
                91.313025,
                43.135126
              ],
              [
                91.255128,
                43.295138
              ],
              [
                91.259018,
                43.334236
              ],
              [
                91.209131,
                43.356255
              ],
              [
                91.225836,
                43.3822
              ],
              [
                91.204554,
                43.423282
              ],
              [
                91.16588,
                43.442356
              ],
              [
                91.15398,
                43.472048
              ],
              [
                91.169084,
                43.49518
              ],
              [
                91.174805,
                43.524991
              ],
              [
                91.225607,
                43.540255
              ],
              [
                91.295861,
                43.546504
              ],
              [
                91.317144,
                43.586313
              ],
              [
                91.396094,
                43.585151
              ],
              [
                91.474815,
                43.605336
              ],
              [
                91.495182,
                43.629433
              ],
              [
                91.553994,
                43.643364
              ],
              [
                91.501589,
                43.649167
              ],
              [
                91.470925,
                43.675277
              ],
              [
                91.366344,
                43.705144
              ],
              [
                91.492436,
                43.726158
              ],
              [
                91.563834,
                43.745572
              ],
              [
                91.563147,
                43.769468
              ],
              [
                91.525618,
                43.816652
              ],
              [
                91.511429,
                43.870882
              ],
              [
                91.435912,
                43.909464
              ],
              [
                91.419664,
                43.927519
              ],
              [
                91.307075,
                44.008911
              ],
              [
                91.319432,
                44.049997
              ],
              [
                91.334993,
                44.174668
              ],
              [
                91.332934,
                44.28013
              ],
              [
                91.287623,
                44.375515
              ],
              [
                91.302956,
                44.432958
              ],
              [
                91.344376,
                44.471604
              ],
              [
                91.348953,
                44.549961
              ],
              [
                91.361768,
                44.553819
              ],
              [
                91.402501,
                44.624788
              ],
              [
                91.387169,
                44.736563
              ],
              [
                91.40662,
                44.76248
              ],
              [
                91.530423,
                44.855656
              ],
              [
                91.569097,
                44.894873
              ],
              [
                91.543925,
                44.981454
              ],
              [
                91.501818,
                45.030931
              ],
              [
                91.518752,
                45.096928
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 652300,
        "name": "昌吉回族自治州",
        "center": [
          87.304012,
          44.014577
        ],
        "centroid": [
          89.791022,
          44.351372
        ],
        "childrenNum": 7,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 4,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                90.671355,
                45.487654
              ],
              [
                90.772274,
                45.432805
              ],
              [
                90.774105,
                45.405923
              ],
              [
                90.813008,
                45.328585
              ],
              [
                90.804998,
                45.294884
              ],
              [
                90.831773,
                45.300385
              ],
              [
                90.877083,
                45.280918
              ],
              [
                90.89745,
                45.249871
              ],
              [
                90.866785,
                45.209343
              ],
              [
                90.881889,
                45.191823
              ],
              [
                90.961525,
                45.201432
              ],
              [
                91.00798,
                45.218383
              ],
              [
                91.050544,
                45.208919
              ],
              [
                91.129723,
                45.215982
              ],
              [
                91.170914,
                45.199454
              ],
              [
                91.196087,
                45.159031
              ],
              [
                91.242084,
                45.137394
              ],
              [
                91.335222,
                45.129614
              ],
              [
                91.377329,
                45.11108
              ],
              [
                91.429276,
                45.156627
              ],
              [
                91.449185,
                45.156627
              ],
              [
                91.518752,
                45.096928
              ],
              [
                91.501818,
                45.030931
              ],
              [
                91.543925,
                44.981454
              ],
              [
                91.569097,
                44.894873
              ],
              [
                91.530423,
                44.855656
              ],
              [
                91.40662,
                44.76248
              ],
              [
                91.387169,
                44.736563
              ],
              [
                91.402501,
                44.624788
              ],
              [
                91.361768,
                44.553819
              ],
              [
                91.348953,
                44.549961
              ],
              [
                91.344376,
                44.471604
              ],
              [
                91.302956,
                44.432958
              ],
              [
                91.287623,
                44.375515
              ],
              [
                91.332934,
                44.28013
              ],
              [
                91.334993,
                44.174668
              ],
              [
                91.319432,
                44.049997
              ],
              [
                91.307075,
                44.008911
              ],
              [
                91.419664,
                43.927519
              ],
              [
                91.435912,
                43.909464
              ],
              [
                91.511429,
                43.870882
              ],
              [
                91.525618,
                43.816652
              ],
              [
                91.563147,
                43.769468
              ],
              [
                91.563834,
                43.745572
              ],
              [
                91.492436,
                43.726158
              ],
              [
                91.366344,
                43.705144
              ],
              [
                91.470925,
                43.675277
              ],
              [
                91.501589,
                43.649167
              ],
              [
                91.553994,
                43.643364
              ],
              [
                91.495182,
                43.629433
              ],
              [
                91.474815,
                43.605336
              ],
              [
                91.396094,
                43.585151
              ],
              [
                91.317144,
                43.586313
              ],
              [
                91.295861,
                43.546504
              ],
              [
                91.225607,
                43.540255
              ],
              [
                91.174805,
                43.524991
              ],
              [
                91.169084,
                43.49518
              ],
              [
                91.129952,
                43.483833
              ],
              [
                91.104551,
                43.494744
              ],
              [
                91.017591,
                43.495325
              ],
              [
                91.003632,
                43.515104
              ],
              [
                90.948939,
                43.504489
              ],
              [
                90.881202,
                43.532842
              ],
              [
                90.843443,
                43.522229
              ],
              [
                90.790124,
                43.528044
              ],
              [
                90.760145,
                43.517867
              ],
              [
                90.686916,
                43.523101
              ],
              [
                90.635198,
                43.502307
              ],
              [
                90.555104,
                43.501434
              ],
              [
                90.420546,
                43.526881
              ],
              [
                90.385304,
                43.498525
              ],
              [
                90.361505,
                43.515686
              ],
              [
                90.318025,
                43.504925
              ],
              [
                90.269969,
                43.53226
              ],
              [
                90.21253,
                43.535022
              ],
              [
                90.17294,
                43.55348
              ],
              [
                90.057147,
                43.519903
              ],
              [
                90.016184,
                43.516704
              ],
              [
                90.014125,
                43.490671
              ],
              [
                89.966755,
                43.492562
              ],
              [
                89.964695,
                43.473794
              ],
              [
                89.920071,
                43.452837
              ],
              [
                89.896958,
                43.466227
              ],
              [
                89.758739,
                43.463899
              ],
              [
                89.749127,
                43.426922
              ],
              [
                89.67956,
                43.410319
              ],
              [
                89.624638,
                43.427505
              ],
              [
                89.550265,
                43.433184
              ],
              [
                89.519142,
                43.44978
              ],
              [
                89.398086,
                43.449344
              ],
              [
                89.375659,
                43.490962
              ],
              [
                89.326001,
                43.501434
              ],
              [
                89.31433,
                43.536185
              ],
              [
                89.280233,
                43.552753
              ],
              [
                89.226913,
                43.526445
              ],
              [
                89.199223,
                43.539673
              ],
              [
                89.189154,
                43.580793
              ],
              [
                89.138123,
                43.600254
              ],
              [
                89.078853,
                43.594445
              ],
              [
                88.999903,
                43.607078
              ],
              [
                88.936285,
                43.63248
              ],
              [
                88.835138,
                43.720797
              ],
              [
                88.758476,
                43.706449
              ],
              [
                88.704927,
                43.708913
              ],
              [
                88.723006,
                43.742964
              ],
              [
                88.693485,
                43.759621
              ],
              [
                88.626893,
                43.765703
              ],
              [
                88.600118,
                43.803919
              ],
              [
                88.531466,
                43.801314
              ],
              [
                88.512015,
                43.858016
              ],
              [
                88.460068,
                43.807681
              ],
              [
                88.413842,
                43.791617
              ],
              [
                88.33924,
                43.801459
              ],
              [
                88.315669,
                43.790604
              ],
              [
                88.282487,
                43.830974
              ],
              [
                88.247246,
                43.80334
              ],
              [
                88.259146,
                43.786985
              ],
              [
                88.21086,
                43.758897
              ],
              [
                88.169898,
                43.772074
              ],
              [
                88.138318,
                43.756869
              ],
              [
                88.132826,
                43.817086
              ],
              [
                88.090719,
                43.81318
              ],
              [
                88.06486,
                43.854257
              ],
              [
                88.018405,
                43.874496
              ],
              [
                88.018405,
                43.937482
              ],
              [
                87.996894,
                43.994632
              ],
              [
                87.958449,
                44.009199
              ],
              [
                87.866226,
                44.063975
              ],
              [
                87.85959,
                44.09624
              ],
              [
                87.824348,
                44.123306
              ],
              [
                87.774232,
                44.11726
              ],
              [
                87.818627,
                44.225268
              ],
              [
                87.81611,
                44.288599
              ],
              [
                87.794828,
                44.329205
              ],
              [
                87.802151,
                44.378238
              ],
              [
                87.989114,
                44.961169
              ],
              [
                88.004446,
                45.002015
              ],
              [
                90.23816,
                45.001732
              ],
              [
                90.22237,
                45.064364
              ],
              [
                90.251204,
                45.087727
              ],
              [
                90.292166,
                45.177267
              ],
              [
                90.353267,
                45.23067
              ],
              [
                90.379583,
                45.276968
              ],
              [
                90.481646,
                45.397335
              ],
              [
                90.494919,
                45.42028
              ],
              [
                90.671355,
                45.487654
              ]
            ]
          ],
          [
            [
              [
                87.59116,
                44.533383
              ],
              [
                87.554774,
                44.580532
              ],
              [
                87.501912,
                44.594812
              ],
              [
                87.514498,
                44.548818
              ],
              [
                87.370557,
                44.566963
              ],
              [
                87.406943,
                44.529381
              ],
              [
                87.449279,
                44.443552
              ],
              [
                87.430056,
                44.408469
              ],
              [
                87.423877,
                44.351433
              ],
              [
                87.489783,
                44.303525
              ],
              [
                87.471934,
                44.283145
              ],
              [
                87.523423,
                44.227279
              ],
              [
                87.506489,
                44.167765
              ],
              [
                87.521592,
                44.150935
              ],
              [
                87.493674,
                44.107615
              ],
              [
                87.504658,
                44.066424
              ],
              [
                87.46278,
                44.078813
              ],
              [
                87.404426,
                44.046827
              ],
              [
                87.404426,
                44.046827
              ],
              [
                87.383144,
                44.044233
              ],
              [
                87.28703,
                43.959569
              ],
              [
                87.262545,
                43.923764
              ],
              [
                87.280852,
                43.865968
              ],
              [
                87.278563,
                43.800446
              ],
              [
                87.222497,
                43.740212
              ],
              [
                87.202588,
                43.698186
              ],
              [
                87.169635,
                43.679628
              ],
              [
                87.102814,
                43.596188
              ],
              [
                86.997318,
                43.530952
              ],
              [
                86.97123,
                43.474231
              ],
              [
                86.900976,
                43.429398
              ],
              [
                86.904867,
                43.393129
              ],
              [
                86.940108,
                43.367188
              ],
              [
                86.922716,
                43.325047
              ],
              [
                86.895942,
                43.302726
              ],
              [
                86.85475,
                43.211458
              ],
              [
                86.815161,
                43.171403
              ],
              [
                86.844681,
                43.159703
              ],
              [
                86.797998,
                43.112442
              ],
              [
                86.741245,
                43.099559
              ],
              [
                86.692731,
                43.118589
              ],
              [
                86.64559,
                43.09707
              ],
              [
                86.61607,
                43.114198
              ],
              [
                86.486317,
                43.142149
              ],
              [
                86.380364,
                43.226508
              ],
              [
                86.293175,
                43.24433
              ],
              [
                86.243746,
                43.288278
              ],
              [
                86.166169,
                43.306811
              ],
              [
                86.153354,
                43.359754
              ],
              [
                86.121545,
                43.371561
              ],
              [
                86.090423,
                43.431728
              ],
              [
                85.989046,
                43.403036
              ],
              [
                85.929776,
                43.430417
              ],
              [
                85.863413,
                43.445996
              ],
              [
                85.842588,
                43.437697
              ],
              [
                85.787209,
                43.450363
              ],
              [
                85.720845,
                43.484415
              ],
              [
                85.690638,
                43.484124
              ],
              [
                85.651277,
                43.522956
              ],
              [
                85.5975,
                43.530806
              ],
              [
                85.579879,
                43.539528
              ],
              [
                85.665008,
                43.622901
              ],
              [
                85.697274,
                43.619272
              ],
              [
                85.719701,
                43.638575
              ],
              [
                85.719701,
                43.678758
              ],
              [
                85.739152,
                43.731809
              ],
              [
                85.779199,
                43.763676
              ],
              [
                85.767757,
                43.791183
              ],
              [
                85.786293,
                43.839507
              ],
              [
                85.883779,
                43.920586
              ],
              [
                85.91925,
                43.934306
              ],
              [
                85.965018,
                43.931706
              ],
              [
                85.955407,
                43.967074
              ],
              [
                85.967535,
                44.003575
              ],
              [
                86.038018,
                44.062102
              ],
              [
                86.096144,
                44.125897
              ],
              [
                86.128868,
                44.211472
              ],
              [
                86.123833,
                44.266204
              ],
              [
                86.141683,
                44.32734
              ],
              [
                86.127037,
                44.374225
              ],
              [
                86.122689,
                44.448992
              ],
              [
                86.130927,
                44.463447
              ],
              [
                86.084015,
                44.490345
              ],
              [
                86.06525,
                44.564105
              ],
              [
                86.068225,
                44.601807
              ],
              [
                86.01788,
                44.603378
              ],
              [
                85.988588,
                44.637773
              ],
              [
                85.955635,
                44.638629
              ],
              [
                85.906892,
                44.736563
              ],
              [
                85.942134,
                44.759633
              ],
              [
                85.891331,
                44.813141
              ],
              [
                85.868447,
                44.86589
              ],
              [
                85.781488,
                44.922849
              ],
              [
                85.668898,
                44.9193
              ],
              [
                85.670729,
                45.278097
              ],
              [
                85.666838,
                45.331123
              ],
              [
                86.487003,
                45.332532
              ],
              [
                87.336918,
                45.330559
              ],
              [
                87.336231,
                45.001874
              ],
              [
                87.555461,
                44.665873
              ],
              [
                87.58132,
                44.596525
              ],
              [
                87.575141,
                44.583531
              ],
              [
                87.575141,
                44.583531
              ],
              [
                87.59116,
                44.533383
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 652700,
        "name": "博尔塔拉蒙古自治州",
        "center": [
          82.074778,
          44.903258
        ],
        "centroid": [
          82.91122,
          44.549726
        ],
        "childrenNum": 4,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 5,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                82.172213,
                44.713627
              ],
              [
                82.126216,
                44.680702
              ],
              [
                82.084338,
                44.666444
              ],
              [
                82.080905,
                44.64405
              ],
              [
                82.128962,
                44.637773
              ],
              [
                82.156651,
                44.669581
              ],
              [
                82.19235,
                44.662308
              ],
              [
                82.23583,
                44.6817
              ],
              [
                82.250934,
                44.691537
              ],
              [
                82.358947,
                44.66844
              ],
              [
                82.393959,
                44.669724
              ],
              [
                82.447737,
                44.688258
              ],
              [
                82.539959,
                44.682271
              ],
              [
                82.543163,
                44.709067
              ],
              [
                82.596483,
                44.722888
              ],
              [
                82.666737,
                44.770025
              ],
              [
                82.674518,
                44.792797
              ],
              [
                82.735847,
                44.827364
              ],
              [
                82.738822,
                44.858641
              ],
              [
                82.679552,
                44.871432
              ],
              [
                82.656439,
                44.944425
              ],
              [
                82.588245,
                45.038582
              ],
              [
                82.615477,
                45.109099
              ],
              [
                82.680696,
                45.138526
              ],
              [
                82.683214,
                45.153799
              ],
              [
                82.757816,
                45.152102
              ],
              [
                82.855531,
                45.100891
              ],
              [
                83.002675,
                45.050766
              ],
              [
                83.09444,
                45.028947
              ],
              [
                83.263554,
                44.998329
              ],
              [
                83.391476,
                44.980887
              ],
              [
                83.474087,
                44.976064
              ],
              [
                83.513448,
                44.939316
              ],
              [
                83.573862,
                44.931225
              ],
              [
                83.600178,
                44.894163
              ],
              [
                83.666313,
                44.888339
              ],
              [
                83.701784,
                44.853951
              ],
              [
                83.730389,
                44.801049
              ],
              [
                83.795837,
                44.756785
              ],
              [
                83.794464,
                44.719469
              ],
              [
                83.75968,
                44.633207
              ],
              [
                83.745492,
                44.552962
              ],
              [
                83.791947,
                44.520375
              ],
              [
                83.79332,
                44.466739
              ],
              [
                83.752815,
                44.46173
              ],
              [
                83.63931,
                44.474751
              ],
              [
                83.602924,
                44.462875
              ],
              [
                83.517567,
                44.467597
              ],
              [
                83.531526,
                44.414915
              ],
              [
                83.489877,
                44.367346
              ],
              [
                83.486216,
                44.317442
              ],
              [
                83.439761,
                44.282571
              ],
              [
                83.448915,
                44.254285
              ],
              [
                83.412071,
                44.168916
              ],
              [
                83.445482,
                44.121723
              ],
              [
                83.448457,
                44.076508
              ],
              [
                83.468824,
                44.036882
              ],
              [
                83.429921,
                44.006171
              ],
              [
                83.399485,
                44.014823
              ],
              [
                83.310466,
                44.008334
              ],
              [
                83.263554,
                44.041206
              ],
              [
                83.238381,
                44.043512
              ],
              [
                83.243416,
                44.073195
              ],
              [
                83.126707,
                44.092928
              ],
              [
                82.945923,
                44.083566
              ],
              [
                82.899697,
                44.053312
              ],
              [
                82.781158,
                44.085871
              ],
              [
                82.705411,
                44.071178
              ],
              [
                82.672916,
                44.114237
              ],
              [
                82.57337,
                44.13669
              ],
              [
                82.5379,
                44.156402
              ],
              [
                82.444991,
                44.182434
              ],
              [
                82.402197,
                44.215927
              ],
              [
                82.36032,
                44.265343
              ],
              [
                82.283658,
                44.249115
              ],
              [
                82.167636,
                44.263476
              ],
              [
                82.082736,
                44.291757
              ],
              [
                82.032391,
                44.285442
              ],
              [
                81.834901,
                44.327484
              ],
              [
                81.777691,
                44.352006
              ],
              [
                81.751603,
                44.347131
              ],
              [
                81.838334,
                44.438256
              ],
              [
                81.903096,
                44.436394
              ],
              [
                82.002184,
                44.456005
              ],
              [
                81.978384,
                44.482906
              ],
              [
                82.08388,
                44.514656
              ],
              [
                82.082507,
                44.570534
              ],
              [
                81.984105,
                44.569962
              ],
              [
                81.960764,
                44.584816
              ],
              [
                81.978384,
                44.634634
              ],
              [
                82.011566,
                44.63335
              ],
              [
                82.012482,
                44.674999
              ],
              [
                81.978613,
                44.692535
              ],
              [
                81.94566,
                44.684694
              ],
              [
                81.968544,
                44.72303
              ],
              [
                82.001269,
                44.745536
              ],
              [
                81.993946,
                44.762053
              ],
              [
                82.056648,
                44.78127
              ],
              [
                82.061454,
                44.762195
              ],
              [
                82.139717,
                44.801334
              ],
              [
                82.157109,
                44.806882
              ],
              [
                82.173128,
                44.80802
              ],
              [
                82.177476,
                44.806882
              ],
              [
                82.184341,
                44.790093
              ],
              [
                82.155736,
                44.770879
              ],
              [
                82.172213,
                44.713627
              ]
            ]
          ],
          [
            [
              [
                82.145667,
                44.89672
              ],
              [
                82.138344,
                44.88493
              ],
              [
                82.07999,
                44.895584
              ],
              [
                82.088915,
                44.879247
              ],
              [
                82.162372,
                44.864326
              ],
              [
                82.138115,
                44.843005
              ],
              [
                82.100814,
                44.857504
              ],
              [
                82.083422,
                44.837602
              ],
              [
                82.122096,
                44.806313
              ],
              [
                82.150015,
                44.833905
              ],
              [
                82.206996,
                44.821248
              ],
              [
                82.271072,
                44.766324
              ],
              [
                82.277937,
                44.743827
              ],
              [
                82.239263,
                44.724028
              ],
              [
                82.192579,
                44.752229
              ],
              [
                82.172213,
                44.713627
              ],
              [
                82.155736,
                44.770879
              ],
              [
                82.184341,
                44.790093
              ],
              [
                82.177476,
                44.806882
              ],
              [
                82.173128,
                44.80802
              ],
              [
                82.157109,
                44.806882
              ],
              [
                82.139717,
                44.801334
              ],
              [
                82.061454,
                44.762195
              ],
              [
                82.056648,
                44.78127
              ],
              [
                81.993946,
                44.762053
              ],
              [
                82.001269,
                44.745536
              ],
              [
                81.968544,
                44.72303
              ],
              [
                81.94566,
                44.684694
              ],
              [
                81.978613,
                44.692535
              ],
              [
                82.012482,
                44.674999
              ],
              [
                82.011566,
                44.63335
              ],
              [
                81.978384,
                44.634634
              ],
              [
                81.960764,
                44.584816
              ],
              [
                81.984105,
                44.569962
              ],
              [
                82.082507,
                44.570534
              ],
              [
                82.08388,
                44.514656
              ],
              [
                81.978384,
                44.482906
              ],
              [
                82.002184,
                44.456005
              ],
              [
                81.903096,
                44.436394
              ],
              [
                81.838334,
                44.438256
              ],
              [
                81.751603,
                44.347131
              ],
              [
                81.713845,
                44.365769
              ],
              [
                81.700114,
                44.394287
              ],
              [
                81.650913,
                44.38655
              ],
              [
                81.618647,
                44.427374
              ],
              [
                81.591415,
                44.41649
              ],
              [
                81.459603,
                44.450996
              ],
              [
                81.425734,
                44.440546
              ],
              [
                81.358455,
                44.44255
              ],
              [
                81.211311,
                44.462875
              ],
              [
                81.112222,
                44.506792
              ],
              [
                81.048376,
                44.50336
              ],
              [
                80.99826,
                44.535527
              ],
              [
                80.890018,
                44.52981
              ],
              [
                80.873771,
                44.563677
              ],
              [
                80.843564,
                44.568391
              ],
              [
                80.755002,
                44.61023
              ],
              [
                80.707632,
                44.601807
              ],
              [
                80.66072,
                44.637202
              ],
              [
                80.691842,
                44.674144
              ],
              [
                80.638293,
                44.710635
              ],
              [
                80.636005,
                44.73115
              ],
              [
                80.590008,
                44.723743
              ],
              [
                80.482911,
                44.739412
              ],
              [
                80.397324,
                44.771733
              ],
              [
                80.348581,
                44.805175
              ],
              [
                80.311051,
                44.811576
              ],
              [
                80.262766,
                44.843573
              ],
              [
                80.227753,
                44.825088
              ],
              [
                80.187935,
                44.825799
              ],
              [
                80.170085,
                44.844569
              ],
              [
                80.11585,
                44.815275
              ],
              [
                80.087703,
                44.816982
              ],
              [
                79.99937,
                44.793793
              ],
              [
                79.997768,
                44.824093
              ],
              [
                79.953831,
                44.849544
              ],
              [
                79.969163,
                44.877542
              ],
              [
                79.887925,
                44.909218
              ],
              [
                79.944677,
                44.93818
              ],
              [
                80.11196,
                45.052749
              ],
              [
                80.161389,
                45.056007
              ],
              [
                80.195716,
                45.030789
              ],
              [
                80.254756,
                45.035182
              ],
              [
                80.291829,
                45.065921
              ],
              [
                80.328214,
                45.070028
              ],
              [
                80.358192,
                45.040708
              ],
              [
                80.404418,
                45.049491
              ],
              [
                80.444237,
                45.077533
              ],
              [
                80.445838,
                45.097777
              ],
              [
                80.493666,
                45.127068
              ],
              [
                80.519296,
                45.108674
              ],
              [
                80.599162,
                45.105702
              ],
              [
                80.686121,
                45.129049
              ],
              [
                80.73166,
                45.156203
              ],
              [
                80.726626,
                45.176984
              ],
              [
                80.770563,
                45.153092
              ],
              [
                80.816332,
                45.152809
              ],
              [
                80.8621,
                45.127068
              ],
              [
                80.906266,
                45.131171
              ],
              [
                80.965993,
                45.168644
              ],
              [
                81.024577,
                45.162848
              ],
              [
                81.080871,
                45.18292
              ],
              [
                81.111307,
                45.218383
              ],
              [
                81.170119,
                45.210897
              ],
              [
                81.174925,
                45.227845
              ],
              [
                81.236941,
                45.247189
              ],
              [
                81.28454,
                45.239
              ],
              [
                81.32779,
                45.260881
              ],
              [
                81.382254,
                45.257634
              ],
              [
                81.413148,
                45.280918
              ],
              [
                81.449762,
                45.265679
              ],
              [
                81.528484,
                45.285997
              ],
              [
                81.541985,
                45.307154
              ],
              [
                81.575396,
                45.307859
              ],
              [
                81.582719,
                45.33662
              ],
              [
                81.69897,
                45.369028
              ],
              [
                81.73055,
                45.363252
              ],
              [
                81.787989,
                45.383676
              ],
              [
                81.832384,
                45.319845
              ],
              [
                81.879754,
                45.284163
              ],
              [
                81.920717,
                45.233353
              ],
              [
                81.99303,
                45.238153
              ],
              [
                82.052987,
                45.2558
              ],
              [
                82.09578,
                45.24973
              ],
              [
                82.10951,
                45.21132
              ],
              [
                82.161457,
                45.226292
              ],
              [
                82.222786,
                45.148426
              ],
              [
                82.235144,
                45.124239
              ],
              [
                82.295786,
                45.106693
              ],
              [
                82.272902,
                45.091407
              ],
              [
                82.287319,
                45.050624
              ],
              [
                82.275191,
                45.03008
              ],
              [
                82.20036,
                44.984291
              ],
              [
                82.133767,
                45.037165
              ],
              [
                82.058936,
                45.041274
              ],
              [
                81.940397,
                45.010238
              ],
              [
                81.993946,
                44.961169
              ],
              [
                82.045892,
                44.972802
              ],
              [
                82.063971,
                44.933638
              ],
              [
                82.130564,
                44.925121
              ],
              [
                82.145667,
                44.89672
              ]
            ]
          ],
          [
            [
              [
                82.277937,
                44.743827
              ],
              [
                82.271072,
                44.766324
              ],
              [
                82.206996,
                44.821248
              ],
              [
                82.268097,
                44.832625
              ],
              [
                82.312721,
                44.80361
              ],
              [
                82.347047,
                44.799769
              ],
              [
                82.499912,
                44.740836
              ],
              [
                82.542934,
                44.740124
              ],
              [
                82.543163,
                44.709067
              ],
              [
                82.539959,
                44.682271
              ],
              [
                82.447737,
                44.688258
              ],
              [
                82.393959,
                44.669724
              ],
              [
                82.347276,
                44.691252
              ],
              [
                82.358947,
                44.66844
              ],
              [
                82.250934,
                44.691537
              ],
              [
                82.23583,
                44.6817
              ],
              [
                82.239263,
                44.724028
              ],
              [
                82.277937,
                44.743827
              ]
            ]
          ],
          [
            [
              [
                82.130564,
                44.925121
              ],
              [
                82.200589,
                44.91788
              ],
              [
                82.211115,
                44.94329
              ],
              [
                82.20036,
                44.984291
              ],
              [
                82.275191,
                45.03008
              ],
              [
                82.438812,
                45.006977
              ],
              [
                82.454144,
                45.068895
              ],
              [
                82.525771,
                45.08532
              ],
              [
                82.588245,
                45.038582
              ],
              [
                82.656439,
                44.944425
              ],
              [
                82.539502,
                44.902685
              ],
              [
                82.49648,
                44.903395
              ],
              [
                82.49648,
                44.884219
              ],
              [
                82.446364,
                44.883509
              ],
              [
                82.3562,
                44.901833
              ],
              [
                82.278395,
                44.860631
              ],
              [
                82.223244,
                44.889192
              ],
              [
                82.145667,
                44.89672
              ],
              [
                82.130564,
                44.925121
              ]
            ]
          ],
          [
            [
              [
                82.582753,
                45.219089
              ],
              [
                82.683214,
                45.153799
              ],
              [
                82.680696,
                45.138526
              ],
              [
                82.615477,
                45.109099
              ],
              [
                82.588245,
                45.038582
              ],
              [
                82.525771,
                45.08532
              ],
              [
                82.454144,
                45.068895
              ],
              [
                82.295786,
                45.106693
              ],
              [
                82.235144,
                45.124239
              ],
              [
                82.222786,
                45.148426
              ],
              [
                82.161457,
                45.226292
              ],
              [
                82.294413,
                45.247754
              ],
              [
                82.344758,
                45.218948
              ],
              [
                82.486868,
                45.181083
              ],
              [
                82.582753,
                45.219089
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 652800,
        "name": "巴音郭楞蒙古自治州",
        "center": [
          86.150969,
          41.768552
        ],
        "centroid": [
          87.681908,
          39.239339
        ],
        "childrenNum": 9,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 6,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                85.894993,
                41.821856
              ],
              [
                85.876685,
                41.778957
              ],
              [
                85.888585,
                41.763853
              ],
              [
                86.091109,
                41.771181
              ],
              [
                86.099576,
                41.798392
              ],
              [
                86.332765,
                41.818568
              ],
              [
                86.362056,
                41.830522
              ],
              [
                86.404392,
                41.861441
              ],
              [
                86.44238,
                41.834705
              ],
              [
                86.522931,
                41.850091
              ],
              [
                86.521787,
                41.906076
              ],
              [
                86.503251,
                41.922787
              ],
              [
                86.552223,
                41.925473
              ],
              [
                86.595474,
                41.96887
              ],
              [
                86.578082,
                42.031602
              ],
              [
                86.620418,
                42.044707
              ],
              [
                86.620418,
                42.044707
              ],
              [
                86.704631,
                42.103051
              ],
              [
                86.691816,
                42.140826
              ],
              [
                86.735067,
                42.169663
              ],
              [
                86.691129,
                42.208439
              ],
              [
                86.691129,
                42.208439
              ],
              [
                86.675568,
                42.22804
              ],
              [
                86.635063,
                42.2319
              ],
              [
                86.634835,
                42.293186
              ],
              [
                86.616298,
                42.302085
              ],
              [
                86.704631,
                42.363599
              ],
              [
                86.751086,
                42.417948
              ],
              [
                86.842164,
                42.429049
              ],
              [
                86.840333,
                42.450505
              ],
              [
                86.908757,
                42.481567
              ],
              [
                86.936904,
                42.460565
              ],
              [
                86.922258,
                42.43778
              ],
              [
                87.024321,
                42.450061
              ],
              [
                87.039425,
                42.475947
              ],
              [
                87.002353,
                42.500048
              ],
              [
                86.95361,
                42.579236
              ],
              [
                86.959102,
                42.604626
              ],
              [
                87.00281,
                42.625432
              ],
              [
                86.975578,
                42.645493
              ],
              [
                86.978324,
                42.678079
              ],
              [
                87.009218,
                42.678227
              ],
              [
                87.015625,
                42.745409
              ],
              [
                87.083133,
                42.739813
              ],
              [
                87.161626,
                42.745704
              ],
              [
                87.188171,
                42.769995
              ],
              [
                87.225244,
                42.747618
              ],
              [
                87.275588,
                42.77706
              ],
              [
                87.377194,
                42.770437
              ],
              [
                87.400535,
                42.791776
              ],
              [
                87.444473,
                42.783094
              ],
              [
                87.456144,
                42.800015
              ],
              [
                87.509235,
                42.795601
              ],
              [
                87.544019,
                42.777796
              ],
              [
                87.589558,
                42.778826
              ],
              [
                87.691392,
                42.760721
              ],
              [
                87.841054,
                42.768229
              ],
              [
                87.9049,
                42.704018
              ],
              [
                87.913139,
                42.659355
              ],
              [
                87.947922,
                42.635906
              ],
              [
                87.981104,
                42.640478
              ],
              [
                88.031449,
                42.604035
              ],
              [
                88.128935,
                42.572296
              ],
              [
                88.166008,
                42.547927
              ],
              [
                88.202393,
                42.501674
              ],
              [
                88.176534,
                42.439556
              ],
              [
                88.122299,
                42.371302
              ],
              [
                88.003531,
                42.329218
              ],
              [
                87.898264,
                42.248675
              ],
              [
                87.923436,
                42.177985
              ],
              [
                87.997581,
                42.069867
              ],
              [
                88.138775,
                42.004193
              ],
              [
                88.168754,
                41.945013
              ],
              [
                88.19324,
                41.926965
              ],
              [
                88.215437,
                41.871296
              ],
              [
                88.293929,
                41.822752
              ],
              [
                88.341986,
                41.76804
              ],
              [
                88.347936,
                41.67016
              ],
              [
                88.33718,
                41.641246
              ],
              [
                88.347478,
                41.533567
              ],
              [
                88.307889,
                41.513902
              ],
              [
                88.318873,
                41.493179
              ],
              [
                88.406519,
                41.459828
              ],
              [
                88.563275,
                41.477858
              ],
              [
                88.735363,
                41.475003
              ],
              [
                88.835824,
                41.440892
              ],
              [
                88.859624,
                41.42195
              ],
              [
                88.990063,
                41.419394
              ],
              [
                89.017753,
                41.426912
              ],
              [
                89.082057,
                41.409921
              ],
              [
                89.204029,
                41.361178
              ],
              [
                89.282979,
                41.393076
              ],
              [
                89.33607,
                41.389766
              ],
              [
                89.338816,
                41.404807
              ],
              [
                89.399001,
                41.396385
              ],
              [
                89.45644,
                41.375022
              ],
              [
                89.460788,
                41.359824
              ],
              [
                89.558045,
                41.3678
              ],
              [
                89.616629,
                41.355158
              ],
              [
                89.698096,
                41.366596
              ],
              [
                89.743635,
                41.344622
              ],
              [
                89.785742,
                41.34974
              ],
              [
                89.834256,
                41.377129
              ],
              [
                89.960347,
                41.357416
              ],
              [
                90.108636,
                41.252883
              ],
              [
                90.315279,
                41.24248
              ],
              [
                90.399721,
                41.234187
              ],
              [
                90.54023,
                41.250018
              ],
              [
                90.65465,
                41.237052
              ],
              [
                90.69996,
                41.239314
              ],
              [
                90.780512,
                41.225743
              ],
              [
                90.905917,
                41.227552
              ],
              [
                90.966331,
                41.245797
              ],
              [
                91.092651,
                41.251375
              ],
              [
                91.194485,
                41.226497
              ],
              [
                91.446667,
                41.197687
              ],
              [
                91.641182,
                41.226949
              ],
              [
                91.765214,
                41.267202
              ],
              [
                91.840273,
                41.281066
              ],
              [
                91.910299,
                41.271422
              ],
              [
                92.023346,
                41.272476
              ],
              [
                92.070029,
                41.264187
              ],
              [
                92.177356,
                41.222727
              ],
              [
                92.373243,
                41.165543
              ],
              [
                92.505513,
                41.142897
              ],
              [
                92.535949,
                41.120847
              ],
              [
                92.66204,
                41.115258
              ],
              [
                92.742821,
                41.125228
              ],
              [
                92.863191,
                41.112992
              ],
              [
                92.99569,
                41.079749
              ],
              [
                93.062054,
                41.048757
              ],
              [
                93.102101,
                41.041045
              ],
              [
                93.200731,
                40.990968
              ],
              [
                93.261374,
                40.986276
              ],
              [
                93.348333,
                40.993995
              ],
              [
                93.556807,
                40.957511
              ],
              [
                93.696629,
                40.875388
              ],
              [
                93.809905,
                40.87933
              ],
              [
                93.821118,
                40.79377
              ],
              [
                93.760704,
                40.664919
              ],
              [
                93.506462,
                40.648491
              ],
              [
                92.928411,
                40.572686
              ],
              [
                92.92063,
                40.39181
              ],
              [
                92.9069,
                40.310669
              ],
              [
                92.796599,
                40.153919
              ],
              [
                92.745567,
                39.868271
              ],
              [
                92.68767,
                39.657418
              ],
              [
                92.639843,
                39.514326
              ],
              [
                92.525422,
                39.368613
              ],
              [
                92.38171,
                39.260176
              ],
              [
                92.340061,
                39.238127
              ],
              [
                92.344409,
                39.144107
              ],
              [
                92.366149,
                39.096039
              ],
              [
                92.351275,
                39.0839
              ],
              [
                92.389262,
                39.059616
              ],
              [
                92.418325,
                39.013048
              ],
              [
                92.380109,
                38.999959
              ],
              [
                92.256763,
                39.000739
              ],
              [
                92.193375,
                38.981725
              ],
              [
                92.171177,
                38.960524
              ],
              [
                91.990393,
                38.938693
              ],
              [
                91.878948,
                38.897664
              ],
              [
                91.878719,
                38.882681
              ],
              [
                91.777113,
                38.862544
              ],
              [
                91.692442,
                38.86551
              ],
              [
                91.613263,
                38.838964
              ],
              [
                91.50136,
                38.815377
              ],
              [
                91.446439,
                38.813502
              ],
              [
                91.301582,
                38.747697
              ],
              [
                91.250093,
                38.752857
              ],
              [
                91.188764,
                38.731118
              ],
              [
                90.992876,
                38.694977
              ],
              [
                90.965416,
                38.696855
              ],
              [
                90.831086,
                38.668055
              ],
              [
                90.728108,
                38.657565
              ],
              [
                90.653048,
                38.674317
              ],
              [
                90.619637,
                38.664454
              ],
              [
                90.643208,
                38.640809
              ],
              [
                90.535653,
                38.567947
              ],
              [
                90.463568,
                38.556658
              ],
              [
                90.463568,
                38.520115
              ],
              [
                90.426953,
                38.493912
              ],
              [
                90.355784,
                38.481513
              ],
              [
                90.315279,
                38.501915
              ],
              [
                90.251433,
                38.491401
              ],
              [
                90.130834,
                38.494226
              ],
              [
                90.110696,
                38.473036
              ],
              [
                90.11184,
                38.419015
              ],
              [
                90.128316,
                38.400161
              ],
              [
                90.179119,
                38.397018
              ],
              [
                90.137699,
                38.340581
              ],
              [
                90.280724,
                38.238127
              ],
              [
                90.352809,
                38.23356
              ],
              [
                90.361734,
                38.300152
              ],
              [
                90.402239,
                38.311323
              ],
              [
                90.530847,
                38.319819
              ],
              [
                90.51643,
                38.207253
              ],
              [
                90.519634,
                37.730829
              ],
              [
                90.579361,
                37.72052
              ],
              [
                90.586684,
                37.703072
              ],
              [
                90.644123,
                37.697202
              ],
              [
                90.776164,
                37.650543
              ],
              [
                90.882575,
                37.575732
              ],
              [
                90.86587,
                37.530586
              ],
              [
                90.911638,
                37.519614
              ],
              [
                90.940701,
                37.480481
              ],
              [
                91.000428,
                37.494482
              ],
              [
                91.056952,
                37.483823
              ],
              [
                91.097457,
                37.450402
              ],
              [
                91.110043,
                37.398332
              ],
              [
                91.137046,
                37.353079
              ],
              [
                91.134758,
                37.324224
              ],
              [
                91.194485,
                37.273662
              ],
              [
                91.191052,
                37.20582
              ],
              [
                91.2803,
                37.163807
              ],
              [
                91.287623,
                37.103542
              ],
              [
                91.303184,
                37.08515
              ],
              [
                91.29014,
                37.047391
              ],
              [
                91.305702,
                37.012815
              ],
              [
                91.214623,
                37.010414
              ],
              [
                91.190824,
                37.024662
              ],
              [
                91.133613,
                37.007692
              ],
              [
                91.113018,
                36.970535
              ],
              [
                91.051688,
                36.967331
              ],
              [
                91.037043,
                36.929514
              ],
              [
                90.983723,
                36.913644
              ],
              [
                90.87365,
                36.920537
              ],
              [
                90.813694,
                36.881895
              ],
              [
                90.789208,
                36.845639
              ],
              [
                90.7336,
                36.827345
              ],
              [
                90.727192,
                36.756051
              ],
              [
                90.755111,
                36.721182
              ],
              [
                90.722158,
                36.710092
              ],
              [
                90.706139,
                36.661049
              ],
              [
                90.735431,
                36.633379
              ],
              [
                90.740923,
                36.585898
              ],
              [
                90.813008,
                36.585576
              ],
              [
                90.832917,
                36.558039
              ],
              [
                90.906832,
                36.559489
              ],
              [
                91.035898,
                36.530009
              ],
              [
                91.028347,
                36.443279
              ],
              [
                91.052604,
                36.426502
              ],
              [
                91.026516,
                36.323664
              ],
              [
                91.074115,
                36.29765
              ],
              [
                91.053977,
                36.235408
              ],
              [
                91.098601,
                36.216807
              ],
              [
                91.091507,
                36.161301
              ],
              [
                91.124689,
                36.115474
              ],
              [
                91.092422,
                36.088743
              ],
              [
                90.994936,
                36.107861
              ],
              [
                90.9645,
                36.095224
              ],
              [
                90.922622,
                36.02893
              ],
              [
                90.846876,
                36.016929
              ],
              [
                90.815983,
                36.03574
              ],
              [
                90.776393,
                36.086312
              ],
              [
                90.662888,
                36.133937
              ],
              [
                90.615518,
                36.126488
              ],
              [
                90.526957,
                36.148511
              ],
              [
                90.479587,
                36.132318
              ],
              [
                90.423978,
                36.133937
              ],
              [
                90.330383,
                36.157091
              ],
              [
                90.253492,
                36.157415
              ],
              [
                90.12763,
                36.215028
              ],
              [
                90.145708,
                36.238966
              ],
              [
                90.028084,
                36.258371
              ],
              [
                90.00909,
                36.184285
              ],
              [
                89.937234,
                36.130051
              ],
              [
                89.941353,
                36.067514
              ],
              [
                89.912748,
                36.079344
              ],
              [
                89.819153,
                36.080803
              ],
              [
                89.761714,
                36.073186
              ],
              [
                89.707936,
                36.09733
              ],
              [
                89.615027,
                36.109643
              ],
              [
                89.594431,
                36.126326
              ],
              [
                89.490309,
                36.151101
              ],
              [
                89.375431,
                36.22813
              ],
              [
                89.29854,
                36.228615
              ],
              [
                89.232176,
                36.295711
              ],
              [
                89.198994,
                36.260311
              ],
              [
                89.128054,
                36.249639
              ],
              [
                89.102652,
                36.280195
              ],
              [
                89.013405,
                36.315424
              ],
              [
                88.948871,
                36.329318
              ],
              [
                88.925987,
                36.364363
              ],
              [
                88.801727,
                36.337232
              ],
              [
                88.783191,
                36.291832
              ],
              [
                88.725065,
                36.319625
              ],
              [
                88.690053,
                36.368077
              ],
              [
                88.623689,
                36.389386
              ],
              [
                88.617968,
                36.427954
              ],
              [
                88.573115,
                36.461181
              ],
              [
                88.498742,
                36.446182
              ],
              [
                88.470594,
                36.482303
              ],
              [
                88.410867,
                36.473275
              ],
              [
                88.378829,
                36.483271
              ],
              [
                88.365557,
                36.457794
              ],
              [
                88.241525,
                36.468599
              ],
              [
                88.22276,
                36.447634
              ],
              [
                88.182484,
                36.452634
              ],
              [
                88.134656,
                36.427147
              ],
              [
                88.092321,
                36.435375
              ],
              [
                87.982935,
                36.437794
              ],
              [
                87.958449,
                36.40843
              ],
              [
                87.919546,
                36.393582
              ],
              [
                87.768511,
                36.374696
              ],
              [
                87.731897,
                36.384866
              ],
              [
                87.619994,
                36.360326
              ],
              [
                87.570564,
                36.342401
              ],
              [
                87.470332,
                36.354352
              ],
              [
                87.460263,
                36.409882
              ],
              [
                87.424106,
                36.425856
              ],
              [
                87.361861,
                36.41908
              ],
              [
                87.348131,
                36.393098
              ],
              [
                87.292294,
                36.359035
              ],
              [
                87.193435,
                36.349345
              ],
              [
                87.149497,
                36.297488
              ],
              [
                87.086337,
                36.310739
              ],
              [
                87.056588,
                36.297165
              ],
              [
                86.996174,
                36.308638
              ],
              [
                86.931641,
                36.265485
              ],
              [
                86.887246,
                36.262898
              ],
              [
                86.862989,
                36.299912
              ],
              [
                86.836214,
                36.291347
              ],
              [
                86.746051,
                36.291994
              ],
              [
                86.700054,
                36.244788
              ],
              [
                86.599364,
                36.222307
              ],
              [
                86.532085,
                36.227321
              ],
              [
                86.515609,
                36.205321
              ],
              [
                86.455195,
                36.221175
              ],
              [
                86.39295,
                36.206939
              ],
              [
                86.358166,
                36.168747
              ],
              [
                86.280132,
                36.170851
              ],
              [
                86.247178,
                36.1409
              ],
              [
                86.190197,
                36.13248
              ],
              [
                86.179899,
                36.075941
              ],
              [
                86.200037,
                36.0479
              ],
              [
                86.173263,
                36.008009
              ],
              [
                86.132758,
                35.979456
              ],
              [
                86.126122,
                35.931738
              ],
              [
                86.059987,
                35.845805
              ],
              [
                86.031611,
                35.844179
              ],
              [
                85.948999,
                35.778813
              ],
              [
                85.903917,
                35.784343
              ],
              [
                85.835494,
                35.772306
              ],
              [
                85.803228,
                35.778325
              ],
              [
                85.653337,
                35.731299
              ],
              [
                85.613747,
                35.652317
              ],
              [
                85.566149,
                35.640423
              ],
              [
                85.519694,
                35.679196
              ],
              [
                85.374151,
                35.700367
              ],
              [
                85.341198,
                35.753432
              ],
              [
                85.271173,
                35.788735
              ],
              [
                85.15927,
                35.745458
              ],
              [
                85.053088,
                35.751968
              ],
              [
                84.986266,
                35.725113
              ],
              [
                84.917614,
                35.77442
              ],
              [
                84.914182,
                35.854418
              ],
              [
                84.861319,
                35.945212
              ],
              [
                84.873677,
                35.984486
              ],
              [
                84.84347,
                36.09895
              ],
              [
                84.775046,
                36.102353
              ],
              [
                84.681222,
                36.142844
              ],
              [
                84.673441,
                36.182828
              ],
              [
                84.637284,
                36.192214
              ],
              [
                84.618519,
                36.220042
              ],
              [
                84.570463,
                36.225704
              ],
              [
                84.537739,
                36.269364
              ],
              [
                84.416682,
                36.276639
              ],
              [
                84.410274,
                36.309931
              ],
              [
                84.363362,
                36.311223
              ],
              [
                84.346885,
                36.364524
              ],
              [
                84.35581,
                36.397779
              ],
              [
                84.308211,
                36.42263
              ],
              [
                84.322857,
                36.478757
              ],
              [
                84.341851,
                36.490525
              ],
              [
                84.346428,
                36.545636
              ],
              [
                84.302719,
                36.611171
              ],
              [
                84.251917,
                36.643837
              ],
              [
                84.201114,
                36.660728
              ],
              [
                84.167932,
                36.69482
              ],
              [
                84.084634,
                36.69498
              ],
              [
                84.013693,
                36.739502
              ],
              [
                83.991038,
                36.76858
              ],
              [
                83.914148,
                36.766974
              ],
              [
                83.833138,
                36.83232
              ],
              [
                83.858311,
                36.867459
              ],
              [
                83.82101,
                36.963326
              ],
              [
                83.860828,
                37.070112
              ],
              [
                83.855336,
                37.117773
              ],
              [
                83.79126,
                37.250203
              ],
              [
                83.862201,
                37.291211
              ],
              [
                83.894467,
                37.349732
              ],
              [
                83.975706,
                37.410437
              ],
              [
                83.974104,
                37.481913
              ],
              [
                83.987377,
                37.514525
              ],
              [
                83.989894,
                37.612273
              ],
              [
                83.963577,
                37.6534
              ],
              [
                83.932455,
                37.78552
              ],
              [
                83.938405,
                37.832252
              ],
              [
                83.885543,
                37.947294
              ],
              [
                83.819179,
                38.048104
              ],
              [
                83.747781,
                38.115339
              ],
              [
                83.648921,
                38.187713
              ],
              [
                83.502692,
                38.281581
              ],
              [
                83.38667,
                38.388217
              ],
              [
                83.387814,
                38.98344
              ],
              [
                83.395137,
                39.321629
              ],
              [
                83.414817,
                39.483227
              ],
              [
                83.951906,
                39.956396
              ],
              [
                84.009574,
                40.037654
              ],
              [
                84.012092,
                40.113142
              ],
              [
                84.060377,
                40.677846
              ],
              [
                84.067471,
                40.77707
              ],
              [
                84.073192,
                40.924038
              ],
              [
                84.058775,
                41.082318
              ],
              [
                84.08738,
                41.120847
              ],
              [
                84.034518,
                41.168864
              ],
              [
                84.022847,
                41.233434
              ],
              [
                84.029255,
                41.348536
              ],
              [
                84.015295,
                41.445401
              ],
              [
                83.975706,
                41.505944
              ],
              [
                83.94733,
                41.528314
              ],
              [
                83.953051,
                41.558778
              ],
              [
                83.918267,
                41.56883
              ],
              [
                83.900646,
                41.597626
              ],
              [
                83.906596,
                41.685885
              ],
              [
                83.929709,
                41.774919
              ],
              [
                83.964264,
                41.809004
              ],
              [
                83.96701,
                41.873984
              ],
              [
                83.987606,
                41.93323
              ],
              [
                83.980054,
                41.985863
              ],
              [
                83.938405,
                42.074332
              ],
              [
                83.924674,
                42.14603
              ],
              [
                83.880737,
                42.186454
              ],
              [
                83.880279,
                42.261735
              ],
              [
                83.948016,
                42.268857
              ],
              [
                83.974104,
                42.294521
              ],
              [
                83.96312,
                42.356783
              ],
              [
                83.932455,
                42.373821
              ],
              [
                83.938405,
                42.415727
              ],
              [
                83.932226,
                42.500196
              ],
              [
                83.947101,
                42.531972
              ],
              [
                84.002938,
                42.501231
              ],
              [
                84.056029,
                42.502118
              ],
              [
                84.121477,
                42.484524
              ],
              [
                84.154202,
                42.457162
              ],
              [
                84.232007,
                42.424905
              ],
              [
                84.324688,
                42.443403
              ],
              [
                84.429497,
                42.443699
              ],
              [
                84.495632,
                42.432897
              ],
              [
                84.601585,
                42.389224
              ],
              [
                84.75857,
                42.35945
              ],
              [
                84.773673,
                42.30772
              ],
              [
                84.835231,
                42.329662
              ],
              [
                84.844614,
                42.358561
              ],
              [
                84.899536,
                42.356783
              ],
              [
                85.020821,
                42.296746
              ],
              [
                85.110984,
                42.301047
              ],
              [
                85.155608,
                42.278946
              ],
              [
                85.265223,
                42.283545
              ],
              [
                85.263621,
                42.211261
              ],
              [
                85.293142,
                42.21527
              ],
              [
                85.335706,
                42.177242
              ],
              [
                85.340969,
                42.109447
              ],
              [
                85.26385,
                42.034581
              ],
              [
                85.262477,
                41.971106
              ],
              [
                85.408706,
                41.94203
              ],
              [
                85.437311,
                41.932036
              ],
              [
                85.512142,
                41.914581
              ],
              [
                85.498412,
                41.866369
              ],
              [
                85.367973,
                41.826488
              ],
              [
                85.357675,
                41.747399
              ],
              [
                85.491089,
                41.754579
              ],
              [
                85.526101,
                41.740218
              ],
              [
                85.705513,
                41.745903
              ],
              [
                85.703682,
                41.684237
              ],
              [
                85.726795,
                41.661472
              ],
              [
                85.785836,
                41.664468
              ],
              [
                85.773021,
                41.72705
              ],
              [
                85.73961,
                41.756374
              ],
              [
                85.792701,
                41.82589
              ],
              [
                85.894993,
                41.821856
              ]
            ]
          ],
          [
            [
              [
                82.638132,
                42.597689
              ],
              [
                82.621198,
                42.621005
              ],
              [
                82.634242,
                42.651982
              ],
              [
                82.599229,
                42.719635
              ],
              [
                82.507006,
                42.799427
              ],
              [
                82.480003,
                42.800603
              ],
              [
                82.470392,
                42.843253
              ],
              [
                82.512727,
                42.858541
              ],
              [
                82.532637,
                42.901739
              ],
              [
                82.576803,
                42.88558
              ],
              [
                82.649345,
                42.88367
              ],
              [
                82.653236,
                42.934337
              ],
              [
                82.712505,
                42.951657
              ],
              [
                82.789396,
                42.933897
              ],
              [
                82.82418,
                42.954886
              ],
              [
                82.82418,
                42.980269
              ],
              [
                82.858963,
                42.971026
              ],
              [
                82.892603,
                42.992296
              ],
              [
                82.941575,
                42.987309
              ],
              [
                83.013889,
                43.007107
              ],
              [
                83.037688,
                42.996402
              ],
              [
                83.135632,
                42.992149
              ],
              [
                83.159889,
                43.006374
              ],
              [
                83.2663,
                43.017957
              ],
              [
                83.325112,
                43.047416
              ],
              [
                83.361726,
                43.028218
              ],
              [
                83.407037,
                43.052105
              ],
              [
                83.504752,
                43.058845
              ],
              [
                83.565852,
                43.07569
              ],
              [
                83.56631,
                43.092385
              ],
              [
                83.627639,
                43.08067
              ],
              [
                83.679815,
                43.09751
              ],
              [
                83.713226,
                43.137467
              ],
              [
                83.758078,
                43.149317
              ],
              [
                83.801558,
                43.133516
              ],
              [
                83.912546,
                43.128102
              ],
              [
                83.96312,
                43.156192
              ],
              [
                84.043214,
                43.132199
              ],
              [
                84.038866,
                43.146245
              ],
              [
                84.104314,
                43.145514
              ],
              [
                84.22949,
                43.171256
              ],
              [
                84.279149,
                43.174912
              ],
              [
                84.363133,
                43.15941
              ],
              [
                84.359014,
                43.144197
              ],
              [
                84.413707,
                43.102341
              ],
              [
                84.423318,
                43.16175
              ],
              [
                84.504328,
                43.164383
              ],
              [
                84.540714,
                43.152974
              ],
              [
                84.574124,
                43.168332
              ],
              [
                84.653761,
                43.175351
              ],
              [
                84.602501,
                43.228553
              ],
              [
                84.564742,
                43.231037
              ],
              [
                84.581447,
                43.266965
              ],
              [
                84.538425,
                43.262877
              ],
              [
                84.532246,
                43.292802
              ],
              [
                84.552842,
                43.331757
              ],
              [
                84.623554,
                43.338028
              ],
              [
                84.676187,
                43.37229
              ],
              [
                84.692893,
                43.40187
              ],
              [
                84.633165,
                43.432747
              ],
              [
                84.661541,
                43.491253
              ],
              [
                84.716005,
                43.453128
              ],
              [
                84.786717,
                43.465936
              ],
              [
                84.834316,
                43.43595
              ],
              [
                84.92425,
                43.425175
              ],
              [
                84.950567,
                43.48427
              ],
              [
                84.979859,
                43.47976
              ],
              [
                85.020364,
                43.51365
              ],
              [
                85.056292,
                43.563942
              ],
              [
                85.156981,
                43.546795
              ],
              [
                85.170483,
                43.510742
              ],
              [
                85.241881,
                43.52092
              ],
              [
                85.286734,
                43.502307
              ],
              [
                85.31511,
                43.529207
              ],
              [
                85.328154,
                43.486743
              ],
              [
                85.434108,
                43.478887
              ],
              [
                85.483537,
                43.498235
              ],
              [
                85.519694,
                43.536185
              ],
              [
                85.5975,
                43.530806
              ],
              [
                85.651277,
                43.522956
              ],
              [
                85.690638,
                43.484124
              ],
              [
                85.720845,
                43.484415
              ],
              [
                85.787209,
                43.450363
              ],
              [
                85.842588,
                43.437697
              ],
              [
                85.863413,
                43.445996
              ],
              [
                85.929776,
                43.430417
              ],
              [
                85.989046,
                43.403036
              ],
              [
                86.090423,
                43.431728
              ],
              [
                86.121545,
                43.371561
              ],
              [
                86.153354,
                43.359754
              ],
              [
                86.166169,
                43.306811
              ],
              [
                86.243746,
                43.288278
              ],
              [
                86.293175,
                43.24433
              ],
              [
                86.380364,
                43.226508
              ],
              [
                86.486317,
                43.142149
              ],
              [
                86.61607,
                43.114198
              ],
              [
                86.64559,
                43.09707
              ],
              [
                86.692731,
                43.118589
              ],
              [
                86.741245,
                43.099559
              ],
              [
                86.797998,
                43.112442
              ],
              [
                86.853835,
                43.083452
              ],
              [
                86.912189,
                43.074665
              ],
              [
                86.926378,
                43.051519
              ],
              [
                87.054528,
                43.022941
              ],
              [
                87.111052,
                43.046684
              ],
              [
                87.111281,
                43.063093
              ],
              [
                87.270096,
                43.032322
              ],
              [
                87.345156,
                42.999775
              ],
              [
                87.403053,
                42.96369
              ],
              [
                87.497106,
                42.940062
              ],
              [
                87.538069,
                42.908201
              ],
              [
                87.52594,
                42.865155
              ],
              [
                87.543103,
                42.8459
              ],
              [
                87.509235,
                42.795601
              ],
              [
                87.456144,
                42.800015
              ],
              [
                87.444473,
                42.783094
              ],
              [
                87.400535,
                42.791776
              ],
              [
                87.377194,
                42.770437
              ],
              [
                87.275588,
                42.77706
              ],
              [
                87.225244,
                42.747618
              ],
              [
                87.188171,
                42.769995
              ],
              [
                87.161626,
                42.745704
              ],
              [
                87.083133,
                42.739813
              ],
              [
                87.015625,
                42.745409
              ],
              [
                87.009218,
                42.678227
              ],
              [
                86.978324,
                42.678079
              ],
              [
                86.975578,
                42.645493
              ],
              [
                87.00281,
                42.625432
              ],
              [
                86.959102,
                42.604626
              ],
              [
                86.95361,
                42.579236
              ],
              [
                87.002353,
                42.500048
              ],
              [
                87.039425,
                42.475947
              ],
              [
                87.024321,
                42.450061
              ],
              [
                86.922258,
                42.43778
              ],
              [
                86.936904,
                42.460565
              ],
              [
                86.908757,
                42.481567
              ],
              [
                86.840333,
                42.450505
              ],
              [
                86.842164,
                42.429049
              ],
              [
                86.751086,
                42.417948
              ],
              [
                86.704631,
                42.363599
              ],
              [
                86.616298,
                42.302085
              ],
              [
                86.634835,
                42.293186
              ],
              [
                86.635063,
                42.2319
              ],
              [
                86.675568,
                42.22804
              ],
              [
                86.691129,
                42.208439
              ],
              [
                86.691129,
                42.208439
              ],
              [
                86.735067,
                42.169663
              ],
              [
                86.691816,
                42.140826
              ],
              [
                86.704631,
                42.103051
              ],
              [
                86.620418,
                42.044707
              ],
              [
                86.620418,
                42.044707
              ],
              [
                86.578082,
                42.031602
              ],
              [
                86.595474,
                41.96887
              ],
              [
                86.552223,
                41.925473
              ],
              [
                86.503251,
                41.922787
              ],
              [
                86.521787,
                41.906076
              ],
              [
                86.522931,
                41.850091
              ],
              [
                86.44238,
                41.834705
              ],
              [
                86.404392,
                41.861441
              ],
              [
                86.362056,
                41.830522
              ],
              [
                86.224294,
                41.908016
              ],
              [
                86.113993,
                41.898465
              ],
              [
                86.100949,
                41.918908
              ],
              [
                86.017422,
                41.964994
              ],
              [
                86.000488,
                42.018942
              ],
              [
                85.858378,
                42.014622
              ],
              [
                85.751738,
                42.037262
              ],
              [
                85.760663,
                42.069718
              ],
              [
                85.720616,
                42.083262
              ],
              [
                85.638233,
                42.133987
              ],
              [
                85.487427,
                42.197002
              ],
              [
                85.443948,
                41.93845
              ],
              [
                85.408706,
                41.94203
              ],
              [
                85.262477,
                41.971106
              ],
              [
                85.26385,
                42.034581
              ],
              [
                85.340969,
                42.109447
              ],
              [
                85.335706,
                42.177242
              ],
              [
                85.293142,
                42.21527
              ],
              [
                85.263621,
                42.211261
              ],
              [
                85.265223,
                42.283545
              ],
              [
                85.155608,
                42.278946
              ],
              [
                85.110984,
                42.301047
              ],
              [
                85.020821,
                42.296746
              ],
              [
                84.899536,
                42.356783
              ],
              [
                84.844614,
                42.358561
              ],
              [
                84.835231,
                42.329662
              ],
              [
                84.773673,
                42.30772
              ],
              [
                84.75857,
                42.35945
              ],
              [
                84.601585,
                42.389224
              ],
              [
                84.495632,
                42.432897
              ],
              [
                84.429497,
                42.443699
              ],
              [
                84.324688,
                42.443403
              ],
              [
                84.232007,
                42.424905
              ],
              [
                84.154202,
                42.457162
              ],
              [
                84.121477,
                42.484524
              ],
              [
                84.056029,
                42.502118
              ],
              [
                84.002938,
                42.501231
              ],
              [
                83.947101,
                42.531972
              ],
              [
                83.913461,
                42.523992
              ],
              [
                83.713912,
                42.540689
              ],
              [
                83.692401,
                42.513943
              ],
              [
                83.64526,
                42.514978
              ],
              [
                83.487589,
                42.469883
              ],
              [
                83.435642,
                42.491178
              ],
              [
                83.350742,
                42.508326
              ],
              [
                83.353717,
                42.539064
              ],
              [
                83.320993,
                42.569195
              ],
              [
                83.29399,
                42.555018
              ],
              [
                83.227855,
                42.583665
              ],
              [
                83.078422,
                42.553688
              ],
              [
                83.017092,
                42.587799
              ],
              [
                82.992606,
                42.620858
              ],
              [
                82.958738,
                42.630448
              ],
              [
                82.924412,
                42.593556
              ],
              [
                82.841571,
                42.568014
              ],
              [
                82.81617,
                42.579088
              ],
              [
                82.842029,
                42.613628
              ],
              [
                82.826468,
                42.645198
              ],
              [
                82.753468,
                42.624989
              ],
              [
                82.722345,
                42.595918
              ],
              [
                82.638132,
                42.597689
              ]
            ]
          ],
          [
            [
              [
                85.792701,
                41.82589
              ],
              [
                85.754484,
                41.852779
              ],
              [
                85.512142,
                41.914581
              ],
              [
                85.437311,
                41.932036
              ],
              [
                85.443948,
                41.93845
              ],
              [
                85.487427,
                42.197002
              ],
              [
                85.638233,
                42.133987
              ],
              [
                85.720616,
                42.083262
              ],
              [
                85.760663,
                42.069718
              ],
              [
                85.751738,
                42.037262
              ],
              [
                85.858378,
                42.014622
              ],
              [
                86.000488,
                42.018942
              ],
              [
                86.017422,
                41.964994
              ],
              [
                86.100949,
                41.918908
              ],
              [
                86.113993,
                41.898465
              ],
              [
                86.224294,
                41.908016
              ],
              [
                86.362056,
                41.830522
              ],
              [
                86.332765,
                41.818568
              ],
              [
                86.099576,
                41.798392
              ],
              [
                85.894993,
                41.821856
              ],
              [
                85.792701,
                41.82589
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 652900,
        "name": "阿克苏地区",
        "center": [
          80.265068,
          41.170712
        ],
        "centroid": [
          81.177098,
          41.477458
        ],
        "childrenNum": 9,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 7,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                78.36499,
                40.009709
              ],
              [
                78.313272,
                40.066049
              ],
              [
                78.241187,
                40.060831
              ],
              [
                78.161322,
                40.071573
              ],
              [
                78.09267,
                40.060831
              ],
              [
                78.03134,
                40.093818
              ],
              [
                78.055369,
                40.140892
              ],
              [
                78.055826,
                40.202483
              ],
              [
                78.082143,
                40.231574
              ],
              [
                78.091068,
                40.274882
              ],
              [
                78.124707,
                40.287119
              ],
              [
                78.15583,
                40.331155
              ],
              [
                78.158576,
                40.387228
              ],
              [
                78.205259,
                40.420362
              ],
              [
                78.303661,
                40.455462
              ],
              [
                78.373915,
                40.494966
              ],
              [
                78.47163,
                40.52637
              ],
              [
                78.523577,
                40.552579
              ],
              [
                78.585593,
                40.637841
              ],
              [
                78.605044,
                40.696699
              ],
              [
                78.574151,
                40.700195
              ],
              [
                78.570489,
                40.766137
              ],
              [
                78.725643,
                40.822909
              ],
              [
                78.748298,
                40.81866
              ],
              [
                78.79727,
                40.861286
              ],
              [
                78.861803,
                40.891609
              ],
              [
                78.848531,
                40.915553
              ],
              [
                78.875534,
                40.985216
              ],
              [
                78.826333,
                40.994751
              ],
              [
                78.762486,
                41.086097
              ],
              [
                78.733881,
                41.161467
              ],
              [
                78.711913,
                41.185616
              ],
              [
                78.565912,
                41.288147
              ],
              [
                78.5071,
                41.310442
              ],
              [
                78.391765,
                41.408266
              ],
              [
                78.454696,
                41.412327
              ],
              [
                78.533875,
                41.445551
              ],
              [
                78.580558,
                41.481613
              ],
              [
                78.650583,
                41.467341
              ],
              [
                78.705734,
                41.519307
              ],
              [
                78.696809,
                41.541672
              ],
              [
                78.738916,
                41.555628
              ],
              [
                78.825189,
                41.560279
              ],
              [
                78.891553,
                41.597776
              ],
              [
                78.957688,
                41.651585
              ],
              [
                79.021534,
                41.657278
              ],
              [
                79.043274,
                41.681242
              ],
              [
                79.114901,
                41.699959
              ],
              [
                79.138014,
                41.72301
              ],
              [
                79.219024,
                41.726452
              ],
              [
                79.27692,
                41.78105
              ],
              [
                79.325892,
                41.809452
              ],
              [
                79.356557,
                41.795701
              ],
              [
                79.407131,
                41.833062
              ],
              [
                79.457018,
                41.847851
              ],
              [
                79.551071,
                41.833958
              ],
              [
                79.604849,
                41.849045
              ],
              [
                79.641006,
                41.884733
              ],
              [
                79.724761,
                41.896823
              ],
              [
                79.776708,
                41.892495
              ],
              [
                79.822705,
                41.963354
              ],
              [
                79.854285,
                41.984224
              ],
              [
                79.852683,
                42.015367
              ],
              [
                79.923624,
                42.042325
              ],
              [
                80.089762,
                42.047536
              ],
              [
                80.142167,
                42.03473
              ],
              [
                80.193427,
                42.081476
              ],
              [
                80.168026,
                42.096802
              ],
              [
                80.13965,
                42.151233
              ],
              [
                80.163678,
                42.152422
              ],
              [
                80.168712,
                42.20027
              ],
              [
                80.233245,
                42.210221
              ],
              [
                80.286565,
                42.233088
              ],
              [
                80.27192,
                42.282061
              ],
              [
                80.284048,
                42.32062
              ],
              [
                80.324324,
                42.315134
              ],
              [
                80.372381,
                42.326698
              ],
              [
                80.415403,
                42.304754
              ],
              [
                80.471469,
                42.321806
              ],
              [
                80.531883,
                42.360932
              ],
              [
                80.592296,
                42.366117
              ],
              [
                80.62914,
                42.353375
              ],
              [
                80.657287,
                42.366117
              ],
              [
                80.761639,
                42.361525
              ],
              [
                80.803974,
                42.339742
              ],
              [
                80.898028,
                42.369228
              ],
              [
                80.963018,
                42.361673
              ],
              [
                80.985216,
                42.380634
              ],
              [
                81.025263,
                42.342854
              ],
              [
                81.048147,
                42.284732
              ],
              [
                81.098263,
                42.291703
              ],
              [
                81.160508,
                42.259954
              ],
              [
                81.152498,
                42.323585
              ],
              [
                81.195521,
                42.343595
              ],
              [
                81.271267,
                42.343595
              ],
              [
                81.285455,
                42.332479
              ],
              [
                81.318637,
                42.357821
              ],
              [
                81.352734,
                42.332331
              ],
              [
                81.386602,
                42.354413
              ],
              [
                81.478825,
                42.360636
              ],
              [
                81.50949,
                42.352042
              ],
              [
                81.582032,
                42.374117
              ],
              [
                81.630775,
                42.373821
              ],
              [
                81.66144,
                42.392186
              ],
              [
                81.672196,
                42.369969
              ],
              [
                81.751832,
                42.365525
              ],
              [
                81.805152,
                42.405957
              ],
              [
                81.820256,
                42.3833
              ],
              [
                81.865795,
                42.384041
              ],
              [
                81.867397,
                42.411138
              ],
              [
                81.959848,
                42.402255
              ],
              [
                81.984563,
                42.425793
              ],
              [
                82.065344,
                42.420316
              ],
              [
                82.07793,
                42.43852
              ],
              [
                82.133538,
                42.440444
              ],
              [
                82.142692,
                42.489256
              ],
              [
                82.189147,
                42.467221
              ],
              [
                82.230109,
                42.494578
              ],
              [
                82.295329,
                42.48275
              ],
              [
                82.366498,
                42.50404
              ],
              [
                82.363752,
                42.538768
              ],
              [
                82.407232,
                42.55162
              ],
              [
                82.585499,
                42.543939
              ],
              [
                82.62074,
                42.558562
              ],
              [
                82.638132,
                42.597689
              ],
              [
                82.722345,
                42.595918
              ],
              [
                82.753468,
                42.624989
              ],
              [
                82.826468,
                42.645198
              ],
              [
                82.842029,
                42.613628
              ],
              [
                82.81617,
                42.579088
              ],
              [
                82.841571,
                42.568014
              ],
              [
                82.924412,
                42.593556
              ],
              [
                82.958738,
                42.630448
              ],
              [
                82.992606,
                42.620858
              ],
              [
                83.017092,
                42.587799
              ],
              [
                83.078422,
                42.553688
              ],
              [
                83.227855,
                42.583665
              ],
              [
                83.29399,
                42.555018
              ],
              [
                83.320993,
                42.569195
              ],
              [
                83.353717,
                42.539064
              ],
              [
                83.350742,
                42.508326
              ],
              [
                83.435642,
                42.491178
              ],
              [
                83.487589,
                42.469883
              ],
              [
                83.64526,
                42.514978
              ],
              [
                83.692401,
                42.513943
              ],
              [
                83.713912,
                42.540689
              ],
              [
                83.913461,
                42.523992
              ],
              [
                83.947101,
                42.531972
              ],
              [
                83.932226,
                42.500196
              ],
              [
                83.938405,
                42.415727
              ],
              [
                83.932455,
                42.373821
              ],
              [
                83.96312,
                42.356783
              ],
              [
                83.974104,
                42.294521
              ],
              [
                83.948016,
                42.268857
              ],
              [
                83.880279,
                42.261735
              ],
              [
                83.880737,
                42.186454
              ],
              [
                83.924674,
                42.14603
              ],
              [
                83.938405,
                42.074332
              ],
              [
                83.980054,
                41.985863
              ],
              [
                83.987606,
                41.93323
              ],
              [
                83.96701,
                41.873984
              ],
              [
                83.964264,
                41.809004
              ],
              [
                83.929709,
                41.774919
              ],
              [
                83.906596,
                41.685885
              ],
              [
                83.900646,
                41.597626
              ],
              [
                83.918267,
                41.56883
              ],
              [
                83.953051,
                41.558778
              ],
              [
                83.94733,
                41.528314
              ],
              [
                83.975706,
                41.505944
              ],
              [
                84.015295,
                41.445401
              ],
              [
                84.029255,
                41.348536
              ],
              [
                84.022847,
                41.233434
              ],
              [
                84.034518,
                41.168864
              ],
              [
                84.08738,
                41.120847
              ],
              [
                84.058775,
                41.082318
              ],
              [
                84.073192,
                40.924038
              ],
              [
                84.067471,
                40.77707
              ],
              [
                83.929022,
                40.816688
              ],
              [
                83.889662,
                40.833681
              ],
              [
                83.85259,
                40.873114
              ],
              [
                83.837257,
                40.913887
              ],
              [
                83.848242,
                40.9563
              ],
              [
                83.769978,
                40.976891
              ],
              [
                83.778903,
                41.010337
              ],
              [
                83.745263,
                41.031063
              ],
              [
                83.696063,
                41.017448
              ],
              [
                83.670432,
                41.036205
              ],
              [
                83.682103,
                41.069924
              ],
              [
                83.616655,
                41.10846
              ],
              [
                83.589652,
                41.15724
              ],
              [
                83.478893,
                41.135951
              ],
              [
                83.485529,
                41.077028
              ],
              [
                83.438159,
                41.06811
              ],
              [
                83.390789,
                41.137914
              ],
              [
                83.301312,
                41.124019
              ],
              [
                83.146387,
                41.223631
              ],
              [
                83.104967,
                41.224084
              ],
              [
                83.069039,
                41.243234
              ],
              [
                83.030823,
                41.289353
              ],
              [
                83.015033,
                41.377881
              ],
              [
                82.98391,
                41.408717
              ],
              [
                82.848894,
                41.478759
              ],
              [
                82.814111,
                41.461932
              ],
              [
                82.729211,
                41.463885
              ],
              [
                82.635844,
                41.503241
              ],
              [
                82.636759,
                41.461331
              ],
              [
                82.607696,
                41.457424
              ],
              [
                82.583897,
                41.389164
              ],
              [
                82.57932,
                41.342063
              ],
              [
                82.520508,
                41.323694
              ],
              [
                82.456661,
                41.255897
              ],
              [
                82.359633,
                41.251677
              ],
              [
                82.294642,
                41.23268
              ],
              [
                82.181824,
                41.166599
              ],
              [
                82.061454,
                41.126436
              ],
              [
                81.999895,
                41.076726
              ],
              [
                81.939482,
                40.991422
              ],
              [
                81.884102,
                40.941004
              ],
              [
                81.863506,
                40.944033
              ],
              [
                81.457085,
                40.804699
              ],
              [
                81.385687,
                40.825033
              ],
              [
                81.32596,
                40.805154
              ],
              [
                81.32985,
                40.762947
              ],
              [
                81.140828,
                40.698979
              ],
              [
                80.990479,
                40.702476
              ],
              [
                80.867363,
                40.658987
              ],
              [
                80.791846,
                40.703236
              ],
              [
                80.725939,
                40.701412
              ],
              [
                80.683375,
                40.666744
              ],
              [
                80.592296,
                40.619884
              ],
              [
                80.57971,
                40.666592
              ],
              [
                80.553165,
                40.655032
              ],
              [
                80.552707,
                40.687577
              ],
              [
                80.520441,
                40.70202
              ],
              [
                80.457967,
                40.773881
              ],
              [
                80.397095,
                40.818964
              ],
              [
                80.331876,
                40.850064
              ],
              [
                80.2678,
                40.819723
              ],
              [
                80.23622,
                40.784358
              ],
              [
                80.249264,
                40.82473
              ],
              [
                80.22455,
                40.883878
              ],
              [
                80.136675,
                40.891912
              ],
              [
                80.050402,
                40.828826
              ],
              [
                80.052004,
                40.775096
              ],
              [
                80.08038,
                40.750341
              ],
              [
                80.087245,
                40.694571
              ],
              [
                80.070997,
                40.631906
              ],
              [
                80.050631,
                40.642405
              ],
              [
                80.022941,
                40.592787
              ],
              [
                80.037129,
                40.536885
              ],
              [
                80.022026,
                40.500913
              ],
              [
                79.975342,
                40.485207
              ],
              [
                79.941016,
                40.44295
              ],
              [
                79.864125,
                40.489629
              ],
              [
                79.810348,
                40.491154
              ],
              [
                79.853599,
                40.437151
              ],
              [
                79.915386,
                40.386617
              ],
              [
                79.86916,
                40.145643
              ],
              [
                79.833461,
                40.131388
              ],
              [
                79.731169,
                40.146716
              ],
              [
                79.587228,
                40.175678
              ],
              [
                79.497294,
                40.211824
              ],
              [
                79.343055,
                40.241065
              ],
              [
                79.238933,
                40.253002
              ],
              [
                79.145108,
                40.256522
              ],
              [
                79.003913,
                40.219786
              ],
              [
                78.903681,
                40.257134
              ],
              [
                78.807339,
                40.22591
              ],
              [
                78.759969,
                40.187014
              ],
              [
                78.605959,
                40.131694
              ],
              [
                78.59795,
                40.107621
              ],
              [
                78.550122,
                40.088295
              ],
              [
                78.543486,
                40.061445
              ],
              [
                78.442338,
                40.02614
              ],
              [
                78.36499,
                40.009709
              ]
            ]
          ],
          [
            [
              [
                80.592296,
                40.619884
              ],
              [
                80.621588,
                40.556845
              ],
              [
                80.670789,
                40.569031
              ],
              [
                80.70214,
                40.546028
              ],
              [
                80.696419,
                40.520121
              ],
              [
                80.741272,
                40.533228
              ],
              [
                80.780404,
                40.505944
              ],
              [
                80.789786,
                40.479564
              ],
              [
                80.827774,
                40.476513
              ],
              [
                80.809924,
                40.454699
              ],
              [
                80.729372,
                40.452411
              ],
              [
                80.723422,
                40.488409
              ],
              [
                80.673993,
                40.511585
              ],
              [
                80.659347,
                40.484597
              ],
              [
                80.683833,
                40.464616
              ],
              [
                80.633717,
                40.465378
              ],
              [
                80.605798,
                40.423262
              ],
              [
                80.679485,
                40.381425
              ],
              [
                80.740128,
                40.369357
              ],
              [
                80.907868,
                40.420362
              ],
              [
                80.931438,
                40.432573
              ],
              [
                80.981097,
                40.423872
              ],
              [
                81.003065,
                40.396849
              ],
              [
                81.210395,
                40.397307
              ],
              [
                81.281107,
                40.43593
              ],
              [
                81.377449,
                40.43944
              ],
              [
                81.760299,
                40.437914
              ],
              [
                81.880441,
                40.467667
              ],
              [
                81.978613,
                40.468429
              ],
              [
                81.944745,
                40.494356
              ],
              [
                81.822544,
                40.685144
              ],
              [
                81.743365,
                40.733326
              ],
              [
                81.812704,
                40.813197
              ],
              [
                81.84314,
                40.886152
              ],
              [
                81.884102,
                40.941004
              ],
              [
                81.939482,
                40.991422
              ],
              [
                81.999895,
                41.076726
              ],
              [
                82.061454,
                41.126436
              ],
              [
                82.181824,
                41.166599
              ],
              [
                82.294642,
                41.23268
              ],
              [
                82.359633,
                41.251677
              ],
              [
                82.456661,
                41.255897
              ],
              [
                82.520508,
                41.323694
              ],
              [
                82.57932,
                41.342063
              ],
              [
                82.583897,
                41.389164
              ],
              [
                82.607696,
                41.457424
              ],
              [
                82.636759,
                41.461331
              ],
              [
                82.635844,
                41.503241
              ],
              [
                82.729211,
                41.463885
              ],
              [
                82.814111,
                41.461932
              ],
              [
                82.848894,
                41.478759
              ],
              [
                82.98391,
                41.408717
              ],
              [
                83.015033,
                41.377881
              ],
              [
                83.030823,
                41.289353
              ],
              [
                83.069039,
                41.243234
              ],
              [
                83.104967,
                41.224084
              ],
              [
                83.146387,
                41.223631
              ],
              [
                83.301312,
                41.124019
              ],
              [
                83.390789,
                41.137914
              ],
              [
                83.438159,
                41.06811
              ],
              [
                83.485529,
                41.077028
              ],
              [
                83.478893,
                41.135951
              ],
              [
                83.589652,
                41.15724
              ],
              [
                83.616655,
                41.10846
              ],
              [
                83.682103,
                41.069924
              ],
              [
                83.670432,
                41.036205
              ],
              [
                83.696063,
                41.017448
              ],
              [
                83.745263,
                41.031063
              ],
              [
                83.778903,
                41.010337
              ],
              [
                83.769978,
                40.976891
              ],
              [
                83.848242,
                40.9563
              ],
              [
                83.837257,
                40.913887
              ],
              [
                83.85259,
                40.873114
              ],
              [
                83.889662,
                40.833681
              ],
              [
                83.929022,
                40.816688
              ],
              [
                84.067471,
                40.77707
              ],
              [
                84.060377,
                40.677846
              ],
              [
                84.012092,
                40.113142
              ],
              [
                84.009574,
                40.037654
              ],
              [
                83.951906,
                39.956396
              ],
              [
                83.414817,
                39.483227
              ],
              [
                83.151879,
                39.484465
              ],
              [
                82.585041,
                39.484
              ],
              [
                82.101272,
                39.485393
              ],
              [
                81.955958,
                39.483691
              ],
              [
                81.438092,
                39.484929
              ],
              [
                81.062335,
                39.483381
              ],
              [
                80.726855,
                39.477346
              ],
              [
                80.162305,
                39.464034
              ],
              [
                79.764351,
                39.622831
              ],
              [
                79.788379,
                39.801909
              ],
              [
                79.815382,
                39.882735
              ],
              [
                79.846047,
                39.908887
              ],
              [
                79.862981,
                39.957165
              ],
              [
                79.837809,
                39.980523
              ],
              [
                79.860006,
                40.013702
              ],
              [
                79.841699,
                40.131388
              ],
              [
                79.833461,
                40.131388
              ],
              [
                79.86916,
                40.145643
              ],
              [
                79.915386,
                40.386617
              ],
              [
                79.853599,
                40.437151
              ],
              [
                79.810348,
                40.491154
              ],
              [
                79.864125,
                40.489629
              ],
              [
                79.941016,
                40.44295
              ],
              [
                79.975342,
                40.485207
              ],
              [
                80.022026,
                40.500913
              ],
              [
                80.037129,
                40.536885
              ],
              [
                80.022941,
                40.592787
              ],
              [
                80.050631,
                40.642405
              ],
              [
                80.070997,
                40.631906
              ],
              [
                80.087245,
                40.694571
              ],
              [
                80.08038,
                40.750341
              ],
              [
                80.052004,
                40.775096
              ],
              [
                80.050402,
                40.828826
              ],
              [
                80.136675,
                40.891912
              ],
              [
                80.22455,
                40.883878
              ],
              [
                80.249264,
                40.82473
              ],
              [
                80.23622,
                40.784358
              ],
              [
                80.2678,
                40.819723
              ],
              [
                80.331876,
                40.850064
              ],
              [
                80.397095,
                40.818964
              ],
              [
                80.457967,
                40.773881
              ],
              [
                80.520441,
                40.70202
              ],
              [
                80.552707,
                40.687577
              ],
              [
                80.553165,
                40.655032
              ],
              [
                80.57971,
                40.666592
              ],
              [
                80.592296,
                40.619884
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 653000,
        "name": "克孜勒苏柯尔克孜自治州",
        "center": [
          76.172825,
          39.713431
        ],
        "centroid": [
          75.956625,
          39.672168
        ],
        "childrenNum": 4,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 8,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                78.36499,
                40.009709
              ],
              [
                78.301144,
                40.011705
              ],
              [
                78.208921,
                39.99865
              ],
              [
                78.074134,
                39.970996
              ],
              [
                78.017839,
                39.984517
              ],
              [
                77.940948,
                39.97453
              ],
              [
                77.798152,
                39.986822
              ],
              [
                77.765428,
                39.970074
              ],
              [
                77.603866,
                39.936413
              ],
              [
                77.529264,
                39.925804
              ],
              [
                77.511872,
                39.878427
              ],
              [
                77.302941,
                39.864731
              ],
              [
                77.211404,
                39.849339
              ],
              [
                77.054648,
                39.862576
              ],
              [
                77.022611,
                39.844413
              ],
              [
                76.838165,
                39.82686
              ],
              [
                76.82924,
                39.794977
              ],
              [
                76.786447,
                39.753985
              ],
              [
                76.743883,
                39.735176
              ],
              [
                76.637014,
                39.651089
              ],
              [
                76.595594,
                39.629935
              ],
              [
                76.59834,
                39.6131
              ],
              [
                76.55303,
                39.588999
              ],
              [
                76.506346,
                39.591935
              ],
              [
                76.447763,
                39.575864
              ],
              [
                76.29627,
                39.591008
              ],
              [
                76.215947,
                39.625302
              ],
              [
                76.15027,
                39.6131
              ],
              [
                76.126471,
                39.624221
              ],
              [
                75.976122,
                39.611556
              ],
              [
                75.985047,
                39.589926
              ],
              [
                75.930125,
                39.599815
              ],
              [
                75.855523,
                39.585754
              ],
              [
                75.701285,
                39.594871
              ],
              [
                75.701742,
                39.615881
              ],
              [
                75.646821,
                39.653404
              ],
              [
                75.551623,
                39.668223
              ],
              [
                75.533316,
                39.655257
              ],
              [
                75.466265,
                39.67918
              ],
              [
                75.433999,
                39.652787
              ],
              [
                75.36077,
                39.654022
              ],
              [
                75.341318,
                39.623294
              ],
              [
                75.365118,
                39.591781
              ],
              [
                75.357566,
                39.557161
              ],
              [
                75.389375,
                39.505972
              ],
              [
                75.357108,
                39.470381
              ],
              [
                75.320723,
                39.461557
              ],
              [
                75.299898,
                39.407819
              ],
              [
                75.305619,
                39.334192
              ],
              [
                75.350014,
                39.144574
              ],
              [
                75.472215,
                39.170072
              ],
              [
                75.512491,
                39.227566
              ],
              [
                75.573134,
                39.241543
              ],
              [
                75.580686,
                39.211876
              ],
              [
                75.635379,
                39.258468
              ],
              [
                75.642244,
                39.284701
              ],
              [
                75.691445,
                39.303943
              ],
              [
                75.736755,
                39.296806
              ],
              [
                75.683435,
                39.270111
              ],
              [
                75.671078,
                39.221197
              ],
              [
                75.60746,
                39.142241
              ],
              [
                75.587322,
                39.100396
              ],
              [
                75.586407,
                39.050273
              ],
              [
                75.552309,
                38.986245
              ],
              [
                75.565582,
                38.971282
              ],
              [
                75.662839,
                38.955691
              ],
              [
                75.757579,
                38.997934
              ],
              [
                75.771996,
                39.095728
              ],
              [
                75.707006,
                39.12731
              ],
              [
                75.747053,
                39.15126
              ],
              [
                75.770166,
                39.189967
              ],
              [
                75.839733,
                39.188879
              ],
              [
                75.835614,
                39.217624
              ],
              [
                75.882298,
                39.269025
              ],
              [
                75.952552,
                39.273682
              ],
              [
                76.006558,
                39.263436
              ],
              [
                76.049351,
                39.23968
              ],
              [
                76.157135,
                39.229895
              ],
              [
                76.145922,
                39.202243
              ],
              [
                76.047521,
                39.180642
              ],
              [
                76.050953,
                39.155925
              ],
              [
                76.131505,
                39.077518
              ],
              [
                76.141116,
                39.039684
              ],
              [
                76.063768,
                39.008062
              ],
              [
                75.940194,
                39.007127
              ],
              [
                75.927608,
                39.039528
              ],
              [
                75.861244,
                38.997778
              ],
              [
                75.759181,
                38.947115
              ],
              [
                75.829893,
                38.920444
              ],
              [
                75.908157,
                38.875345
              ],
              [
                75.938821,
                38.805378
              ],
              [
                75.975665,
                38.79819
              ],
              [
                75.977495,
                38.759268
              ],
              [
                76.033104,
                38.753639
              ],
              [
                76.035392,
                38.730024
              ],
              [
                76.16217,
                38.646917
              ],
              [
                76.149584,
                38.609323
              ],
              [
                76.243179,
                38.612926
              ],
              [
                76.288948,
                38.629689
              ],
              [
                76.339292,
                38.606346
              ],
              [
                76.403139,
                38.606189
              ],
              [
                76.401995,
                38.540192
              ],
              [
                76.344098,
                38.500503
              ],
              [
                76.383688,
                38.485123
              ],
              [
                76.455544,
                38.497835
              ],
              [
                76.547309,
                38.457337
              ],
              [
                76.597654,
                38.42467
              ],
              [
                76.602688,
                38.399532
              ],
              [
                76.6004,
                38.219541
              ],
              [
                76.539299,
                38.129851
              ],
              [
                76.540215,
                38.060735
              ],
              [
                76.510923,
                38.01399
              ],
              [
                76.509779,
                37.974485
              ],
              [
                76.469274,
                37.925787
              ],
              [
                76.492387,
                37.86566
              ],
              [
                76.482089,
                37.849987
              ],
              [
                76.436092,
                37.856003
              ],
              [
                76.410233,
                37.876898
              ],
              [
                76.384374,
                37.867401
              ],
              [
                76.382543,
                37.826868
              ],
              [
                76.327164,
                37.815622
              ],
              [
                76.292151,
                37.734159
              ],
              [
                76.264462,
                37.731463
              ],
              [
                76.208167,
                37.813405
              ],
              [
                76.162856,
                37.780449
              ],
              [
                76.100383,
                37.770464
              ],
              [
                76.0299,
                37.732256
              ],
              [
                75.940881,
                37.732415
              ],
              [
                75.868567,
                37.674669
              ],
              [
                75.805865,
                37.65213
              ],
              [
                75.793507,
                37.734476
              ],
              [
                75.858498,
                37.829719
              ],
              [
                75.851175,
                37.859961
              ],
              [
                75.886417,
                37.876581
              ],
              [
                75.880467,
                37.92642
              ],
              [
                75.78321,
                37.939704
              ],
              [
                75.781379,
                37.909811
              ],
              [
                75.747053,
                37.888451
              ],
              [
                75.728746,
                37.903008
              ],
              [
                75.666959,
                37.875473
              ],
              [
                75.561463,
                37.919302
              ],
              [
                75.462146,
                37.936858
              ],
              [
                75.410428,
                37.922624
              ],
              [
                75.421184,
                37.974485
              ],
              [
                75.389604,
                38.035155
              ],
              [
                75.385942,
                38.088673
              ],
              [
                75.399215,
                38.106031
              ],
              [
                75.368322,
                38.12433
              ],
              [
                75.278158,
                38.203786
              ],
              [
                75.192114,
                38.198902
              ],
              [
                75.136277,
                38.234977
              ],
              [
                75.108587,
                38.276387
              ],
              [
                75.042681,
                38.266155
              ],
              [
                74.982725,
                38.243009
              ],
              [
                74.945653,
                38.273869
              ],
              [
                74.896223,
                38.267414
              ],
              [
                74.806746,
                38.285516
              ],
              [
                74.789583,
                38.324695
              ],
              [
                74.868305,
                38.403932
              ],
              [
                74.862812,
                38.484024
              ],
              [
                74.821621,
                38.491087
              ],
              [
                74.784778,
                38.538154
              ],
              [
                74.717727,
                38.542231
              ],
              [
                74.640379,
                38.599608
              ],
              [
                74.613376,
                38.593183
              ],
              [
                74.546783,
                38.607599
              ],
              [
                74.506508,
                38.637677
              ],
              [
                74.455934,
                38.632978
              ],
              [
                74.377899,
                38.654903
              ],
              [
                74.22961,
                38.656156
              ],
              [
                74.148143,
                38.676821
              ],
              [
                74.118394,
                38.614493
              ],
              [
                74.068735,
                38.58566
              ],
              [
                74.090704,
                38.542231
              ],
              [
                74.034409,
                38.541604
              ],
              [
                74.011754,
                38.524978
              ],
              [
                73.926168,
                38.535958
              ],
              [
                73.899164,
                38.57892
              ],
              [
                73.852252,
                38.584249
              ],
              [
                73.799161,
                38.611046
              ],
              [
                73.808772,
                38.634231
              ],
              [
                73.757054,
                38.719543
              ],
              [
                73.770785,
                38.77115
              ],
              [
                73.729365,
                38.83709
              ],
              [
                73.699386,
                38.857703
              ],
              [
                73.709227,
                38.89345
              ],
              [
                73.742408,
                38.933858
              ],
              [
                73.767581,
                38.941033
              ],
              [
                73.826393,
                38.916855
              ],
              [
                73.846302,
                38.972061
              ],
              [
                73.820214,
                39.041553
              ],
              [
                73.742866,
                39.029404
              ],
              [
                73.72044,
                39.071759
              ],
              [
                73.719753,
                39.108176
              ],
              [
                73.688631,
                39.154992
              ],
              [
                73.657737,
                39.166186
              ],
              [
                73.63943,
                39.22042
              ],
              [
                73.58016,
                39.237506
              ],
              [
                73.539427,
                39.27244
              ],
              [
                73.554988,
                39.29603
              ],
              [
                73.554073,
                39.349854
              ],
              [
                73.506474,
                39.380547
              ],
              [
                73.592518,
                39.412312
              ],
              [
                73.610596,
                39.465892
              ],
              [
                73.646982,
                39.474405
              ],
              [
                73.745383,
                39.462022
              ],
              [
                73.868042,
                39.482917
              ],
              [
                73.916327,
                39.586527
              ],
              [
                73.953628,
                39.600278
              ],
              [
                73.924337,
                39.721914
              ],
              [
                73.905572,
                39.742114
              ],
              [
                73.841725,
                39.756297
              ],
              [
                73.845387,
                39.831172
              ],
              [
                73.907174,
                39.873811
              ],
              [
                73.911064,
                39.934721
              ],
              [
                73.980403,
                40.004794
              ],
              [
                73.943331,
                40.016005
              ],
              [
                74.003058,
                40.045023
              ],
              [
                74.023425,
                40.085074
              ],
              [
                74.089102,
                40.079704
              ],
              [
                74.126632,
                40.104554
              ],
              [
                74.26325,
                40.125102
              ],
              [
                74.280642,
                40.098112
              ],
              [
                74.316799,
                40.106548
              ],
              [
                74.356617,
                40.089216
              ],
              [
                74.433278,
                40.131694
              ],
              [
                74.476758,
                40.175065
              ],
              [
                74.547241,
                40.219174
              ],
              [
                74.577448,
                40.260347
              ],
              [
                74.618411,
                40.279777
              ],
              [
                74.663263,
                40.271363
              ],
              [
                74.701022,
                40.317091
              ],
              [
                74.698047,
                40.344452
              ],
              [
                74.811781,
                40.34705
              ],
              [
                74.863041,
                40.326416
              ],
              [
                74.908352,
                40.33895
              ],
              [
                74.795076,
                40.443255
              ],
              [
                74.814756,
                40.460954
              ],
              [
                74.819333,
                40.505791
              ],
              [
                74.844505,
                40.52134
              ],
              [
                74.891875,
                40.507621
              ],
              [
                74.963274,
                40.464616
              ],
              [
                75.021857,
                40.467209
              ],
              [
                75.102866,
                40.439898
              ],
              [
                75.135362,
                40.463395
              ],
              [
                75.242459,
                40.448901
              ],
              [
                75.268776,
                40.483682
              ],
              [
                75.292118,
                40.483682
              ],
              [
                75.355506,
                40.537952
              ],
              [
                75.432397,
                40.563395
              ],
              [
                75.468096,
                40.599943
              ],
              [
                75.568557,
                40.65701
              ],
              [
                75.599451,
                40.659748
              ],
              [
                75.63698,
                40.62445
              ],
              [
                75.630802,
                40.549075
              ],
              [
                75.646134,
                40.516615
              ],
              [
                75.734467,
                40.467514
              ],
              [
                75.68641,
                40.418072
              ],
              [
                75.669934,
                40.363857
              ],
              [
                75.709065,
                40.280848
              ],
              [
                75.785956,
                40.301036
              ],
              [
                75.831037,
                40.327333
              ],
              [
                75.921429,
                40.291248
              ],
              [
                75.932185,
                40.339561
              ],
              [
                75.98642,
                40.381883
              ],
              [
                76.048436,
                40.356982
              ],
              [
                76.048894,
                40.388756
              ],
              [
                76.144091,
                40.393337
              ],
              [
                76.173383,
                40.382035
              ],
              [
                76.213888,
                40.394864
              ],
              [
                76.279794,
                40.439288
              ],
              [
                76.283227,
                40.415171
              ],
              [
                76.327622,
                40.391352
              ],
              [
                76.333343,
                40.343688
              ],
              [
                76.382086,
                40.390894
              ],
              [
                76.390324,
                40.377606
              ],
              [
                76.442042,
                40.391505
              ],
              [
                76.470647,
                40.422651
              ],
              [
                76.509092,
                40.42952
              ],
              [
                76.539528,
                40.464005
              ],
              [
                76.55692,
                40.542676
              ],
              [
                76.618707,
                40.609077
              ],
              [
                76.657381,
                40.620341
              ],
              [
                76.654864,
                40.65275
              ],
              [
                76.675917,
                40.694267
              ],
              [
                76.646626,
                40.760062
              ],
              [
                76.693309,
                40.779499
              ],
              [
                76.731525,
                40.819116
              ],
              [
                76.741823,
                40.912068
              ],
              [
                76.761961,
                40.954028
              ],
              [
                76.853497,
                40.976437
              ],
              [
                76.885764,
                41.027432
              ],
              [
                76.940915,
                41.028794
              ],
              [
                77.002244,
                41.073401
              ],
              [
                77.023297,
                41.059341
              ],
              [
                77.091492,
                41.062668
              ],
              [
                77.111172,
                41.035903
              ],
              [
                77.169298,
                41.009127
              ],
              [
                77.25168,
                41.025163
              ],
              [
                77.296304,
                41.005042
              ],
              [
                77.363126,
                41.040742
              ],
              [
                77.41553,
                41.038928
              ],
              [
                77.473885,
                41.022743
              ],
              [
                77.476402,
                40.999594
              ],
              [
                77.540248,
                41.006403
              ],
              [
                77.591509,
                40.99233
              ],
              [
                77.65444,
                41.016087
              ],
              [
                77.684876,
                41.007765
              ],
              [
                77.737509,
                41.032273
              ],
              [
                77.780531,
                41.023046
              ],
              [
                77.829503,
                41.059493
              ],
              [
                77.807763,
                41.123415
              ],
              [
                77.834537,
                41.151956
              ],
              [
                77.904792,
                41.185163
              ],
              [
                77.973444,
                41.173392
              ],
              [
                78.097018,
                41.22514
              ],
              [
                78.129055,
                41.228156
              ],
              [
                78.137065,
                41.280011
              ],
              [
                78.164297,
                41.345224
              ],
              [
                78.166128,
                41.3842
              ],
              [
                78.232263,
                41.39849
              ],
              [
                78.323799,
                41.3842
              ],
              [
                78.391765,
                41.408266
              ],
              [
                78.5071,
                41.310442
              ],
              [
                78.565912,
                41.288147
              ],
              [
                78.711913,
                41.185616
              ],
              [
                78.733881,
                41.161467
              ],
              [
                78.762486,
                41.086097
              ],
              [
                78.826333,
                40.994751
              ],
              [
                78.875534,
                40.985216
              ],
              [
                78.848531,
                40.915553
              ],
              [
                78.861803,
                40.891609
              ],
              [
                78.79727,
                40.861286
              ],
              [
                78.748298,
                40.81866
              ],
              [
                78.725643,
                40.822909
              ],
              [
                78.570489,
                40.766137
              ],
              [
                78.574151,
                40.700195
              ],
              [
                78.605044,
                40.696699
              ],
              [
                78.585593,
                40.637841
              ],
              [
                78.523577,
                40.552579
              ],
              [
                78.47163,
                40.52637
              ],
              [
                78.373915,
                40.494966
              ],
              [
                78.303661,
                40.455462
              ],
              [
                78.205259,
                40.420362
              ],
              [
                78.158576,
                40.387228
              ],
              [
                78.15583,
                40.331155
              ],
              [
                78.124707,
                40.287119
              ],
              [
                78.091068,
                40.274882
              ],
              [
                78.082143,
                40.231574
              ],
              [
                78.055826,
                40.202483
              ],
              [
                78.055369,
                40.140892
              ],
              [
                78.03134,
                40.093818
              ],
              [
                78.09267,
                40.060831
              ],
              [
                78.161322,
                40.071573
              ],
              [
                78.241187,
                40.060831
              ],
              [
                78.313272,
                40.066049
              ],
              [
                78.36499,
                40.009709
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 653100,
        "name": "喀什地区",
        "center": [
          75.989138,
          39.467664
        ],
        "centroid": [
          77.133824,
          38.111752
        ],
        "childrenNum": 12,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 9,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                74.806746,
                38.285516
              ],
              [
                74.896223,
                38.267414
              ],
              [
                74.945653,
                38.273869
              ],
              [
                74.982725,
                38.243009
              ],
              [
                75.042681,
                38.266155
              ],
              [
                75.108587,
                38.276387
              ],
              [
                75.136277,
                38.234977
              ],
              [
                75.192114,
                38.198902
              ],
              [
                75.278158,
                38.203786
              ],
              [
                75.368322,
                38.12433
              ],
              [
                75.399215,
                38.106031
              ],
              [
                75.385942,
                38.088673
              ],
              [
                75.389604,
                38.035155
              ],
              [
                75.421184,
                37.974485
              ],
              [
                75.410428,
                37.922624
              ],
              [
                75.462146,
                37.936858
              ],
              [
                75.561463,
                37.919302
              ],
              [
                75.666959,
                37.875473
              ],
              [
                75.728746,
                37.903008
              ],
              [
                75.747053,
                37.888451
              ],
              [
                75.781379,
                37.909811
              ],
              [
                75.78321,
                37.939704
              ],
              [
                75.880467,
                37.92642
              ],
              [
                75.886417,
                37.876581
              ],
              [
                75.851175,
                37.859961
              ],
              [
                75.858498,
                37.829719
              ],
              [
                75.793507,
                37.734476
              ],
              [
                75.805865,
                37.65213
              ],
              [
                75.868567,
                37.674669
              ],
              [
                75.940881,
                37.732415
              ],
              [
                76.0299,
                37.732256
              ],
              [
                76.100383,
                37.770464
              ],
              [
                76.162856,
                37.780449
              ],
              [
                76.208167,
                37.813405
              ],
              [
                76.264462,
                37.731463
              ],
              [
                76.292151,
                37.734159
              ],
              [
                76.327164,
                37.815622
              ],
              [
                76.382543,
                37.826868
              ],
              [
                76.384374,
                37.867401
              ],
              [
                76.410233,
                37.876898
              ],
              [
                76.436092,
                37.856003
              ],
              [
                76.482089,
                37.849987
              ],
              [
                76.492387,
                37.86566
              ],
              [
                76.469274,
                37.925787
              ],
              [
                76.509779,
                37.974485
              ],
              [
                76.510923,
                38.01399
              ],
              [
                76.540215,
                38.060735
              ],
              [
                76.539299,
                38.129851
              ],
              [
                76.6004,
                38.219541
              ],
              [
                76.602688,
                38.399532
              ],
              [
                76.597654,
                38.42467
              ],
              [
                76.547309,
                38.457337
              ],
              [
                76.455544,
                38.497835
              ],
              [
                76.383688,
                38.485123
              ],
              [
                76.344098,
                38.500503
              ],
              [
                76.401995,
                38.540192
              ],
              [
                76.403139,
                38.606189
              ],
              [
                76.339292,
                38.606346
              ],
              [
                76.288948,
                38.629689
              ],
              [
                76.243179,
                38.612926
              ],
              [
                76.149584,
                38.609323
              ],
              [
                76.16217,
                38.646917
              ],
              [
                76.035392,
                38.730024
              ],
              [
                76.033104,
                38.753639
              ],
              [
                75.977495,
                38.759268
              ],
              [
                75.975665,
                38.79819
              ],
              [
                75.938821,
                38.805378
              ],
              [
                75.908157,
                38.875345
              ],
              [
                75.829893,
                38.920444
              ],
              [
                75.759181,
                38.947115
              ],
              [
                75.861244,
                38.997778
              ],
              [
                75.927608,
                39.039528
              ],
              [
                75.940194,
                39.007127
              ],
              [
                76.063768,
                39.008062
              ],
              [
                76.141116,
                39.039684
              ],
              [
                76.131505,
                39.077518
              ],
              [
                76.050953,
                39.155925
              ],
              [
                76.047521,
                39.180642
              ],
              [
                76.145922,
                39.202243
              ],
              [
                76.157135,
                39.229895
              ],
              [
                76.049351,
                39.23968
              ],
              [
                76.006558,
                39.263436
              ],
              [
                75.952552,
                39.273682
              ],
              [
                75.882298,
                39.269025
              ],
              [
                75.835614,
                39.217624
              ],
              [
                75.839733,
                39.188879
              ],
              [
                75.770166,
                39.189967
              ],
              [
                75.747053,
                39.15126
              ],
              [
                75.707006,
                39.12731
              ],
              [
                75.771996,
                39.095728
              ],
              [
                75.757579,
                38.997934
              ],
              [
                75.662839,
                38.955691
              ],
              [
                75.565582,
                38.971282
              ],
              [
                75.552309,
                38.986245
              ],
              [
                75.586407,
                39.050273
              ],
              [
                75.587322,
                39.100396
              ],
              [
                75.60746,
                39.142241
              ],
              [
                75.671078,
                39.221197
              ],
              [
                75.683435,
                39.270111
              ],
              [
                75.736755,
                39.296806
              ],
              [
                75.691445,
                39.303943
              ],
              [
                75.642244,
                39.284701
              ],
              [
                75.635379,
                39.258468
              ],
              [
                75.580686,
                39.211876
              ],
              [
                75.573134,
                39.241543
              ],
              [
                75.512491,
                39.227566
              ],
              [
                75.472215,
                39.170072
              ],
              [
                75.350014,
                39.144574
              ],
              [
                75.305619,
                39.334192
              ],
              [
                75.299898,
                39.407819
              ],
              [
                75.320723,
                39.461557
              ],
              [
                75.357108,
                39.470381
              ],
              [
                75.389375,
                39.505972
              ],
              [
                75.357566,
                39.557161
              ],
              [
                75.365118,
                39.591781
              ],
              [
                75.341318,
                39.623294
              ],
              [
                75.36077,
                39.654022
              ],
              [
                75.433999,
                39.652787
              ],
              [
                75.466265,
                39.67918
              ],
              [
                75.533316,
                39.655257
              ],
              [
                75.551623,
                39.668223
              ],
              [
                75.646821,
                39.653404
              ],
              [
                75.701742,
                39.615881
              ],
              [
                75.701285,
                39.594871
              ],
              [
                75.855523,
                39.585754
              ],
              [
                75.930125,
                39.599815
              ],
              [
                75.985047,
                39.589926
              ],
              [
                75.976122,
                39.611556
              ],
              [
                76.126471,
                39.624221
              ],
              [
                76.15027,
                39.6131
              ],
              [
                76.215947,
                39.625302
              ],
              [
                76.29627,
                39.591008
              ],
              [
                76.447763,
                39.575864
              ],
              [
                76.506346,
                39.591935
              ],
              [
                76.55303,
                39.588999
              ],
              [
                76.59834,
                39.6131
              ],
              [
                76.595594,
                39.629935
              ],
              [
                76.637014,
                39.651089
              ],
              [
                76.743883,
                39.735176
              ],
              [
                76.786447,
                39.753985
              ],
              [
                76.82924,
                39.794977
              ],
              [
                76.838165,
                39.82686
              ],
              [
                77.022611,
                39.844413
              ],
              [
                77.054648,
                39.862576
              ],
              [
                77.211404,
                39.849339
              ],
              [
                77.302941,
                39.864731
              ],
              [
                77.511872,
                39.878427
              ],
              [
                77.529264,
                39.925804
              ],
              [
                77.603866,
                39.936413
              ],
              [
                77.765428,
                39.970074
              ],
              [
                77.798152,
                39.986822
              ],
              [
                77.940948,
                39.97453
              ],
              [
                78.017839,
                39.984517
              ],
              [
                78.074134,
                39.970996
              ],
              [
                78.208921,
                39.99865
              ],
              [
                78.301144,
                40.011705
              ],
              [
                78.36499,
                40.009709
              ],
              [
                78.442338,
                40.02614
              ],
              [
                78.543486,
                40.061445
              ],
              [
                78.550122,
                40.088295
              ],
              [
                78.59795,
                40.107621
              ],
              [
                78.605959,
                40.131694
              ],
              [
                78.759969,
                40.187014
              ],
              [
                78.807339,
                40.22591
              ],
              [
                78.903681,
                40.257134
              ],
              [
                79.003913,
                40.219786
              ],
              [
                79.145108,
                40.256522
              ],
              [
                79.214218,
                40.059603
              ],
              [
                79.045562,
                40.036887
              ],
              [
                79.015355,
                40.022147
              ],
              [
                79.039155,
                39.981291
              ],
              [
                79.001625,
                39.970996
              ],
              [
                78.989725,
                39.929494
              ],
              [
                78.942813,
                39.908118
              ],
              [
                78.989496,
                39.868271
              ],
              [
                78.932057,
                39.859806
              ],
              [
                78.906885,
                39.831326
              ],
              [
                78.942584,
                39.809765
              ],
              [
                79.004829,
                39.800677
              ],
              [
                78.993387,
                39.781418
              ],
              [
                78.904368,
                39.781418
              ],
              [
                78.870728,
                39.762154
              ],
              [
                78.883772,
                39.704176
              ],
              [
                78.840521,
                39.711271
              ],
              [
                78.806424,
                39.657264
              ],
              [
                78.782853,
                39.688593
              ],
              [
                78.809856,
                39.74381
              ],
              [
                78.776675,
                39.758147
              ],
              [
                78.777819,
                39.825012
              ],
              [
                78.757223,
                39.796672
              ],
              [
                78.657449,
                39.736409
              ],
              [
                78.673467,
                39.700936
              ],
              [
                78.705276,
                39.689982
              ],
              [
                78.708709,
                39.650471
              ],
              [
                78.796584,
                39.653404
              ],
              [
                78.84075,
                39.6131
              ],
              [
                78.915581,
                39.611247
              ],
              [
                79.000252,
                39.624993
              ],
              [
                79.003684,
                39.65927
              ],
              [
                79.092246,
                39.681032
              ],
              [
                79.117647,
                39.715436
              ],
              [
                79.190647,
                39.72068
              ],
              [
                79.733686,
                39.4775
              ],
              [
                79.616062,
                38.919196
              ],
              [
                79.599814,
                38.829905
              ],
              [
                79.566633,
                38.784437
              ],
              [
                79.390425,
                38.830218
              ],
              [
                79.333902,
                38.802253
              ],
              [
                79.285387,
                38.807253
              ],
              [
                79.238704,
                38.794283
              ],
              [
                79.003227,
                38.667116
              ],
              [
                78.506871,
                38.422471
              ],
              [
                78.245078,
                38.188343
              ],
              [
                78.006397,
                37.96342
              ],
              [
                77.878246,
                37.811662
              ],
              [
                77.806161,
                37.727023
              ],
              [
                77.752155,
                37.678954
              ],
              [
                77.741399,
                37.637365
              ],
              [
                77.699979,
                37.588762
              ],
              [
                77.664051,
                37.581611
              ],
              [
                77.667713,
                37.444035
              ],
              [
                77.639794,
                37.376505
              ],
              [
                77.64254,
                37.350369
              ],
              [
                77.600205,
                37.297591
              ],
              [
                77.642769,
                37.266481
              ],
              [
                77.664967,
                37.14463
              ],
              [
                77.681214,
                37.128485
              ],
              [
                77.651236,
                37.056512
              ],
              [
                77.642311,
                36.975981
              ],
              [
                77.608214,
                36.935284
              ],
              [
                77.518966,
                36.930315
              ],
              [
                77.528806,
                36.865052
              ],
              [
                77.505693,
                36.842911
              ],
              [
                77.49265,
                36.792991
              ],
              [
                77.542308,
                36.746732
              ],
              [
                77.61691,
                36.699964
              ],
              [
                77.64849,
                36.669252
              ],
              [
                77.623089,
                36.643193
              ],
              [
                77.576405,
                36.633701
              ],
              [
                77.582126,
                36.610366
              ],
              [
                77.534756,
                36.610849
              ],
              [
                77.503634,
                36.56126
              ],
              [
                77.40775,
                36.545959
              ],
              [
                77.42537,
                36.492137
              ],
              [
                77.484869,
                36.493104
              ],
              [
                77.579151,
                36.448924
              ],
              [
                77.624462,
                36.387772
              ],
              [
                77.610045,
                36.35968
              ],
              [
                77.724465,
                36.28262
              ],
              [
                77.810967,
                36.294579
              ],
              [
                77.910055,
                36.198525
              ],
              [
                77.854675,
                36.182504
              ],
              [
                77.790829,
                36.131508
              ],
              [
                77.791287,
                36.112234
              ],
              [
                77.732246,
                36.100247
              ],
              [
                77.742544,
                36.039145
              ],
              [
                77.800669,
                36.027308
              ],
              [
                77.872983,
                35.994707
              ],
              [
                77.923785,
                35.930764
              ],
              [
                77.887857,
                35.908355
              ],
              [
                77.844835,
                35.912577
              ],
              [
                77.866804,
                35.880904
              ],
              [
                77.878704,
                35.811828
              ],
              [
                77.835224,
                35.804836
              ],
              [
                77.851701,
                35.748225
              ],
              [
                77.826299,
                35.748225
              ],
              [
                77.821722,
                35.714858
              ],
              [
                77.851929,
                35.687014
              ],
              [
                77.844149,
                35.612716
              ],
              [
                77.814399,
                35.602609
              ],
              [
                77.781675,
                35.554011
              ],
              [
                77.816459,
                35.518604
              ],
              [
                77.797236,
                35.491345
              ],
              [
                77.757647,
                35.497222
              ],
              [
                77.728127,
                35.457871
              ],
              [
                77.690597,
                35.448234
              ],
              [
                77.657415,
                35.477467
              ],
              [
                77.639565,
                35.454931
              ],
              [
                77.578236,
                35.475671
              ],
              [
                77.518737,
                35.482039
              ],
              [
                77.451916,
                35.460484
              ],
              [
                77.38006,
                35.477141
              ],
              [
                77.307746,
                35.54047
              ],
              [
                77.195843,
                35.519257
              ],
              [
                77.093323,
                35.56967
              ],
              [
                77.064489,
                35.595761
              ],
              [
                76.998125,
                35.611086
              ],
              [
                76.966774,
                35.591685
              ],
              [
                76.917802,
                35.608478
              ],
              [
                76.836792,
                35.662093
              ],
              [
                76.761275,
                35.655902
              ],
              [
                76.751663,
                35.680499
              ],
              [
                76.698572,
                35.722346
              ],
              [
                76.69308,
                35.747574
              ],
              [
                76.593534,
                35.77198
              ],
              [
                76.566302,
                35.819307
              ],
              [
                76.587585,
                35.840278
              ],
              [
                76.597425,
                35.895686
              ],
              [
                76.548911,
                35.919235
              ],
              [
                76.515271,
                35.880904
              ],
              [
                76.482089,
                35.889189
              ],
              [
                76.431744,
                35.851818
              ],
              [
                76.369728,
                35.863356
              ],
              [
                76.365838,
                35.824185
              ],
              [
                76.298788,
                35.841579
              ],
              [
                76.228762,
                35.837027
              ],
              [
                76.22144,
                35.823372
              ],
              [
                76.147066,
                35.833451
              ],
              [
                76.164687,
                35.908842
              ],
              [
                76.117088,
                35.975075
              ],
              [
                76.097408,
                36.022605
              ],
              [
                76.014568,
                36.018065
              ],
              [
                75.968571,
                36.042063
              ],
              [
                75.949577,
                36.070269
              ],
              [
                75.936304,
                36.134747
              ],
              [
                75.967884,
                36.15871
              ],
              [
                76.016398,
                36.165509
              ],
              [
                76.011593,
                36.229101
              ],
              [
                76.061022,
                36.225219
              ],
              [
                76.055301,
                36.252712
              ],
              [
                75.999006,
                36.312193
              ],
              [
                75.989624,
                36.34014
              ],
              [
                76.034934,
                36.409237
              ],
              [
                75.991455,
                36.507127
              ],
              [
                75.924404,
                36.566414
              ],
              [
                75.946831,
                36.590567
              ],
              [
                75.871542,
                36.666518
              ],
              [
                75.723711,
                36.750588
              ],
              [
                75.634006,
                36.771632
              ],
              [
                75.588695,
                36.762797
              ],
              [
                75.537435,
                36.773077
              ],
              [
                75.536977,
                36.730182
              ],
              [
                75.504939,
                36.74368
              ],
              [
                75.458485,
                36.721022
              ],
              [
                75.425761,
                36.778859
              ],
              [
                75.430108,
                36.873394
              ],
              [
                75.396469,
                36.904185
              ],
              [
                75.413632,
                36.954674
              ],
              [
                75.288685,
                36.97454
              ],
              [
                75.244748,
                36.963326
              ],
              [
                75.168315,
                36.991838
              ],
              [
                75.171976,
                37.013936
              ],
              [
                75.063277,
                37.006251
              ],
              [
                75.032383,
                37.016818
              ],
              [
                75.005609,
                36.994561
              ],
              [
                74.927346,
                36.977904
              ],
              [
                74.938559,
                36.943297
              ],
              [
                74.893935,
                36.939611
              ],
              [
                74.842674,
                37.0205
              ],
              [
                74.847022,
                37.056992
              ],
              [
                74.806746,
                37.054272
              ],
              [
                74.792558,
                37.027544
              ],
              [
                74.739238,
                37.028024
              ],
              [
                74.709032,
                37.08451
              ],
              [
                74.632599,
                37.066592
              ],
              [
                74.617038,
                37.04371
              ],
              [
                74.568066,
                37.032666
              ],
              [
                74.530078,
                37.08211
              ],
              [
                74.498956,
                37.072352
              ],
              [
                74.496439,
                37.115855
              ],
              [
                74.465087,
                37.146867
              ],
              [
                74.487971,
                37.162049
              ],
              [
                74.477216,
                37.199431
              ],
              [
                74.511084,
                37.239988
              ],
              [
                74.544953,
                37.249246
              ],
              [
                74.578592,
                37.231367
              ],
              [
                74.598959,
                37.258343
              ],
              [
                74.64221,
                37.261375
              ],
              [
                74.665781,
                37.235837
              ],
              [
                74.727339,
                37.282915
              ],
              [
                74.753655,
                37.281161
              ],
              [
                74.800339,
                37.247969
              ],
              [
                74.816129,
                37.216519
              ],
              [
                74.911098,
                37.233602
              ],
              [
                74.927117,
                37.277651
              ],
              [
                75.017966,
                37.293763
              ],
              [
                75.078609,
                37.318165
              ],
              [
                75.12575,
                37.322311
              ],
              [
                75.138794,
                37.367741
              ],
              [
                75.12392,
                37.381763
              ],
              [
                75.153211,
                37.4141
              ],
              [
                75.129641,
                37.459156
              ],
              [
                75.078609,
                37.511026
              ],
              [
                75.035358,
                37.500845
              ],
              [
                74.930778,
                37.571759
              ],
              [
                74.892104,
                37.668162
              ],
              [
                74.920938,
                37.684667
              ],
              [
                74.922998,
                37.71719
              ],
              [
                75.006524,
                37.77094
              ],
              [
                74.98959,
                37.797879
              ],
              [
                74.917505,
                37.845079
              ],
              [
                74.937186,
                37.875948
              ],
              [
                74.919107,
                37.90807
              ],
              [
                74.911327,
                37.967056
              ],
              [
                74.925744,
                38.017307
              ],
              [
                74.879289,
                38.021256
              ],
              [
                74.821621,
                38.103033
              ],
              [
                74.804687,
                38.167064
              ],
              [
                74.817044,
                38.215445
              ],
              [
                74.793245,
                38.270878
              ],
              [
                74.806746,
                38.285516
              ]
            ]
          ],
          [
            [
              [
                79.190647,
                39.72068
              ],
              [
                79.240306,
                39.733017
              ],
              [
                79.246484,
                39.784808
              ],
              [
                79.325663,
                39.80345
              ],
              [
                79.28882,
                39.814848
              ],
              [
                79.298889,
                39.844566
              ],
              [
                79.278522,
                39.877658
              ],
              [
                79.406215,
                39.89212
              ],
              [
                79.53551,
                39.862884
              ],
              [
                79.55725,
                39.865039
              ],
              [
                79.606222,
                39.913347
              ],
              [
                79.573955,
                40.012012
              ],
              [
                79.482648,
                40.097652
              ],
              [
                79.214218,
                40.059603
              ],
              [
                79.145108,
                40.256522
              ],
              [
                79.238933,
                40.253002
              ],
              [
                79.343055,
                40.241065
              ],
              [
                79.497294,
                40.211824
              ],
              [
                79.587228,
                40.175678
              ],
              [
                79.731169,
                40.146716
              ],
              [
                79.833461,
                40.131388
              ],
              [
                79.841699,
                40.131388
              ],
              [
                79.860006,
                40.013702
              ],
              [
                79.837809,
                39.980523
              ],
              [
                79.862981,
                39.957165
              ],
              [
                79.846047,
                39.908887
              ],
              [
                79.815382,
                39.882735
              ],
              [
                79.788379,
                39.801909
              ],
              [
                79.764351,
                39.622831
              ],
              [
                79.733686,
                39.4775
              ],
              [
                79.190647,
                39.72068
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 653200,
        "name": "和田地区",
        "center": [
          79.92533,
          37.110687
        ],
        "centroid": [
          81.72906,
          37.578228
        ],
        "childrenNum": 8,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 10,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                80.416089,
                36.279064
              ],
              [
                80.244916,
                36.304114
              ],
              [
                80.291142,
                36.386642
              ],
              [
                80.317001,
                36.394067
              ],
              [
                80.302355,
                36.461987
              ],
              [
                80.318374,
                36.47005
              ],
              [
                80.288625,
                36.532587
              ],
              [
                80.241484,
                36.526465
              ],
              [
                80.233703,
                36.584127
              ],
              [
                80.104866,
                36.717325
              ],
              [
                80.125461,
                36.765689
              ],
              [
                80.087932,
                36.808404
              ],
              [
                80.047427,
                36.823332
              ],
              [
                79.973054,
                36.828629
              ],
              [
                79.891357,
                36.904345
              ],
              [
                79.901655,
                36.949386
              ],
              [
                79.93438,
                36.980627
              ],
              [
                79.949025,
                37.04355
              ],
              [
                79.977859,
                37.052672
              ],
              [
                80.01127,
                37.124009
              ],
              [
                80.04285,
                37.13408
              ],
              [
                80.016991,
                37.15358
              ],
              [
                80.113104,
                37.226737
              ],
              [
                80.103264,
                37.288659
              ],
              [
                80.061615,
                37.290094
              ],
              [
                80.019508,
                37.252916
              ],
              [
                79.937812,
                37.251959
              ],
              [
                79.930718,
                37.262173
              ],
              [
                79.97763,
                37.335544
              ],
              [
                79.990217,
                37.39419
              ],
              [
                80.011041,
                37.40104
              ],
              [
                80.435541,
                37.606714
              ],
              [
                80.486572,
                37.804692
              ],
              [
                80.455907,
                37.862652
              ],
              [
                80.495726,
                37.937016
              ],
              [
                80.477418,
                37.966266
              ],
              [
                80.525475,
                37.979859
              ],
              [
                80.581083,
                38.069575
              ],
              [
                80.559801,
                38.08457
              ],
              [
                80.504879,
                38.039261
              ],
              [
                80.444923,
                38.032944
              ],
              [
                80.433252,
                37.99977
              ],
              [
                80.385196,
                37.934169
              ],
              [
                80.352471,
                37.930057
              ],
              [
                80.306474,
                37.89478
              ],
              [
                80.26986,
                37.801998
              ],
              [
                80.193885,
                37.764758
              ],
              [
                80.198462,
                37.745893
              ],
              [
                80.162991,
                37.7045
              ],
              [
                80.131411,
                37.69863
              ],
              [
                80.089762,
                37.655464
              ],
              [
                80.097085,
                37.637206
              ],
              [
                80.026831,
                37.581135
              ],
              [
                79.960239,
                37.563812
              ],
              [
                79.901655,
                37.508322
              ],
              [
                79.883577,
                37.471411
              ],
              [
                79.818586,
                37.537742
              ],
              [
                79.818128,
                37.574937
              ],
              [
                79.783116,
                37.580499
              ],
              [
                79.694326,
                37.517546
              ],
              [
                79.699131,
                37.561269
              ],
              [
                79.661601,
                37.554116
              ],
              [
                79.632768,
                37.474275
              ],
              [
                79.367083,
                37.325021
              ],
              [
                79.36571,
                37.354354
              ],
              [
                79.33825,
                37.371406
              ],
              [
                79.370974,
                37.385428
              ],
              [
                79.377152,
                37.416489
              ],
              [
                79.249917,
                37.414896
              ],
              [
                79.256325,
                37.236316
              ],
              [
                79.211243,
                37.231367
              ],
              [
                79.197513,
                37.206299
              ],
              [
                78.543028,
                37.574301
              ],
              [
                78.54463,
                37.791066
              ],
              [
                78.350344,
                37.731146
              ],
              [
                78.350344,
                37.68546
              ],
              [
                77.878246,
                37.811662
              ],
              [
                78.006397,
                37.96342
              ],
              [
                78.245078,
                38.188343
              ],
              [
                78.506871,
                38.422471
              ],
              [
                79.003227,
                38.667116
              ],
              [
                79.238704,
                38.794283
              ],
              [
                79.285387,
                38.807253
              ],
              [
                79.333902,
                38.802253
              ],
              [
                79.390425,
                38.830218
              ],
              [
                79.566633,
                38.784437
              ],
              [
                79.599814,
                38.829905
              ],
              [
                79.616062,
                38.919196
              ],
              [
                79.733686,
                39.4775
              ],
              [
                79.764351,
                39.622831
              ],
              [
                80.162305,
                39.464034
              ],
              [
                80.726855,
                39.477346
              ],
              [
                81.062335,
                39.483381
              ],
              [
                81.438092,
                39.484929
              ],
              [
                81.955958,
                39.483691
              ],
              [
                82.101272,
                39.485393
              ],
              [
                82.585041,
                39.484
              ],
              [
                83.151879,
                39.484465
              ],
              [
                83.414817,
                39.483227
              ],
              [
                83.395137,
                39.321629
              ],
              [
                83.387814,
                38.98344
              ],
              [
                83.38667,
                38.388217
              ],
              [
                83.502692,
                38.281581
              ],
              [
                83.648921,
                38.187713
              ],
              [
                83.747781,
                38.115339
              ],
              [
                83.819179,
                38.048104
              ],
              [
                83.885543,
                37.947294
              ],
              [
                83.938405,
                37.832252
              ],
              [
                83.932455,
                37.78552
              ],
              [
                83.963577,
                37.6534
              ],
              [
                83.989894,
                37.612273
              ],
              [
                83.987377,
                37.514525
              ],
              [
                83.974104,
                37.481913
              ],
              [
                83.975706,
                37.410437
              ],
              [
                83.894467,
                37.349732
              ],
              [
                83.862201,
                37.291211
              ],
              [
                83.79126,
                37.250203
              ],
              [
                83.855336,
                37.117773
              ],
              [
                83.860828,
                37.070112
              ],
              [
                83.82101,
                36.963326
              ],
              [
                83.858311,
                36.867459
              ],
              [
                83.833138,
                36.83232
              ],
              [
                83.914148,
                36.766974
              ],
              [
                83.991038,
                36.76858
              ],
              [
                84.013693,
                36.739502
              ],
              [
                84.084634,
                36.69498
              ],
              [
                84.167932,
                36.69482
              ],
              [
                84.201114,
                36.660728
              ],
              [
                84.251917,
                36.643837
              ],
              [
                84.302719,
                36.611171
              ],
              [
                84.346428,
                36.545636
              ],
              [
                84.341851,
                36.490525
              ],
              [
                84.322857,
                36.478757
              ],
              [
                84.308211,
                36.42263
              ],
              [
                84.35581,
                36.397779
              ],
              [
                84.346885,
                36.364524
              ],
              [
                84.363362,
                36.311223
              ],
              [
                84.410274,
                36.309931
              ],
              [
                84.416682,
                36.276639
              ],
              [
                84.537739,
                36.269364
              ],
              [
                84.570463,
                36.225704
              ],
              [
                84.618519,
                36.220042
              ],
              [
                84.637284,
                36.192214
              ],
              [
                84.673441,
                36.182828
              ],
              [
                84.681222,
                36.142844
              ],
              [
                84.775046,
                36.102353
              ],
              [
                84.84347,
                36.09895
              ],
              [
                84.873677,
                35.984486
              ],
              [
                84.861319,
                35.945212
              ],
              [
                84.914182,
                35.854418
              ],
              [
                84.917614,
                35.77442
              ],
              [
                84.986266,
                35.725113
              ],
              [
                84.797015,
                35.646778
              ],
              [
                84.729049,
                35.613368
              ],
              [
                84.702733,
                35.617117
              ],
              [
                84.604331,
                35.589239
              ],
              [
                84.570005,
                35.588261
              ],
              [
                84.448948,
                35.550422
              ],
              [
                84.471375,
                35.526764
              ],
              [
                84.453068,
                35.473385
              ],
              [
                84.416224,
                35.46277
              ],
              [
                84.332926,
                35.413924
              ],
              [
                84.200656,
                35.381071
              ],
              [
                84.161525,
                35.358999
              ],
              [
                84.140929,
                35.378946
              ],
              [
                84.096076,
                35.36276
              ],
              [
                84.077082,
                35.39987
              ],
              [
                84.005913,
                35.422421
              ],
              [
                83.904765,
                35.401831
              ],
              [
                83.885085,
                35.367338
              ],
              [
                83.797439,
                35.354747
              ],
              [
                83.785539,
                35.363087
              ],
              [
                83.684621,
                35.362596
              ],
              [
                83.622376,
                35.335448
              ],
              [
                83.599263,
                35.351149
              ],
              [
                83.541824,
                35.341663
              ],
              [
                83.540222,
                35.364068
              ],
              [
                83.502463,
                35.36047
              ],
              [
                83.448915,
                35.382052
              ],
              [
                83.280259,
                35.401177
              ],
              [
                83.242272,
                35.419807
              ],
              [
                83.178196,
                35.389572
              ],
              [
                83.126707,
                35.398562
              ],
              [
                83.089177,
                35.425526
              ],
              [
                83.067666,
                35.462607
              ],
              [
                82.999014,
                35.484488
              ],
              [
                82.971782,
                35.548301
              ],
              [
                82.981622,
                35.599837
              ],
              [
                82.956221,
                35.636186
              ],
              [
                82.961026,
                35.671541
              ],
              [
                82.894663,
                35.673984
              ],
              [
                82.873609,
                35.688805
              ],
              [
                82.788709,
                35.684571
              ],
              [
                82.73127,
                35.637815
              ],
              [
                82.628521,
                35.692225
              ],
              [
                82.546138,
                35.708508
              ],
              [
                82.501972,
                35.701344
              ],
              [
                82.468561,
                35.717462
              ],
              [
                82.425081,
                35.712741
              ],
              [
                82.392815,
                35.656228
              ],
              [
                82.336062,
                35.65134
              ],
              [
                82.350251,
                35.611086
              ],
              [
                82.328053,
                35.559394
              ],
              [
                82.272216,
                35.550259
              ],
              [
                82.234457,
                35.520399
              ],
              [
                82.044291,
                35.452971
              ],
              [
                82.029416,
                35.429284
              ],
              [
                82.054588,
                35.355237
              ],
              [
                82.044291,
                35.33234
              ],
              [
                81.991886,
                35.305836
              ],
              [
                81.955272,
                35.307308
              ],
              [
                81.92804,
                35.271138
              ],
              [
                81.853895,
                35.258696
              ],
              [
                81.804237,
                35.270647
              ],
              [
                81.736729,
                35.262298
              ],
              [
                81.674942,
                35.233478
              ],
              [
                81.513151,
                35.234952
              ],
              [
                81.494158,
                35.292253
              ],
              [
                81.523907,
                35.312708
              ],
              [
                81.58455,
                35.46277
              ],
              [
                81.586152,
                35.570648
              ],
              [
                81.56876,
                35.629178
              ],
              [
                81.463493,
                35.650036
              ],
              [
                81.399646,
                35.707368
              ],
              [
                81.410402,
                35.76108
              ],
              [
                81.371041,
                35.796867
              ],
              [
                81.372414,
                35.83654
              ],
              [
                81.42253,
                35.879767
              ],
              [
                81.466468,
                35.95203
              ],
              [
                81.493929,
                36.016605
              ],
              [
                81.460518,
                36.057788
              ],
              [
                81.473333,
                36.116932
              ],
              [
                81.429396,
                36.157091
              ],
              [
                81.442897,
                36.22813
              ],
              [
                81.436261,
                36.256754
              ],
              [
                81.394383,
                36.31914
              ],
              [
                81.357082,
                36.443601
              ],
              [
                81.330994,
                36.421177
              ],
              [
                81.330079,
                36.405848
              ],
              [
                81.275386,
                36.142196
              ],
              [
                81.274928,
                36.142196
              ],
              [
                81.047461,
                36.250771
              ],
              [
                81.049978,
                36.315101
              ],
              [
                81.033959,
                36.280033
              ],
              [
                81.030984,
                36.280195
              ],
              [
                81.031213,
                36.27874
              ],
              [
                81.03373,
                36.275992
              ],
              [
                81.031671,
                36.259341
              ],
              [
                81.008787,
                36.259826
              ],
              [
                81.007185,
                36.260473
              ],
              [
                80.81862,
                36.298135
              ],
              [
                80.81656,
                36.296034
              ],
              [
                80.817018,
                36.293287
              ],
              [
                80.81473,
                36.292479
              ],
              [
                80.41792,
                36.278255
              ],
              [
                80.416089,
                36.279064
              ]
            ]
          ],
          [
            [
              [
                79.883577,
                37.471411
              ],
              [
                79.901655,
                37.508322
              ],
              [
                79.960239,
                37.563812
              ],
              [
                80.026831,
                37.581135
              ],
              [
                80.097085,
                37.637206
              ],
              [
                80.089762,
                37.655464
              ],
              [
                80.131411,
                37.69863
              ],
              [
                80.162991,
                37.7045
              ],
              [
                80.198462,
                37.745893
              ],
              [
                80.193885,
                37.764758
              ],
              [
                80.26986,
                37.801998
              ],
              [
                80.306474,
                37.89478
              ],
              [
                80.352471,
                37.930057
              ],
              [
                80.385196,
                37.934169
              ],
              [
                80.433252,
                37.99977
              ],
              [
                80.444923,
                38.032944
              ],
              [
                80.504879,
                38.039261
              ],
              [
                80.559801,
                38.08457
              ],
              [
                80.581083,
                38.069575
              ],
              [
                80.525475,
                37.979859
              ],
              [
                80.477418,
                37.966266
              ],
              [
                80.495726,
                37.937016
              ],
              [
                80.455907,
                37.862652
              ],
              [
                80.486572,
                37.804692
              ],
              [
                80.435541,
                37.606714
              ],
              [
                80.011041,
                37.40104
              ],
              [
                79.990217,
                37.39419
              ],
              [
                79.97763,
                37.335544
              ],
              [
                79.930718,
                37.262173
              ],
              [
                79.937812,
                37.251959
              ],
              [
                80.019508,
                37.252916
              ],
              [
                80.061615,
                37.290094
              ],
              [
                80.103264,
                37.288659
              ],
              [
                80.113104,
                37.226737
              ],
              [
                80.016991,
                37.15358
              ],
              [
                80.04285,
                37.13408
              ],
              [
                80.01127,
                37.124009
              ],
              [
                79.977859,
                37.052672
              ],
              [
                79.949025,
                37.04355
              ],
              [
                79.93438,
                36.980627
              ],
              [
                79.901655,
                36.949386
              ],
              [
                79.891357,
                36.904345
              ],
              [
                79.973054,
                36.828629
              ],
              [
                80.047427,
                36.823332
              ],
              [
                80.087932,
                36.808404
              ],
              [
                80.125461,
                36.765689
              ],
              [
                80.104866,
                36.717325
              ],
              [
                80.233703,
                36.584127
              ],
              [
                80.241484,
                36.526465
              ],
              [
                80.288625,
                36.532587
              ],
              [
                80.318374,
                36.47005
              ],
              [
                80.302355,
                36.461987
              ],
              [
                80.317001,
                36.394067
              ],
              [
                80.291142,
                36.386642
              ],
              [
                80.244916,
                36.304114
              ],
              [
                80.416089,
                36.279064
              ],
              [
                80.41792,
                36.278255
              ],
              [
                80.81473,
                36.292479
              ],
              [
                80.817018,
                36.293287
              ],
              [
                80.81656,
                36.296034
              ],
              [
                80.81862,
                36.298135
              ],
              [
                81.007185,
                36.260473
              ],
              [
                81.008787,
                36.259826
              ],
              [
                81.031671,
                36.259341
              ],
              [
                81.047461,
                36.250771
              ],
              [
                81.274928,
                36.142196
              ],
              [
                81.275386,
                36.142196
              ],
              [
                81.330079,
                36.405848
              ],
              [
                81.330994,
                36.421177
              ],
              [
                81.357082,
                36.443601
              ],
              [
                81.394383,
                36.31914
              ],
              [
                81.436261,
                36.256754
              ],
              [
                81.442897,
                36.22813
              ],
              [
                81.429396,
                36.157091
              ],
              [
                81.473333,
                36.116932
              ],
              [
                81.460518,
                36.057788
              ],
              [
                81.493929,
                36.016605
              ],
              [
                81.466468,
                35.95203
              ],
              [
                81.42253,
                35.879767
              ],
              [
                81.372414,
                35.83654
              ],
              [
                81.371041,
                35.796867
              ],
              [
                81.410402,
                35.76108
              ],
              [
                81.399646,
                35.707368
              ],
              [
                81.463493,
                35.650036
              ],
              [
                81.56876,
                35.629178
              ],
              [
                81.586152,
                35.570648
              ],
              [
                81.58455,
                35.46277
              ],
              [
                81.523907,
                35.312708
              ],
              [
                81.494158,
                35.292253
              ],
              [
                81.441295,
                35.333485
              ],
              [
                81.385458,
                35.335448
              ],
              [
                81.363947,
                35.354583
              ],
              [
                81.314289,
                35.337247
              ],
              [
                81.285226,
                35.345425
              ],
              [
                81.266232,
                35.322688
              ],
              [
                81.219549,
                35.319089
              ],
              [
                81.191859,
                35.365212
              ],
              [
                81.142429,
                35.365212
              ],
              [
                81.099179,
                35.407551
              ],
              [
                81.054555,
                35.402321
              ],
              [
                81.031671,
                35.380581
              ],
              [
                81.026178,
                35.31189
              ],
              [
                80.963705,
                35.311072
              ],
              [
                80.924573,
                35.330704
              ],
              [
                80.894366,
                35.323997
              ],
              [
                80.844479,
                35.345425
              ],
              [
                80.760037,
                35.33463
              ],
              [
                80.689325,
                35.339046
              ],
              [
                80.691156,
                35.364395
              ],
              [
                80.656372,
                35.393985
              ],
              [
                80.599848,
                35.409675
              ],
              [
                80.568039,
                35.39137
              ],
              [
                80.51655,
                35.392187
              ],
              [
                80.444237,
                35.417192
              ],
              [
                80.419979,
                35.442353
              ],
              [
                80.374669,
                35.388101
              ],
              [
                80.304415,
                35.379764
              ],
              [
                80.268029,
                35.295853
              ],
              [
                80.362769,
                35.208907
              ],
              [
                80.257731,
                35.203337
              ],
              [
                80.223176,
                35.177282
              ],
              [
                80.236449,
                35.148268
              ],
              [
                80.118139,
                35.066088
              ],
              [
                80.07832,
                35.07659
              ],
              [
                80.03095,
                35.03884
              ],
              [
                80.042621,
                34.98021
              ],
              [
                80.036671,
                34.903122
              ],
              [
                80.003489,
                34.8949
              ],
              [
                79.995938,
                34.856078
              ],
              [
                79.926828,
                34.849332
              ],
              [
                79.946279,
                34.822835
              ],
              [
                79.899138,
                34.733572
              ],
              [
                79.907147,
                34.683793
              ],
              [
                79.866872,
                34.671426
              ],
              [
                79.885865,
                34.642892
              ],
              [
                79.843759,
                34.557398
              ],
              [
                79.860922,
                34.528164
              ],
              [
                79.801194,
                34.478923
              ],
              [
                79.699818,
                34.477931
              ],
              [
                79.675561,
                34.45115
              ],
              [
                79.581278,
                34.45611
              ],
              [
                79.54535,
                34.476278
              ],
              [
                79.504617,
                34.454787
              ],
              [
                79.435049,
                34.447678
              ],
              [
                79.362964,
                34.427999
              ],
              [
                79.326808,
                34.443048
              ],
              [
                79.274174,
                34.436102
              ],
              [
                79.22955,
                34.413939
              ],
              [
                79.161356,
                34.441394
              ],
              [
                79.078287,
                34.411624
              ],
              [
                79.052199,
                34.427172
              ],
              [
                79.010779,
                34.399878
              ],
              [
                79.048995,
                34.348409
              ],
              [
                79.039612,
                34.334502
              ],
              [
                78.974393,
                34.361651
              ],
              [
                78.958603,
                34.38631
              ],
              [
                78.892468,
                34.355858
              ],
              [
                78.855853,
                34.411789
              ],
              [
                78.742806,
                34.454457
              ],
              [
                78.758596,
                34.481567
              ],
              [
                78.70848,
                34.522052
              ],
              [
                78.61763,
                34.536258
              ],
              [
                78.583991,
                34.506356
              ],
              [
                78.563166,
                34.512965
              ],
              [
                78.558132,
                34.56037
              ],
              [
                78.492912,
                34.578367
              ],
              [
                78.433871,
                34.548645
              ],
              [
                78.427693,
                34.594049
              ],
              [
                78.345996,
                34.604117
              ],
              [
                78.280777,
                34.623094
              ],
              [
                78.259952,
                34.710169
              ],
              [
                78.21304,
                34.717916
              ],
              [
                78.229974,
                34.774263
              ],
              [
                78.237526,
                34.8824
              ],
              [
                78.209607,
                34.889308
              ],
              [
                78.181918,
                34.936991
              ],
              [
                78.198852,
                34.977745
              ],
              [
                78.160635,
                34.991052
              ],
              [
                78.122877,
                35.03687
              ],
              [
                78.150795,
                35.069534
              ],
              [
                78.124707,
                35.108254
              ],
              [
                78.07871,
                35.099888
              ],
              [
                78.062692,
                35.114651
              ],
              [
                78.060174,
                35.180232
              ],
              [
                78.016923,
                35.228237
              ],
              [
                78.021271,
                35.315162
              ],
              [
                78.013262,
                35.365866
              ],
              [
                78.107087,
                35.437289
              ],
              [
                78.140497,
                35.494773
              ],
              [
                78.048504,
                35.491345
              ],
              [
                78.035917,
                35.467833
              ],
              [
                78.010058,
                35.491508
              ],
              [
                77.951475,
                35.47861
              ],
              [
                77.917607,
                35.491019
              ],
              [
                77.915089,
                35.464893
              ],
              [
                77.816459,
                35.518604
              ],
              [
                77.781675,
                35.554011
              ],
              [
                77.814399,
                35.602609
              ],
              [
                77.844149,
                35.612716
              ],
              [
                77.851929,
                35.687014
              ],
              [
                77.821722,
                35.714858
              ],
              [
                77.826299,
                35.748225
              ],
              [
                77.851701,
                35.748225
              ],
              [
                77.835224,
                35.804836
              ],
              [
                77.878704,
                35.811828
              ],
              [
                77.866804,
                35.880904
              ],
              [
                77.844835,
                35.912577
              ],
              [
                77.887857,
                35.908355
              ],
              [
                77.923785,
                35.930764
              ],
              [
                77.872983,
                35.994707
              ],
              [
                77.800669,
                36.027308
              ],
              [
                77.742544,
                36.039145
              ],
              [
                77.732246,
                36.100247
              ],
              [
                77.791287,
                36.112234
              ],
              [
                77.790829,
                36.131508
              ],
              [
                77.854675,
                36.182504
              ],
              [
                77.910055,
                36.198525
              ],
              [
                77.810967,
                36.294579
              ],
              [
                77.724465,
                36.28262
              ],
              [
                77.610045,
                36.35968
              ],
              [
                77.624462,
                36.387772
              ],
              [
                77.579151,
                36.448924
              ],
              [
                77.484869,
                36.493104
              ],
              [
                77.42537,
                36.492137
              ],
              [
                77.40775,
                36.545959
              ],
              [
                77.503634,
                36.56126
              ],
              [
                77.534756,
                36.610849
              ],
              [
                77.582126,
                36.610366
              ],
              [
                77.576405,
                36.633701
              ],
              [
                77.623089,
                36.643193
              ],
              [
                77.64849,
                36.669252
              ],
              [
                77.61691,
                36.699964
              ],
              [
                77.542308,
                36.746732
              ],
              [
                77.49265,
                36.792991
              ],
              [
                77.505693,
                36.842911
              ],
              [
                77.528806,
                36.865052
              ],
              [
                77.518966,
                36.930315
              ],
              [
                77.608214,
                36.935284
              ],
              [
                77.642311,
                36.975981
              ],
              [
                77.651236,
                37.056512
              ],
              [
                77.681214,
                37.128485
              ],
              [
                77.664967,
                37.14463
              ],
              [
                77.642769,
                37.266481
              ],
              [
                77.600205,
                37.297591
              ],
              [
                77.64254,
                37.350369
              ],
              [
                77.639794,
                37.376505
              ],
              [
                77.667713,
                37.444035
              ],
              [
                77.664051,
                37.581611
              ],
              [
                77.699979,
                37.588762
              ],
              [
                77.741399,
                37.637365
              ],
              [
                77.752155,
                37.678954
              ],
              [
                77.806161,
                37.727023
              ],
              [
                77.878246,
                37.811662
              ],
              [
                78.350344,
                37.68546
              ],
              [
                78.359956,
                37.653876
              ],
              [
                78.330664,
                37.603537
              ],
              [
                78.414191,
                37.621167
              ],
              [
                78.441881,
                37.642128
              ],
              [
                78.491081,
                37.616879
              ],
              [
                78.488793,
                37.568739
              ],
              [
                78.521746,
                37.555706
              ],
              [
                78.543028,
                37.574301
              ],
              [
                79.197513,
                37.206299
              ],
              [
                79.251061,
                37.197036
              ],
              [
                79.254494,
                37.214283
              ],
              [
                79.374406,
                37.174033
              ],
              [
                79.367083,
                37.325021
              ],
              [
                79.632768,
                37.474275
              ],
              [
                79.643294,
                37.424292
              ],
              [
                79.618122,
                37.392438
              ],
              [
                79.572354,
                37.38256
              ],
              [
                79.580363,
                37.340008
              ],
              [
                79.581965,
                37.333153
              ],
              [
                79.584024,
                37.330761
              ],
              [
                79.587686,
                37.325021
              ],
              [
                79.589745,
                37.322789
              ],
              [
                79.765037,
                37.28132
              ],
              [
                79.776022,
                37.28467
              ],
              [
                79.806686,
                37.29791
              ],
              [
                79.811034,
                37.364554
              ],
              [
                79.889298,
                37.454381
              ],
              [
                79.883577,
                37.471411
              ]
            ]
          ],
          [
            [
              [
                79.709887,
                37.379533
              ],
              [
                79.704166,
                37.377461
              ],
              [
                79.702335,
                37.376505
              ],
              [
                79.680824,
                37.375071
              ],
              [
                79.610341,
                37.373797
              ],
              [
                79.618122,
                37.392438
              ],
              [
                79.643294,
                37.424292
              ],
              [
                79.686774,
                37.447537
              ],
              [
                79.694326,
                37.517546
              ],
              [
                79.783116,
                37.580499
              ],
              [
                79.783802,
                37.537265
              ],
              [
                79.818586,
                37.537742
              ],
              [
                79.883577,
                37.471411
              ],
              [
                79.889298,
                37.454381
              ],
              [
                79.811034,
                37.364554
              ],
              [
                79.751307,
                37.376505
              ],
              [
                79.728652,
                37.383197
              ],
              [
                79.709887,
                37.379533
              ]
            ]
          ],
          [
            [
              [
                79.776022,
                37.28467
              ],
              [
                79.765037,
                37.28132
              ],
              [
                79.589745,
                37.322789
              ],
              [
                79.587686,
                37.325021
              ],
              [
                79.584024,
                37.330761
              ],
              [
                79.581965,
                37.333153
              ],
              [
                79.580363,
                37.340008
              ],
              [
                79.610341,
                37.373797
              ],
              [
                79.680824,
                37.375071
              ],
              [
                79.702335,
                37.376505
              ],
              [
                79.704166,
                37.377461
              ],
              [
                79.709887,
                37.379533
              ],
              [
                79.728652,
                37.383197
              ],
              [
                79.751307,
                37.376505
              ],
              [
                79.811034,
                37.364554
              ],
              [
                79.806686,
                37.29791
              ],
              [
                79.776022,
                37.28467
              ]
            ]
          ],
          [
            [
              [
                81.031213,
                36.27874
              ],
              [
                81.030984,
                36.280195
              ],
              [
                81.033959,
                36.280033
              ],
              [
                81.03373,
                36.275992
              ],
              [
                81.031213,
                36.27874
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 654000,
        "name": "伊犁哈萨克自治州",
        "center": [
          81.317946,
          43.92186
        ],
        "centroid": [
          82.213264,
          43.349079
        ],
        "childrenNum": 11,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 11,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                84.950567,
                43.48427
              ],
              [
                84.92425,
                43.425175
              ],
              [
                84.834316,
                43.43595
              ],
              [
                84.786717,
                43.465936
              ],
              [
                84.716005,
                43.453128
              ],
              [
                84.661541,
                43.491253
              ],
              [
                84.633165,
                43.432747
              ],
              [
                84.692893,
                43.40187
              ],
              [
                84.676187,
                43.37229
              ],
              [
                84.623554,
                43.338028
              ],
              [
                84.552842,
                43.331757
              ],
              [
                84.532246,
                43.292802
              ],
              [
                84.538425,
                43.262877
              ],
              [
                84.581447,
                43.266965
              ],
              [
                84.564742,
                43.231037
              ],
              [
                84.602501,
                43.228553
              ],
              [
                84.653761,
                43.175351
              ],
              [
                84.574124,
                43.168332
              ],
              [
                84.540714,
                43.152974
              ],
              [
                84.504328,
                43.164383
              ],
              [
                84.423318,
                43.16175
              ],
              [
                84.413707,
                43.102341
              ],
              [
                84.359014,
                43.144197
              ],
              [
                84.363133,
                43.15941
              ],
              [
                84.279149,
                43.174912
              ],
              [
                84.22949,
                43.171256
              ],
              [
                84.104314,
                43.145514
              ],
              [
                84.038866,
                43.146245
              ],
              [
                84.043214,
                43.132199
              ],
              [
                83.96312,
                43.156192
              ],
              [
                83.912546,
                43.128102
              ],
              [
                83.801558,
                43.133516
              ],
              [
                83.758078,
                43.149317
              ],
              [
                83.713226,
                43.137467
              ],
              [
                83.679815,
                43.09751
              ],
              [
                83.627639,
                43.08067
              ],
              [
                83.56631,
                43.092385
              ],
              [
                83.565852,
                43.07569
              ],
              [
                83.504752,
                43.058845
              ],
              [
                83.407037,
                43.052105
              ],
              [
                83.361726,
                43.028218
              ],
              [
                83.325112,
                43.047416
              ],
              [
                83.2663,
                43.017957
              ],
              [
                83.159889,
                43.006374
              ],
              [
                83.135632,
                42.992149
              ],
              [
                83.037688,
                42.996402
              ],
              [
                83.013889,
                43.007107
              ],
              [
                82.941575,
                42.987309
              ],
              [
                82.892603,
                42.992296
              ],
              [
                82.858963,
                42.971026
              ],
              [
                82.82418,
                42.980269
              ],
              [
                82.82418,
                42.954886
              ],
              [
                82.789396,
                42.933897
              ],
              [
                82.712505,
                42.951657
              ],
              [
                82.653236,
                42.934337
              ],
              [
                82.649345,
                42.88367
              ],
              [
                82.576803,
                42.88558
              ],
              [
                82.532637,
                42.901739
              ],
              [
                82.512727,
                42.858541
              ],
              [
                82.470392,
                42.843253
              ],
              [
                82.480003,
                42.800603
              ],
              [
                82.507006,
                42.799427
              ],
              [
                82.599229,
                42.719635
              ],
              [
                82.634242,
                42.651982
              ],
              [
                82.621198,
                42.621005
              ],
              [
                82.638132,
                42.597689
              ],
              [
                82.62074,
                42.558562
              ],
              [
                82.585499,
                42.543939
              ],
              [
                82.407232,
                42.55162
              ],
              [
                82.363752,
                42.538768
              ],
              [
                82.366498,
                42.50404
              ],
              [
                82.295329,
                42.48275
              ],
              [
                82.230109,
                42.494578
              ],
              [
                82.189147,
                42.467221
              ],
              [
                82.142692,
                42.489256
              ],
              [
                82.133538,
                42.440444
              ],
              [
                82.07793,
                42.43852
              ],
              [
                82.065344,
                42.420316
              ],
              [
                81.984563,
                42.425793
              ],
              [
                81.959848,
                42.402255
              ],
              [
                81.867397,
                42.411138
              ],
              [
                81.865795,
                42.384041
              ],
              [
                81.820256,
                42.3833
              ],
              [
                81.805152,
                42.405957
              ],
              [
                81.751832,
                42.365525
              ],
              [
                81.672196,
                42.369969
              ],
              [
                81.66144,
                42.392186
              ],
              [
                81.630775,
                42.373821
              ],
              [
                81.582032,
                42.374117
              ],
              [
                81.50949,
                42.352042
              ],
              [
                81.478825,
                42.360636
              ],
              [
                81.386602,
                42.354413
              ],
              [
                81.352734,
                42.332331
              ],
              [
                81.318637,
                42.357821
              ],
              [
                81.285455,
                42.332479
              ],
              [
                81.271267,
                42.343595
              ],
              [
                81.195521,
                42.343595
              ],
              [
                81.152498,
                42.323585
              ],
              [
                81.160508,
                42.259954
              ],
              [
                81.098263,
                42.291703
              ],
              [
                81.048147,
                42.284732
              ],
              [
                81.025263,
                42.342854
              ],
              [
                80.985216,
                42.380634
              ],
              [
                80.963018,
                42.361673
              ],
              [
                80.898028,
                42.369228
              ],
              [
                80.803974,
                42.339742
              ],
              [
                80.761639,
                42.361525
              ],
              [
                80.657287,
                42.366117
              ],
              [
                80.62914,
                42.353375
              ],
              [
                80.592296,
                42.366117
              ],
              [
                80.531883,
                42.360932
              ],
              [
                80.471469,
                42.321806
              ],
              [
                80.415403,
                42.304754
              ],
              [
                80.372381,
                42.326698
              ],
              [
                80.324324,
                42.315134
              ],
              [
                80.284048,
                42.32062
              ],
              [
                80.228669,
                42.359895
              ],
              [
                80.239882,
                42.389224
              ],
              [
                80.206013,
                42.431565
              ],
              [
                80.210361,
                42.469588
              ],
              [
                80.265283,
                42.502266
              ],
              [
                80.221575,
                42.533302
              ],
              [
                80.163907,
                42.62794
              ],
              [
                80.178324,
                42.667907
              ],
              [
                80.228211,
                42.692966
              ],
              [
                80.226151,
                42.713006
              ],
              [
                80.258876,
                42.790746
              ],
              [
                80.260249,
                42.824873
              ],
              [
                80.320663,
                42.838549
              ],
              [
                80.356133,
                42.828256
              ],
              [
                80.425929,
                42.842518
              ],
              [
                80.427074,
                42.857071
              ],
              [
                80.505795,
                42.882495
              ],
              [
                80.603052,
                42.894394
              ],
              [
                80.591381,
                42.923179
              ],
              [
                80.487259,
                42.948869
              ],
              [
                80.392519,
                43.002122
              ],
              [
                80.378559,
                43.031443
              ],
              [
                80.416776,
                43.056794
              ],
              [
                80.482453,
                43.069539
              ],
              [
                80.556368,
                43.104391
              ],
              [
                80.593441,
                43.133516
              ],
              [
                80.665754,
                43.147562
              ],
              [
                80.732576,
                43.130882
              ],
              [
                80.752714,
                43.148147
              ],
              [
                80.794592,
                43.13732
              ],
              [
                80.804432,
                43.178421
              ],
              [
                80.788642,
                43.242285
              ],
              [
                80.76919,
                43.265359
              ],
              [
                80.776971,
                43.307979
              ],
              [
                80.692758,
                43.32038
              ],
              [
                80.68635,
                43.333653
              ],
              [
                80.73578,
                43.389632
              ],
              [
                80.760952,
                43.446432
              ],
              [
                80.755002,
                43.494162
              ],
              [
                80.632344,
                43.663384
              ],
              [
                80.707632,
                43.673827
              ],
              [
                80.782463,
                43.696882
              ],
              [
                80.756833,
                43.784959
              ],
              [
                80.775369,
                43.80334
              ],
              [
                80.727084,
                43.811443
              ],
              [
                80.672391,
                43.844713
              ],
              [
                80.71999,
                43.890971
              ],
              [
                80.739899,
                43.888659
              ],
              [
                80.764156,
                43.854257
              ],
              [
                80.862328,
                43.867702
              ],
              [
                81.039909,
                43.849052
              ],
              [
                81.125953,
                43.870593
              ],
              [
                81.072175,
                43.895595
              ],
              [
                81.014508,
                43.873773
              ],
              [
                80.985674,
                43.893139
              ],
              [
                80.917021,
                43.889382
              ],
              [
                80.873771,
                43.91452
              ],
              [
                80.793905,
                43.906431
              ],
              [
                80.804661,
                43.930407
              ],
              [
                80.905579,
                43.946722
              ],
              [
                80.9351,
                43.929685
              ],
              [
                80.978122,
                43.908742
              ],
              [
                81.071031,
                43.907731
              ],
              [
                81.082931,
                43.930984
              ],
              [
                81.076295,
                43.96058
              ],
              [
                81.079269,
                43.96592
              ],
              [
                81.11268,
                43.99694
              ],
              [
                81.125495,
                44.055185
              ],
              [
                81.143345,
                44.052015
              ],
              [
                81.205589,
                44.098256
              ],
              [
                81.208564,
                44.144892
              ],
              [
                81.241975,
                44.206154
              ],
              [
                81.290947,
                44.233601
              ],
              [
                81.325044,
                44.226417
              ],
              [
                81.370355,
                44.239778
              ],
              [
                81.363947,
                44.253424
              ],
              [
                81.401477,
                44.284867
              ],
              [
                81.333054,
                44.348135
              ],
              [
                81.334884,
                44.380388
              ],
              [
                81.363947,
                44.405175
              ],
              [
                81.358455,
                44.44255
              ],
              [
                81.425734,
                44.440546
              ],
              [
                81.459603,
                44.450996
              ],
              [
                81.591415,
                44.41649
              ],
              [
                81.618647,
                44.427374
              ],
              [
                81.650913,
                44.38655
              ],
              [
                81.700114,
                44.394287
              ],
              [
                81.713845,
                44.365769
              ],
              [
                81.751603,
                44.347131
              ],
              [
                81.777691,
                44.352006
              ],
              [
                81.834901,
                44.327484
              ],
              [
                82.032391,
                44.285442
              ],
              [
                82.082736,
                44.291757
              ],
              [
                82.167636,
                44.263476
              ],
              [
                82.283658,
                44.249115
              ],
              [
                82.36032,
                44.265343
              ],
              [
                82.402197,
                44.215927
              ],
              [
                82.444991,
                44.182434
              ],
              [
                82.5379,
                44.156402
              ],
              [
                82.57337,
                44.13669
              ],
              [
                82.672916,
                44.114237
              ],
              [
                82.705411,
                44.071178
              ],
              [
                82.781158,
                44.085871
              ],
              [
                82.899697,
                44.053312
              ],
              [
                82.945923,
                44.083566
              ],
              [
                83.126707,
                44.092928
              ],
              [
                83.243416,
                44.073195
              ],
              [
                83.238381,
                44.043512
              ],
              [
                83.263554,
                44.041206
              ],
              [
                83.310466,
                44.008334
              ],
              [
                83.399485,
                44.014823
              ],
              [
                83.429921,
                44.006171
              ],
              [
                83.468824,
                44.036882
              ],
              [
                83.502692,
                44.022321
              ],
              [
                83.499946,
                44.001988
              ],
              [
                83.571802,
                44.010353
              ],
              [
                83.621003,
                43.965631
              ],
              [
                83.68668,
                43.981648
              ],
              [
                83.738398,
                43.9473
              ],
              [
                83.804533,
                43.939648
              ],
              [
                83.886229,
                43.952785
              ],
              [
                83.939549,
                43.901663
              ],
              [
                83.983944,
                43.910042
              ],
              [
                84.029941,
                43.879844
              ],
              [
                84.064267,
                43.885769
              ],
              [
                84.088753,
                43.855992
              ],
              [
                84.114841,
                43.854546
              ],
              [
                84.084405,
                43.825477
              ],
              [
                84.22949,
                43.774246
              ],
              [
                84.253747,
                43.785248
              ],
              [
                84.281437,
                43.765848
              ],
              [
                84.287845,
                43.730795
              ],
              [
                84.339563,
                43.726158
              ],
              [
                84.36382,
                43.743399
              ],
              [
                84.395171,
                43.724709
              ],
              [
                84.44071,
                43.738474
              ],
              [
                84.492199,
                43.734707
              ],
              [
                84.504557,
                43.750207
              ],
              [
                84.5533,
                43.750931
              ],
              [
                84.634767,
                43.719638
              ],
              [
                84.597695,
                43.669476
              ],
              [
                84.708454,
                43.63161
              ],
              [
                84.786717,
                43.641913
              ],
              [
                84.821043,
                43.581229
              ],
              [
                84.84942,
                43.570044
              ],
              [
                84.895188,
                43.577162
              ],
              [
                84.899078,
                43.521502
              ],
              [
                84.950567,
                43.48427
              ]
            ]
          ],
          [
            [
              [
                81.079269,
                43.96592
              ],
              [
                80.987047,
                43.990016
              ],
              [
                80.9351,
                43.929685
              ],
              [
                80.905579,
                43.946722
              ],
              [
                80.804661,
                43.930407
              ],
              [
                80.793905,
                43.906431
              ],
              [
                80.739899,
                43.888659
              ],
              [
                80.71999,
                43.890971
              ],
              [
                80.736237,
                43.921164
              ],
              [
                80.725482,
                43.969816
              ],
              [
                80.741729,
                44.016842
              ],
              [
                80.679256,
                44.062534
              ],
              [
                80.699394,
                44.067577
              ],
              [
                80.673764,
                44.100272
              ],
              [
                80.701911,
                44.133093
              ],
              [
                80.637607,
                44.180852
              ],
              [
                80.566895,
                44.17323
              ],
              [
                80.553851,
                44.101424
              ],
              [
                80.586347,
                44.017707
              ],
              [
                80.531196,
                44.029674
              ],
              [
                80.521356,
                44.07017
              ],
              [
                80.440804,
                44.083854
              ],
              [
                80.39412,
                44.127192
              ],
              [
                80.406936,
                44.149784
              ],
              [
                80.400986,
                44.19868
              ],
              [
                80.413114,
                44.264625
              ],
              [
                80.382907,
                44.401164
              ],
              [
                80.350641,
                44.48448
              ],
              [
                80.413114,
                44.610944
              ],
              [
                80.314942,
                44.704649
              ],
              [
                80.220888,
                44.733287
              ],
              [
                80.178781,
                44.796923
              ],
              [
                80.187935,
                44.825799
              ],
              [
                80.227753,
                44.825088
              ],
              [
                80.262766,
                44.843573
              ],
              [
                80.311051,
                44.811576
              ],
              [
                80.348581,
                44.805175
              ],
              [
                80.397324,
                44.771733
              ],
              [
                80.482911,
                44.739412
              ],
              [
                80.590008,
                44.723743
              ],
              [
                80.636005,
                44.73115
              ],
              [
                80.638293,
                44.710635
              ],
              [
                80.691842,
                44.674144
              ],
              [
                80.66072,
                44.637202
              ],
              [
                80.707632,
                44.601807
              ],
              [
                80.755002,
                44.61023
              ],
              [
                80.843564,
                44.568391
              ],
              [
                80.873771,
                44.563677
              ],
              [
                80.890018,
                44.52981
              ],
              [
                80.99826,
                44.535527
              ],
              [
                81.048376,
                44.50336
              ],
              [
                81.112222,
                44.506792
              ],
              [
                81.211311,
                44.462875
              ],
              [
                81.358455,
                44.44255
              ],
              [
                81.363947,
                44.405175
              ],
              [
                81.334884,
                44.380388
              ],
              [
                81.333054,
                44.348135
              ],
              [
                81.401477,
                44.284867
              ],
              [
                81.363947,
                44.253424
              ],
              [
                81.370355,
                44.239778
              ],
              [
                81.325044,
                44.226417
              ],
              [
                81.290947,
                44.233601
              ],
              [
                81.241975,
                44.206154
              ],
              [
                81.208564,
                44.144892
              ],
              [
                81.205589,
                44.098256
              ],
              [
                81.143345,
                44.052015
              ],
              [
                81.125495,
                44.055185
              ],
              [
                81.11268,
                43.99694
              ],
              [
                81.079269,
                43.96592
              ]
            ]
          ],
          [
            [
              [
                84.77825,
                44.390848
              ],
              [
                84.798159,
                44.438971
              ],
              [
                84.86109,
                44.495637
              ],
              [
                84.853081,
                44.564963
              ],
              [
                84.879627,
                44.628498
              ],
              [
                84.854225,
                44.685692
              ],
              [
                84.792667,
                44.803752
              ],
              [
                84.851021,
                44.826368
              ],
              [
                84.898163,
                44.802899
              ],
              [
                84.954,
                44.799911
              ],
              [
                85.010295,
                44.755219
              ],
              [
                85.04668,
                44.740266
              ],
              [
                85.052859,
                44.698093
              ],
              [
                85.025398,
                44.68669
              ],
              [
                85.018304,
                44.61965
              ],
              [
                85.202978,
                44.636061
              ],
              [
                85.238678,
                44.598809
              ],
              [
                85.229753,
                44.550675
              ],
              [
                85.254696,
                44.476754
              ],
              [
                85.212819,
                44.479187
              ],
              [
                85.177348,
                44.324902
              ],
              [
                85.113273,
                44.34369
              ],
              [
                84.974595,
                44.384687
              ],
              [
                84.77825,
                44.390848
              ]
            ]
          ],
          [
            [
              [
                80.624792,
                43.754407
              ],
              [
                80.576735,
                43.783945
              ],
              [
                80.660949,
                43.778734
              ],
              [
                80.669873,
                43.753683
              ],
              [
                80.624792,
                43.754407
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 654200,
        "name": "塔城地区",
        "center": [
          82.985732,
          46.746301
        ],
        "centroid": [
          84.156301,
          45.398077
        ],
        "childrenNum": 7,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 12,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                85.380101,
                46.143628
              ],
              [
                85.282844,
                46.090811
              ],
              [
                85.263392,
                46.053114
              ],
              [
                85.293142,
                45.993246
              ],
              [
                85.259044,
                45.978199
              ],
              [
                85.288565,
                45.967608
              ],
              [
                85.258358,
                45.925364
              ],
              [
                85.22838,
                45.850136
              ],
              [
                85.193825,
                45.802491
              ],
              [
                85.129978,
                45.74543
              ],
              [
                85.059953,
                45.713098
              ],
              [
                85.023796,
                45.721218
              ],
              [
                84.956746,
                45.707777
              ],
              [
                84.910291,
                45.648938
              ],
              [
                84.847589,
                45.631414
              ],
              [
                84.791981,
                45.663794
              ],
              [
                84.772071,
                45.648658
              ],
              [
                84.80594,
                45.608275
              ],
              [
                84.783513,
                45.597613
              ],
              [
                84.739576,
                45.520819
              ],
              [
                84.710742,
                45.451797
              ],
              [
                84.651701,
                45.395646
              ],
              [
                84.623325,
                45.343808
              ],
              [
                84.579388,
                45.31068
              ],
              [
                84.58877,
                45.241401
              ],
              [
                84.633394,
                45.185888
              ],
              [
                84.668864,
                45.158607
              ],
              [
                84.635682,
                44.867026
              ],
              [
                84.648726,
                44.866316
              ],
              [
                84.652388,
                44.791231
              ],
              [
                84.626071,
                44.791801
              ],
              [
                84.677331,
                44.739839
              ],
              [
                84.708454,
                44.733857
              ],
              [
                84.782598,
                44.669153
              ],
              [
                84.800677,
                44.683554
              ],
              [
                84.854225,
                44.685692
              ],
              [
                84.879627,
                44.628498
              ],
              [
                84.853081,
                44.564963
              ],
              [
                84.86109,
                44.495637
              ],
              [
                84.798159,
                44.438971
              ],
              [
                84.77825,
                44.390848
              ],
              [
                84.779166,
                44.343546
              ],
              [
                84.798159,
                44.258737
              ],
              [
                84.792209,
                44.224262
              ],
              [
                84.737974,
                44.126185
              ],
              [
                84.797244,
                44.161436
              ],
              [
                84.830426,
                44.160142
              ],
              [
                84.917385,
                44.17927
              ],
              [
                84.939354,
                44.252275
              ],
              [
                84.969103,
                44.297354
              ],
              [
                84.996106,
                44.310699
              ],
              [
                85.065445,
                44.317299
              ],
              [
                85.108467,
                44.309551
              ],
              [
                85.113273,
                44.34369
              ],
              [
                85.177348,
                44.324902
              ],
              [
                85.212819,
                44.479187
              ],
              [
                85.254696,
                44.476754
              ],
              [
                85.229753,
                44.550675
              ],
              [
                85.238678,
                44.598809
              ],
              [
                85.202978,
                44.636061
              ],
              [
                85.018304,
                44.61965
              ],
              [
                85.025398,
                44.68669
              ],
              [
                85.052859,
                44.698093
              ],
              [
                85.04668,
                44.740266
              ],
              [
                85.010295,
                44.755219
              ],
              [
                85.047367,
                44.770167
              ],
              [
                85.021965,
                44.814421
              ],
              [
                85.027229,
                44.886208
              ],
              [
                85.051486,
                44.931793
              ],
              [
                85.156066,
                44.970958
              ],
              [
                85.171627,
                45.022711
              ],
              [
                85.240737,
                45.019735
              ],
              [
                85.258358,
                45.031639
              ],
              [
                85.238449,
                45.080223
              ],
              [
                85.250348,
                45.158607
              ],
              [
                85.205953,
                45.207365
              ],
              [
                85.201834,
                45.244224
              ],
              [
                85.239593,
                45.29305
              ],
              [
                85.245772,
                45.329008
              ],
              [
                85.291769,
                45.332391
              ],
              [
                85.666838,
                45.331123
              ],
              [
                85.670729,
                45.278097
              ],
              [
                85.668898,
                44.9193
              ],
              [
                85.781488,
                44.922849
              ],
              [
                85.868447,
                44.86589
              ],
              [
                85.891331,
                44.813141
              ],
              [
                85.942134,
                44.759633
              ],
              [
                85.906892,
                44.736563
              ],
              [
                85.955635,
                44.638629
              ],
              [
                85.988588,
                44.637773
              ],
              [
                86.01788,
                44.603378
              ],
              [
                86.068225,
                44.601807
              ],
              [
                86.06525,
                44.564105
              ],
              [
                86.084015,
                44.490345
              ],
              [
                86.130927,
                44.463447
              ],
              [
                86.122689,
                44.448992
              ],
              [
                86.111018,
                44.459011
              ],
              [
                86.043281,
                44.452141
              ],
              [
                86.011015,
                44.411334
              ],
              [
                85.981037,
                44.407037
              ],
              [
                85.912156,
                44.426515
              ],
              [
                85.904833,
                44.332647
              ],
              [
                85.954262,
                44.309551
              ],
              [
                85.985842,
                44.157265
              ],
              [
                86.065937,
                44.160286
              ],
              [
                86.096144,
                44.125897
              ],
              [
                86.038018,
                44.062102
              ],
              [
                85.967535,
                44.003575
              ],
              [
                85.955407,
                43.967074
              ],
              [
                85.965018,
                43.931706
              ],
              [
                85.91925,
                43.934306
              ],
              [
                85.883779,
                43.920586
              ],
              [
                85.786293,
                43.839507
              ],
              [
                85.767757,
                43.791183
              ],
              [
                85.779199,
                43.763676
              ],
              [
                85.739152,
                43.731809
              ],
              [
                85.719701,
                43.678758
              ],
              [
                85.719701,
                43.638575
              ],
              [
                85.697274,
                43.619272
              ],
              [
                85.665008,
                43.622901
              ],
              [
                85.579879,
                43.539528
              ],
              [
                85.5975,
                43.530806
              ],
              [
                85.519694,
                43.536185
              ],
              [
                85.483537,
                43.498235
              ],
              [
                85.434108,
                43.478887
              ],
              [
                85.328154,
                43.486743
              ],
              [
                85.31511,
                43.529207
              ],
              [
                85.286734,
                43.502307
              ],
              [
                85.241881,
                43.52092
              ],
              [
                85.170483,
                43.510742
              ],
              [
                85.156981,
                43.546795
              ],
              [
                85.056292,
                43.563942
              ],
              [
                85.020364,
                43.51365
              ],
              [
                84.979859,
                43.47976
              ],
              [
                84.950567,
                43.48427
              ],
              [
                84.899078,
                43.521502
              ],
              [
                84.895188,
                43.577162
              ],
              [
                84.84942,
                43.570044
              ],
              [
                84.821043,
                43.581229
              ],
              [
                84.786717,
                43.641913
              ],
              [
                84.708454,
                43.63161
              ],
              [
                84.597695,
                43.669476
              ],
              [
                84.634767,
                43.719638
              ],
              [
                84.5533,
                43.750931
              ],
              [
                84.504557,
                43.750207
              ],
              [
                84.492199,
                43.734707
              ],
              [
                84.44071,
                43.738474
              ],
              [
                84.395171,
                43.724709
              ],
              [
                84.36382,
                43.743399
              ],
              [
                84.339563,
                43.726158
              ],
              [
                84.287845,
                43.730795
              ],
              [
                84.281437,
                43.765848
              ],
              [
                84.253747,
                43.785248
              ],
              [
                84.22949,
                43.774246
              ],
              [
                84.084405,
                43.825477
              ],
              [
                84.114841,
                43.854546
              ],
              [
                84.088753,
                43.855992
              ],
              [
                84.064267,
                43.885769
              ],
              [
                84.029941,
                43.879844
              ],
              [
                83.983944,
                43.910042
              ],
              [
                83.939549,
                43.901663
              ],
              [
                83.886229,
                43.952785
              ],
              [
                83.804533,
                43.939648
              ],
              [
                83.738398,
                43.9473
              ],
              [
                83.68668,
                43.981648
              ],
              [
                83.621003,
                43.965631
              ],
              [
                83.571802,
                44.010353
              ],
              [
                83.499946,
                44.001988
              ],
              [
                83.502692,
                44.022321
              ],
              [
                83.468824,
                44.036882
              ],
              [
                83.448457,
                44.076508
              ],
              [
                83.445482,
                44.121723
              ],
              [
                83.412071,
                44.168916
              ],
              [
                83.448915,
                44.254285
              ],
              [
                83.439761,
                44.282571
              ],
              [
                83.486216,
                44.317442
              ],
              [
                83.489877,
                44.367346
              ],
              [
                83.531526,
                44.414915
              ],
              [
                83.517567,
                44.467597
              ],
              [
                83.602924,
                44.462875
              ],
              [
                83.63931,
                44.474751
              ],
              [
                83.752815,
                44.46173
              ],
              [
                83.79332,
                44.466739
              ],
              [
                83.791947,
                44.520375
              ],
              [
                83.745492,
                44.552962
              ],
              [
                83.75968,
                44.633207
              ],
              [
                83.794464,
                44.719469
              ],
              [
                83.795837,
                44.756785
              ],
              [
                83.730389,
                44.801049
              ],
              [
                83.701784,
                44.853951
              ],
              [
                83.666313,
                44.888339
              ],
              [
                83.600178,
                44.894163
              ],
              [
                83.573862,
                44.931225
              ],
              [
                83.513448,
                44.939316
              ],
              [
                83.474087,
                44.976064
              ],
              [
                83.391476,
                44.980887
              ],
              [
                83.263554,
                44.998329
              ],
              [
                83.09444,
                45.028947
              ],
              [
                83.002675,
                45.050766
              ],
              [
                82.855531,
                45.100891
              ],
              [
                82.757816,
                45.152102
              ],
              [
                82.683214,
                45.153799
              ],
              [
                82.582753,
                45.219089
              ],
              [
                82.60106,
                45.346203
              ],
              [
                82.546825,
                45.42591
              ],
              [
                82.447966,
                45.461361
              ],
              [
                82.282056,
                45.538939
              ],
              [
                82.266724,
                45.620196
              ],
              [
                82.288464,
                45.655385
              ],
              [
                82.290065,
                45.716458
              ],
              [
                82.340182,
                45.772569
              ],
              [
                82.349564,
                45.823035
              ],
              [
                82.336062,
                45.882249
              ],
              [
                82.342699,
                45.935126
              ],
              [
                82.401282,
                45.972207
              ],
              [
                82.461467,
                45.980011
              ],
              [
                82.51822,
                46.153769
              ],
              [
                82.608841,
                46.295124
              ],
              [
                82.727151,
                46.495503
              ],
              [
                82.774292,
                46.60017
              ],
              [
                82.788938,
                46.677815
              ],
              [
                82.829672,
                46.772655
              ],
              [
                82.878415,
                46.797232
              ],
              [
                82.876355,
                46.823855
              ],
              [
                82.923496,
                46.931995
              ],
              [
                82.937913,
                47.014085
              ],
              [
                82.98803,
                47.058771
              ],
              [
                83.031738,
                47.16821
              ],
              [
                83.02739,
                47.215491
              ],
              [
                83.1084,
                47.222164
              ],
              [
                83.154854,
                47.236052
              ],
              [
                83.20703,
                47.21372
              ],
              [
                83.222134,
                47.186882
              ],
              [
                83.257833,
                47.173253
              ],
              [
                83.306347,
                47.179659
              ],
              [
                83.332435,
                47.167801
              ],
              [
                83.370422,
                47.178569
              ],
              [
                83.418937,
                47.11884
              ],
              [
                83.463332,
                47.132074
              ],
              [
                83.57615,
                47.059181
              ],
              [
                83.700639,
                47.032128
              ],
              [
                83.699266,
                47.015589
              ],
              [
                83.766546,
                47.027071
              ],
              [
                83.885772,
                46.981948
              ],
              [
                83.932913,
                46.970046
              ],
              [
                83.951449,
                46.987283
              ],
              [
                84.002709,
                46.990566
              ],
              [
                84.086465,
                46.965257
              ],
              [
                84.150311,
                46.977297
              ],
              [
                84.195164,
                47.003557
              ],
              [
                84.289218,
                46.994805
              ],
              [
                84.336588,
                47.005335
              ],
              [
                84.3716,
                46.993301
              ],
              [
                84.425378,
                47.00889
              ],
              [
                84.506616,
                46.973056
              ],
              [
                84.56314,
                46.99166
              ],
              [
                84.668635,
                46.994805
              ],
              [
                84.748043,
                47.009847
              ],
              [
                84.795413,
                46.972509
              ],
              [
                84.84942,
                46.956909
              ],
              [
                84.86704,
                46.927476
              ],
              [
                84.943702,
                46.861982
              ],
              [
                84.881,
                46.855949
              ],
              [
                84.821959,
                46.832086
              ],
              [
                84.819899,
                46.81425
              ],
              [
                84.761316,
                46.794075
              ],
              [
                84.764291,
                46.760432
              ],
              [
                84.725617,
                46.716046
              ],
              [
                84.722642,
                46.685381
              ],
              [
                84.686256,
                46.636253
              ],
              [
                84.710742,
                46.599068
              ],
              [
                84.779394,
                46.554412
              ],
              [
                84.814865,
                46.547241
              ],
              [
                84.893815,
                46.493571
              ],
              [
                84.881,
                46.431832
              ],
              [
                84.901366,
                46.402942
              ],
              [
                84.900222,
                46.356741
              ],
              [
                84.919674,
                46.320195
              ],
              [
                84.969332,
                46.275309
              ],
              [
                85.077574,
                46.21263
              ],
              [
                85.264765,
                46.182235
              ],
              [
                85.296345,
                46.164602
              ],
              [
                85.380101,
                46.143628
              ]
            ]
          ],
          [
            [
              [
                85.245772,
                45.329008
              ],
              [
                85.239593,
                45.375508
              ],
              [
                85.28353,
                45.421406
              ],
              [
                85.388111,
                45.436182
              ],
              [
                85.434336,
                45.459814
              ],
              [
                85.491775,
                45.51267
              ],
              [
                85.547384,
                45.593123
              ],
              [
                85.596813,
                45.641929
              ],
              [
                85.59155,
                45.654404
              ],
              [
                85.621299,
                45.763058
              ],
              [
                85.642353,
                45.78921
              ],
              [
                85.814212,
                45.895369
              ],
              [
                85.839613,
                45.921877
              ],
              [
                85.886297,
                45.938751
              ],
              [
                85.880347,
                45.952973
              ],
              [
                85.931836,
                45.975273
              ],
              [
                85.95472,
                46.001325
              ],
              [
                85.962501,
                46.044764
              ],
              [
                86.024288,
                46.068001
              ],
              [
                85.993165,
                46.123897
              ],
              [
                85.903002,
                46.181819
              ],
              [
                85.813754,
                46.178209
              ],
              [
                85.791557,
                46.192924
              ],
              [
                85.679882,
                46.190842
              ],
              [
                85.648302,
                46.211936
              ],
              [
                85.557453,
                46.198059
              ],
              [
                85.437998,
                46.150296
              ],
              [
                85.419462,
                46.128066
              ],
              [
                85.380101,
                46.143628
              ],
              [
                85.296345,
                46.164602
              ],
              [
                85.264765,
                46.182235
              ],
              [
                85.077574,
                46.21263
              ],
              [
                84.969332,
                46.275309
              ],
              [
                84.919674,
                46.320195
              ],
              [
                84.900222,
                46.356741
              ],
              [
                84.901366,
                46.402942
              ],
              [
                84.881,
                46.431832
              ],
              [
                84.893815,
                46.493571
              ],
              [
                84.814865,
                46.547241
              ],
              [
                84.779394,
                46.554412
              ],
              [
                84.710742,
                46.599068
              ],
              [
                84.686256,
                46.636253
              ],
              [
                84.722642,
                46.685381
              ],
              [
                84.725617,
                46.716046
              ],
              [
                84.764291,
                46.760432
              ],
              [
                84.761316,
                46.794075
              ],
              [
                84.819899,
                46.81425
              ],
              [
                84.821959,
                46.832086
              ],
              [
                84.881,
                46.855949
              ],
              [
                84.943702,
                46.861982
              ],
              [
                84.980088,
                46.883092
              ],
              [
                84.987182,
                46.918164
              ],
              [
                85.081922,
                46.939799
              ],
              [
                85.111442,
                46.973193
              ],
              [
                85.175518,
                46.998087
              ],
              [
                85.213963,
                47.041147
              ],
              [
                85.276436,
                47.068878
              ],
              [
                85.326095,
                47.044836
              ],
              [
                85.441202,
                47.063415
              ],
              [
                85.540061,
                47.057405
              ],
              [
                85.679882,
                47.051531
              ],
              [
                85.797735,
                47.053853
              ],
              [
                85.953347,
                47.078028
              ],
              [
                86.005752,
                47.06642
              ],
              [
                86.082642,
                47.025568
              ],
              [
                86.197749,
                47.041557
              ],
              [
                86.377618,
                47.087312
              ],
              [
                86.492724,
                47.08977
              ],
              [
                86.49364,
                47.064235
              ],
              [
                86.581057,
                47.051941
              ],
              [
                87.037365,
                47.11884
              ],
              [
                87.029585,
                46.970867
              ],
              [
                87.068488,
                46.932543
              ],
              [
                87.203732,
                46.849505
              ],
              [
                87.201673,
                46.715771
              ],
              [
                87.037136,
                46.503509
              ],
              [
                87.300761,
                46.060489
              ],
              [
                87.336002,
                46.005085
              ],
              [
                87.339435,
                45.957852
              ],
              [
                87.336918,
                45.330559
              ],
              [
                86.487003,
                45.332532
              ],
              [
                85.666838,
                45.331123
              ],
              [
                85.291769,
                45.332391
              ],
              [
                85.245772,
                45.329008
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 654300,
        "name": "阿勒泰地区",
        "center": [
          88.13963,
          47.848393
        ],
        "centroid": [
          87.048189,
          48.013014
        ],
        "childrenNum": 7,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 13,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                88.43009,
                47.258239
              ],
              [
                88.339698,
                47.239728
              ],
              [
                88.312237,
                47.258103
              ],
              [
                88.262121,
                47.238503
              ],
              [
                88.098042,
                47.28096
              ],
              [
                88.038772,
                47.312237
              ],
              [
                87.98591,
                47.316859
              ],
              [
                87.906731,
                47.341322
              ],
              [
                87.862565,
                47.317539
              ],
              [
                87.828696,
                47.351919
              ],
              [
                87.873091,
                47.346213
              ],
              [
                87.853411,
                47.367267
              ],
              [
                87.831671,
                47.357216
              ],
              [
                87.803066,
                47.382339
              ],
              [
                87.753637,
                47.380167
              ],
              [
                87.771715,
                47.357081
              ],
              [
                87.556147,
                47.356673
              ],
              [
                87.579489,
                47.406229
              ],
              [
                87.554774,
                47.42129
              ],
              [
                87.540357,
                47.4297
              ],
              [
                87.431658,
                47.435397
              ],
              [
                87.385661,
                47.399307
              ],
              [
                87.312203,
                47.38519
              ],
              [
                87.252933,
                47.362649
              ],
              [
                87.151786,
                47.344175
              ],
              [
                87.017914,
                47.3034
              ],
              [
                87.016312,
                47.284633
              ],
              [
                87.037365,
                47.11884
              ],
              [
                86.581057,
                47.051941
              ],
              [
                86.49364,
                47.064235
              ],
              [
                86.492724,
                47.08977
              ],
              [
                86.377618,
                47.087312
              ],
              [
                86.197749,
                47.041557
              ],
              [
                86.082642,
                47.025568
              ],
              [
                86.005752,
                47.06642
              ],
              [
                85.953347,
                47.078028
              ],
              [
                85.797735,
                47.053853
              ],
              [
                85.679882,
                47.051531
              ],
              [
                85.540061,
                47.057405
              ],
              [
                85.546926,
                47.096732
              ],
              [
                85.582854,
                47.142849
              ],
              [
                85.6824,
                47.222709
              ],
              [
                85.701165,
                47.288441
              ],
              [
                85.675992,
                47.321617
              ],
              [
                85.701393,
                47.38424
              ],
              [
                85.684917,
                47.428886
              ],
              [
                85.652193,
                47.455195
              ],
              [
                85.610086,
                47.511295
              ],
              [
                85.617638,
                47.550691
              ],
              [
                85.546926,
                48.008265
              ],
              [
                85.531822,
                48.046349
              ],
              [
                85.55196,
                48.081591
              ],
              [
                85.55608,
                48.139962
              ],
              [
                85.592236,
                48.196396
              ],
              [
                85.622215,
                48.202945
              ],
              [
                85.633885,
                48.232871
              ],
              [
                85.661804,
                48.243422
              ],
              [
                85.694986,
                48.301476
              ],
              [
                85.71192,
                48.361462
              ],
              [
                85.758604,
                48.403943
              ],
              [
                85.838698,
                48.42883
              ],
              [
                85.916504,
                48.437876
              ],
              [
                86.053808,
                48.441069
              ],
              [
                86.226125,
                48.432422
              ],
              [
                86.270978,
                48.452906
              ],
              [
                86.3021,
                48.490793
              ],
              [
                86.371439,
                48.493052
              ],
              [
                86.41263,
                48.481091
              ],
              [
                86.585634,
                48.542194
              ],
              [
                86.594559,
                48.576697
              ],
              [
                86.642615,
                48.629601
              ],
              [
                86.693647,
                48.643779
              ],
              [
                86.702343,
                48.66537
              ],
              [
                86.781064,
                48.732069
              ],
              [
                86.754289,
                48.780979
              ],
              [
                86.764358,
                48.803699
              ],
              [
                86.818365,
                48.830369
              ],
              [
                86.822484,
                48.84581
              ],
              [
                86.782894,
                48.886172
              ],
              [
                86.75818,
                48.894873
              ],
              [
                86.730032,
                48.955475
              ],
              [
                86.73255,
                48.995354
              ],
              [
                86.772368,
                49.027707
              ],
              [
                86.836214,
                49.051103
              ],
              [
                86.847199,
                49.101015
              ],
              [
                86.881982,
                49.129494
              ],
              [
                86.953838,
                49.1312
              ],
              [
                87.002124,
                49.142613
              ],
              [
                87.088397,
                49.133693
              ],
              [
                87.112654,
                49.155597
              ],
              [
                87.211742,
                49.140645
              ],
              [
                87.238745,
                49.114535
              ],
              [
                87.30488,
                49.112304
              ],
              [
                87.388865,
                49.097995
              ],
              [
                87.436692,
                49.075277
              ],
              [
                87.511523,
                49.101671
              ],
              [
                87.495504,
                49.131987
              ],
              [
                87.517473,
                49.145499
              ],
              [
                87.563012,
                49.142482
              ],
              [
                87.685442,
                49.159924
              ],
              [
                87.700546,
                49.175788
              ],
              [
                87.820916,
                49.173822
              ],
              [
                87.820687,
                49.148253
              ],
              [
                87.845631,
                49.146023
              ],
              [
                87.867142,
                49.10876
              ],
              [
                87.858217,
                49.07357
              ],
              [
                87.835333,
                49.054257
              ],
              [
                87.88316,
                49.023762
              ],
              [
                87.884076,
                48.993906
              ],
              [
                87.911766,
                48.979959
              ],
              [
                87.871947,
                48.963638
              ],
              [
                87.876524,
                48.949155
              ],
              [
                87.814508,
                48.945336
              ],
              [
                87.759815,
                48.925974
              ],
              [
                87.742423,
                48.881293
              ],
              [
                87.780869,
                48.872194
              ],
              [
                87.828925,
                48.825617
              ],
              [
                87.826408,
                48.800926
              ],
              [
                87.872176,
                48.799473
              ],
              [
                87.938998,
                48.757852
              ],
              [
                87.961424,
                48.773447
              ],
              [
                88.029161,
                48.750185
              ],
              [
                88.061885,
                48.714344
              ],
              [
                88.090719,
                48.719768
              ],
              [
                88.089575,
                48.694893
              ],
              [
                88.026644,
                48.653185
              ],
              [
                88.02733,
                48.627348
              ],
              [
                87.961653,
                48.599377
              ],
              [
                87.973095,
                48.576034
              ],
              [
                88.041289,
                48.5483
              ],
              [
                88.101017,
                48.548034
              ],
              [
                88.13008,
                48.521613
              ],
              [
                88.151819,
                48.526261
              ],
              [
                88.196672,
                48.493982
              ],
              [
                88.257544,
                48.497702
              ],
              [
                88.363039,
                48.460485
              ],
              [
                88.36098,
                48.433353
              ],
              [
                88.438099,
                48.393559
              ],
              [
                88.503776,
                48.412994
              ],
              [
                88.535585,
                48.369056
              ],
              [
                88.573344,
                48.369722
              ],
              [
                88.606068,
                48.337876
              ],
              [
                88.575175,
                48.277595
              ],
              [
                88.598288,
                48.227262
              ],
              [
                88.64131,
                48.181959
              ],
              [
                88.584328,
                48.162035
              ],
              [
                88.474027,
                48.093512
              ],
              [
                88.468993,
                48.054391
              ],
              [
                88.491877,
                48.001155
              ],
              [
                88.386381,
                47.943432
              ],
              [
                88.433522,
                47.911321
              ],
              [
                88.497598,
                47.912799
              ],
              [
                88.563961,
                47.881476
              ],
              [
                88.544968,
                47.850806
              ],
              [
                88.57815,
                47.829811
              ],
              [
                88.562588,
                47.800458
              ],
              [
                88.624833,
                47.779712
              ],
              [
                88.525059,
                47.776478
              ],
              [
                88.531237,
                47.748982
              ],
              [
                88.511786,
                47.713243
              ],
              [
                88.46167,
                47.682069
              ],
              [
                88.422996,
                47.612231
              ],
              [
                88.405833,
                47.557863
              ],
              [
                88.352284,
                47.523889
              ],
              [
                88.345876,
                47.48664
              ],
              [
                88.316585,
                47.455331
              ],
              [
                88.307202,
                47.3155
              ],
              [
                88.390271,
                47.265043
              ],
              [
                88.43009,
                47.258239
              ]
            ]
          ],
          [
            [
              [
                88.64131,
                48.181959
              ],
              [
                88.700808,
                48.181024
              ],
              [
                88.721404,
                48.160564
              ],
              [
                88.797379,
                48.133941
              ],
              [
                88.824382,
                48.106768
              ],
              [
                88.930564,
                48.119486
              ],
              [
                88.953906,
                48.090833
              ],
              [
                89.027364,
                48.050906
              ],
              [
                89.044756,
                48.009875
              ],
              [
                89.078395,
                47.986931
              ],
              [
                89.15643,
                47.996861
              ],
              [
                89.23149,
                47.980221
              ],
              [
                89.282064,
                47.994044
              ],
              [
                89.308609,
                48.021946
              ],
              [
                89.359869,
                48.026372
              ],
              [
                89.38138,
                48.046215
              ],
              [
                89.408612,
                48.034953
              ],
              [
                89.498089,
                48.028383
              ],
              [
                89.568801,
                48.037769
              ],
              [
                89.599466,
                48.015643
              ],
              [
                89.603356,
                47.963172
              ],
              [
                89.645463,
                47.947864
              ],
              [
                89.650955,
                47.91374
              ],
              [
                89.735397,
                47.897476
              ],
              [
                89.762171,
                47.835734
              ],
              [
                89.933344,
                47.835734
              ],
              [
                89.958059,
                47.842867
              ],
              [
                89.960576,
                47.885779
              ],
              [
                90.086667,
                47.865605
              ],
              [
                90.070648,
                47.820522
              ],
              [
                90.076141,
                47.777421
              ],
              [
                90.134953,
                47.723226
              ],
              [
                90.192621,
                47.722416
              ],
              [
                90.21642,
                47.705418
              ],
              [
                90.331527,
                47.681529
              ],
              [
                90.384847,
                47.644257
              ],
              [
                90.346173,
                47.637367
              ],
              [
                90.376151,
                47.603039
              ],
              [
                90.398348,
                47.547714
              ],
              [
                90.468145,
                47.497614
              ],
              [
                90.474323,
                47.46238
              ],
              [
                90.458991,
                47.438923
              ],
              [
                90.468602,
                47.404872
              ],
              [
                90.507734,
                47.399986
              ],
              [
                90.526499,
                47.378945
              ],
              [
                90.488283,
                47.317267
              ],
              [
                90.521465,
                47.284633
              ],
              [
                90.561512,
                47.207046
              ],
              [
                90.579819,
                47.198191
              ],
              [
                90.653735,
                47.111608
              ],
              [
                90.69218,
                47.080622
              ],
              [
                90.76724,
                46.99248
              ],
              [
                90.830857,
                46.995899
              ],
              [
                90.901569,
                46.960741
              ],
              [
                90.922165,
                46.938704
              ],
              [
                90.929945,
                46.893095
              ],
              [
                90.957864,
                46.879528
              ],
              [
                90.94276,
                46.825775
              ],
              [
                91.019422,
                46.766201
              ],
              [
                91.053977,
                46.717421
              ],
              [
                91.036356,
                46.670386
              ],
              [
                91.01782,
                46.582257
              ],
              [
                91.067936,
                46.579225
              ],
              [
                91.079149,
                46.558824
              ],
              [
                91.037958,
                46.500886
              ],
              [
                91.025601,
                46.443854
              ],
              [
                90.996309,
                46.419393
              ],
              [
                90.983494,
                46.374866
              ],
              [
                90.900425,
                46.312301
              ],
              [
                90.955575,
                46.233855
              ],
              [
                90.948024,
                46.219151
              ],
              [
                90.984638,
                46.160574
              ],
              [
                91.021481,
                46.121118
              ],
              [
                91.014845,
                46.066471
              ],
              [
                91.028347,
                46.023049
              ],
              [
                90.85008,
                45.887972
              ],
              [
                90.799964,
                45.83505
              ],
              [
                90.714835,
                45.728916
              ],
              [
                90.670211,
                45.547926
              ],
              [
                90.671355,
                45.487654
              ],
              [
                90.494919,
                45.42028
              ],
              [
                90.481646,
                45.397335
              ],
              [
                90.379583,
                45.276968
              ],
              [
                90.353267,
                45.23067
              ],
              [
                90.292166,
                45.177267
              ],
              [
                90.251204,
                45.087727
              ],
              [
                90.22237,
                45.064364
              ],
              [
                90.23816,
                45.001732
              ],
              [
                88.004446,
                45.002015
              ],
              [
                87.336231,
                45.001874
              ],
              [
                87.336918,
                45.330559
              ],
              [
                87.339435,
                45.957852
              ],
              [
                87.336002,
                46.005085
              ],
              [
                87.300761,
                46.060489
              ],
              [
                87.037136,
                46.503509
              ],
              [
                87.201673,
                46.715771
              ],
              [
                87.203732,
                46.849505
              ],
              [
                87.068488,
                46.932543
              ],
              [
                87.029585,
                46.970867
              ],
              [
                87.037365,
                47.11884
              ],
              [
                87.016312,
                47.284633
              ],
              [
                87.017914,
                47.3034
              ],
              [
                87.151786,
                47.344175
              ],
              [
                87.252933,
                47.362649
              ],
              [
                87.312203,
                47.38519
              ],
              [
                87.385661,
                47.399307
              ],
              [
                87.431658,
                47.435397
              ],
              [
                87.540357,
                47.4297
              ],
              [
                87.481316,
                47.411114
              ],
              [
                87.490241,
                47.400664
              ],
              [
                87.554774,
                47.42129
              ],
              [
                87.579489,
                47.406229
              ],
              [
                87.556147,
                47.356673
              ],
              [
                87.527542,
                47.338604
              ],
              [
                87.595508,
                47.289121
              ],
              [
                87.66805,
                47.267492
              ],
              [
                87.74311,
                47.204866
              ],
              [
                87.79437,
                47.184156
              ],
              [
                87.886364,
                47.161121
              ],
              [
                87.91085,
                47.172572
              ],
              [
                88.005361,
                47.145713
              ],
              [
                88.05502,
                47.147486
              ],
              [
                88.077904,
                47.128663
              ],
              [
                88.176763,
                47.114883
              ],
              [
                88.273563,
                47.132892
              ],
              [
                88.342673,
                47.174344
              ],
              [
                88.343359,
                47.232512
              ],
              [
                88.428717,
                47.234691
              ],
              [
                88.43009,
                47.258239
              ],
              [
                88.390271,
                47.265043
              ],
              [
                88.307202,
                47.3155
              ],
              [
                88.316585,
                47.455331
              ],
              [
                88.345876,
                47.48664
              ],
              [
                88.352284,
                47.523889
              ],
              [
                88.405833,
                47.557863
              ],
              [
                88.422996,
                47.612231
              ],
              [
                88.46167,
                47.682069
              ],
              [
                88.511786,
                47.713243
              ],
              [
                88.531237,
                47.748982
              ],
              [
                88.525059,
                47.776478
              ],
              [
                88.624833,
                47.779712
              ],
              [
                88.562588,
                47.800458
              ],
              [
                88.57815,
                47.829811
              ],
              [
                88.544968,
                47.850806
              ],
              [
                88.563961,
                47.881476
              ],
              [
                88.497598,
                47.912799
              ],
              [
                88.433522,
                47.911321
              ],
              [
                88.386381,
                47.943432
              ],
              [
                88.491877,
                48.001155
              ],
              [
                88.468993,
                48.054391
              ],
              [
                88.474027,
                48.093512
              ],
              [
                88.584328,
                48.162035
              ],
              [
                88.64131,
                48.181959
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659001,
        "name": "石河子市",
        "center": [
          86.041075,
          44.305886
        ],
        "centroid": [
          86.038213,
          44.306831
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 14,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                86.122689,
                44.448992
              ],
              [
                86.127037,
                44.374225
              ],
              [
                86.141683,
                44.32734
              ],
              [
                86.123833,
                44.266204
              ],
              [
                86.128868,
                44.211472
              ],
              [
                86.096144,
                44.125897
              ],
              [
                86.065937,
                44.160286
              ],
              [
                85.985842,
                44.157265
              ],
              [
                85.954262,
                44.309551
              ],
              [
                85.904833,
                44.332647
              ],
              [
                85.912156,
                44.426515
              ],
              [
                85.981037,
                44.407037
              ],
              [
                86.011015,
                44.411334
              ],
              [
                86.043281,
                44.452141
              ],
              [
                86.111018,
                44.459011
              ],
              [
                86.122689,
                44.448992
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659002,
        "name": "阿拉尔市",
        "center": [
          81.285884,
          40.541914
        ],
        "centroid": [
          81.316957,
          40.6005
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 15,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                81.884102,
                40.941004
              ],
              [
                81.84314,
                40.886152
              ],
              [
                81.812704,
                40.813197
              ],
              [
                81.743365,
                40.733326
              ],
              [
                81.822544,
                40.685144
              ],
              [
                81.944745,
                40.494356
              ],
              [
                81.978613,
                40.468429
              ],
              [
                81.880441,
                40.467667
              ],
              [
                81.760299,
                40.437914
              ],
              [
                81.377449,
                40.43944
              ],
              [
                81.281107,
                40.43593
              ],
              [
                81.210395,
                40.397307
              ],
              [
                81.003065,
                40.396849
              ],
              [
                80.981097,
                40.423872
              ],
              [
                80.931438,
                40.432573
              ],
              [
                80.907868,
                40.420362
              ],
              [
                80.740128,
                40.369357
              ],
              [
                80.679485,
                40.381425
              ],
              [
                80.605798,
                40.423262
              ],
              [
                80.633717,
                40.465378
              ],
              [
                80.683833,
                40.464616
              ],
              [
                80.659347,
                40.484597
              ],
              [
                80.673993,
                40.511585
              ],
              [
                80.723422,
                40.488409
              ],
              [
                80.729372,
                40.452411
              ],
              [
                80.809924,
                40.454699
              ],
              [
                80.827774,
                40.476513
              ],
              [
                80.789786,
                40.479564
              ],
              [
                80.780404,
                40.505944
              ],
              [
                80.741272,
                40.533228
              ],
              [
                80.696419,
                40.520121
              ],
              [
                80.70214,
                40.546028
              ],
              [
                80.670789,
                40.569031
              ],
              [
                80.621588,
                40.556845
              ],
              [
                80.592296,
                40.619884
              ],
              [
                80.683375,
                40.666744
              ],
              [
                80.725939,
                40.701412
              ],
              [
                80.791846,
                40.703236
              ],
              [
                80.867363,
                40.658987
              ],
              [
                80.990479,
                40.702476
              ],
              [
                81.140828,
                40.698979
              ],
              [
                81.32985,
                40.762947
              ],
              [
                81.32596,
                40.805154
              ],
              [
                81.385687,
                40.825033
              ],
              [
                81.457085,
                40.804699
              ],
              [
                81.863506,
                40.944033
              ],
              [
                81.884102,
                40.941004
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659003,
        "name": "图木舒克市",
        "center": [
          79.077978,
          39.867316
        ],
        "centroid": [
          79.163596,
          39.870411
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 16,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                79.190647,
                39.72068
              ],
              [
                79.117647,
                39.715436
              ],
              [
                79.092246,
                39.681032
              ],
              [
                79.003684,
                39.65927
              ],
              [
                79.000252,
                39.624993
              ],
              [
                78.915581,
                39.611247
              ],
              [
                78.84075,
                39.6131
              ],
              [
                78.796584,
                39.653404
              ],
              [
                78.708709,
                39.650471
              ],
              [
                78.705276,
                39.689982
              ],
              [
                78.673467,
                39.700936
              ],
              [
                78.657449,
                39.736409
              ],
              [
                78.757223,
                39.796672
              ],
              [
                78.777819,
                39.825012
              ],
              [
                78.776675,
                39.758147
              ],
              [
                78.809856,
                39.74381
              ],
              [
                78.782853,
                39.688593
              ],
              [
                78.806424,
                39.657264
              ],
              [
                78.840521,
                39.711271
              ],
              [
                78.883772,
                39.704176
              ],
              [
                78.870728,
                39.762154
              ],
              [
                78.904368,
                39.781418
              ],
              [
                78.993387,
                39.781418
              ],
              [
                79.004829,
                39.800677
              ],
              [
                78.942584,
                39.809765
              ],
              [
                78.906885,
                39.831326
              ],
              [
                78.932057,
                39.859806
              ],
              [
                78.989496,
                39.868271
              ],
              [
                78.942813,
                39.908118
              ],
              [
                78.989725,
                39.929494
              ],
              [
                79.001625,
                39.970996
              ],
              [
                79.039155,
                39.981291
              ],
              [
                79.015355,
                40.022147
              ],
              [
                79.045562,
                40.036887
              ],
              [
                79.214218,
                40.059603
              ],
              [
                79.482648,
                40.097652
              ],
              [
                79.573955,
                40.012012
              ],
              [
                79.606222,
                39.913347
              ],
              [
                79.55725,
                39.865039
              ],
              [
                79.53551,
                39.862884
              ],
              [
                79.406215,
                39.89212
              ],
              [
                79.278522,
                39.877658
              ],
              [
                79.298889,
                39.844566
              ],
              [
                79.28882,
                39.814848
              ],
              [
                79.325663,
                39.80345
              ],
              [
                79.246484,
                39.784808
              ],
              [
                79.240306,
                39.733017
              ],
              [
                79.190647,
                39.72068
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659004,
        "name": "五家渠市",
        "center": [
          87.526884,
          44.167401
        ],
        "centroid": [
          87.557631,
          44.362095
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 17,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                87.504658,
                44.066424
              ],
              [
                87.493674,
                44.107615
              ],
              [
                87.521592,
                44.150935
              ],
              [
                87.506489,
                44.167765
              ],
              [
                87.523423,
                44.227279
              ],
              [
                87.471934,
                44.283145
              ],
              [
                87.489783,
                44.303525
              ],
              [
                87.423877,
                44.351433
              ],
              [
                87.430056,
                44.408469
              ],
              [
                87.449279,
                44.443552
              ],
              [
                87.406943,
                44.529381
              ],
              [
                87.370557,
                44.566963
              ],
              [
                87.514498,
                44.548818
              ],
              [
                87.501912,
                44.594812
              ],
              [
                87.554774,
                44.580532
              ],
              [
                87.59116,
                44.533383
              ],
              [
                87.598711,
                44.477756
              ],
              [
                87.652718,
                44.450423
              ],
              [
                87.663702,
                44.417063
              ],
              [
                87.693452,
                44.416633
              ],
              [
                87.692765,
                44.370212
              ],
              [
                87.716107,
                44.356881
              ],
              [
                87.712216,
                44.262902
              ],
              [
                87.691163,
                44.221963
              ],
              [
                87.652489,
                44.196236
              ],
              [
                87.640132,
                44.226561
              ],
              [
                87.584066,
                44.239347
              ],
              [
                87.564614,
                44.170929
              ],
              [
                87.576743,
                44.116541
              ],
              [
                87.527542,
                44.093648
              ],
              [
                87.508319,
                44.021456
              ],
              [
                87.492529,
                44.007757
              ],
              [
                87.504658,
                44.066424
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659005,
        "name": "北屯市",
        "center": [
          87.824932,
          47.353177
        ],
        "centroid": [
          87.95973,
          47.244003
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 18,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                87.556147,
                47.356673
              ],
              [
                87.771715,
                47.357081
              ],
              [
                87.753637,
                47.380167
              ],
              [
                87.803066,
                47.382339
              ],
              [
                87.831671,
                47.357216
              ],
              [
                87.853411,
                47.367267
              ],
              [
                87.873091,
                47.346213
              ],
              [
                87.828696,
                47.351919
              ],
              [
                87.862565,
                47.317539
              ],
              [
                87.906731,
                47.341322
              ],
              [
                87.98591,
                47.316859
              ],
              [
                88.038772,
                47.312237
              ],
              [
                88.098042,
                47.28096
              ],
              [
                88.262121,
                47.238503
              ],
              [
                88.312237,
                47.258103
              ],
              [
                88.339698,
                47.239728
              ],
              [
                88.43009,
                47.258239
              ],
              [
                88.428717,
                47.234691
              ],
              [
                88.343359,
                47.232512
              ],
              [
                88.342673,
                47.174344
              ],
              [
                88.273563,
                47.132892
              ],
              [
                88.176763,
                47.114883
              ],
              [
                88.077904,
                47.128663
              ],
              [
                88.05502,
                47.147486
              ],
              [
                88.005361,
                47.145713
              ],
              [
                87.91085,
                47.172572
              ],
              [
                87.886364,
                47.161121
              ],
              [
                87.79437,
                47.184156
              ],
              [
                87.74311,
                47.204866
              ],
              [
                87.66805,
                47.267492
              ],
              [
                87.595508,
                47.289121
              ],
              [
                87.527542,
                47.338604
              ],
              [
                87.556147,
                47.356673
              ]
            ]
          ],
          [
            [
              [
                87.540357,
                47.4297
              ],
              [
                87.554774,
                47.42129
              ],
              [
                87.490241,
                47.400664
              ],
              [
                87.481316,
                47.411114
              ],
              [
                87.540357,
                47.4297
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659006,
        "name": "铁门关市",
        "center": [
          85.501218,
          41.827251
        ],
        "centroid": [
          85.590071,
          41.800499
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 19,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                85.512142,
                41.914581
              ],
              [
                85.754484,
                41.852779
              ],
              [
                85.792701,
                41.82589
              ],
              [
                85.73961,
                41.756374
              ],
              [
                85.773021,
                41.72705
              ],
              [
                85.785836,
                41.664468
              ],
              [
                85.726795,
                41.661472
              ],
              [
                85.703682,
                41.684237
              ],
              [
                85.705513,
                41.745903
              ],
              [
                85.526101,
                41.740218
              ],
              [
                85.491089,
                41.754579
              ],
              [
                85.357675,
                41.747399
              ],
              [
                85.367973,
                41.826488
              ],
              [
                85.498412,
                41.866369
              ],
              [
                85.512142,
                41.914581
              ]
            ]
          ],
          [
            [
              [
                86.099576,
                41.798392
              ],
              [
                86.091109,
                41.771181
              ],
              [
                85.888585,
                41.763853
              ],
              [
                85.876685,
                41.778957
              ],
              [
                85.894993,
                41.821856
              ],
              [
                86.099576,
                41.798392
              ]
            ]
          ],
          [
            [
              [
                85.437311,
                41.932036
              ],
              [
                85.408706,
                41.94203
              ],
              [
                85.443948,
                41.93845
              ],
              [
                85.437311,
                41.932036
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659007,
        "name": "双河市",
        "center": [
          82.353656,
          44.840524
        ],
        "centroid": [
          82.468534,
          44.833549
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 20,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                82.206996,
                44.821248
              ],
              [
                82.150015,
                44.833905
              ],
              [
                82.122096,
                44.806313
              ],
              [
                82.083422,
                44.837602
              ],
              [
                82.100814,
                44.857504
              ],
              [
                82.138115,
                44.843005
              ],
              [
                82.162372,
                44.864326
              ],
              [
                82.088915,
                44.879247
              ],
              [
                82.07999,
                44.895584
              ],
              [
                82.138344,
                44.88493
              ],
              [
                82.145667,
                44.89672
              ],
              [
                82.223244,
                44.889192
              ],
              [
                82.278395,
                44.860631
              ],
              [
                82.3562,
                44.901833
              ],
              [
                82.446364,
                44.883509
              ],
              [
                82.49648,
                44.884219
              ],
              [
                82.49648,
                44.903395
              ],
              [
                82.539502,
                44.902685
              ],
              [
                82.656439,
                44.944425
              ],
              [
                82.679552,
                44.871432
              ],
              [
                82.738822,
                44.858641
              ],
              [
                82.735847,
                44.827364
              ],
              [
                82.674518,
                44.792797
              ],
              [
                82.666737,
                44.770025
              ],
              [
                82.596483,
                44.722888
              ],
              [
                82.543163,
                44.709067
              ],
              [
                82.542934,
                44.740124
              ],
              [
                82.499912,
                44.740836
              ],
              [
                82.347047,
                44.799769
              ],
              [
                82.312721,
                44.80361
              ],
              [
                82.268097,
                44.832625
              ],
              [
                82.206996,
                44.821248
              ]
            ]
          ],
          [
            [
              [
                82.20036,
                44.984291
              ],
              [
                82.211115,
                44.94329
              ],
              [
                82.200589,
                44.91788
              ],
              [
                82.130564,
                44.925121
              ],
              [
                82.063971,
                44.933638
              ],
              [
                82.045892,
                44.972802
              ],
              [
                81.993946,
                44.961169
              ],
              [
                81.940397,
                45.010238
              ],
              [
                82.058936,
                45.041274
              ],
              [
                82.133767,
                45.037165
              ],
              [
                82.20036,
                44.984291
              ]
            ]
          ],
          [
            [
              [
                82.23583,
                44.6817
              ],
              [
                82.19235,
                44.662308
              ],
              [
                82.156651,
                44.669581
              ],
              [
                82.128962,
                44.637773
              ],
              [
                82.080905,
                44.64405
              ],
              [
                82.084338,
                44.666444
              ],
              [
                82.126216,
                44.680702
              ],
              [
                82.172213,
                44.713627
              ],
              [
                82.192579,
                44.752229
              ],
              [
                82.239263,
                44.724028
              ],
              [
                82.23583,
                44.6817
              ]
            ]
          ],
          [
            [
              [
                82.393959,
                44.669724
              ],
              [
                82.358947,
                44.66844
              ],
              [
                82.347276,
                44.691252
              ],
              [
                82.393959,
                44.669724
              ]
            ]
          ],
          [
            [
              [
                82.454144,
                45.068895
              ],
              [
                82.438812,
                45.006977
              ],
              [
                82.275191,
                45.03008
              ],
              [
                82.287319,
                45.050624
              ],
              [
                82.272902,
                45.091407
              ],
              [
                82.295786,
                45.106693
              ],
              [
                82.454144,
                45.068895
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659008,
        "name": "可克达拉市",
        "center": [
          80.63579,
          43.6832
        ],
        "centroid": [
          80.603017,
          43.96732
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 21,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                80.440804,
                44.083854
              ],
              [
                80.521356,
                44.07017
              ],
              [
                80.531196,
                44.029674
              ],
              [
                80.586347,
                44.017707
              ],
              [
                80.553851,
                44.101424
              ],
              [
                80.566895,
                44.17323
              ],
              [
                80.637607,
                44.180852
              ],
              [
                80.701911,
                44.133093
              ],
              [
                80.673764,
                44.100272
              ],
              [
                80.699394,
                44.067577
              ],
              [
                80.679256,
                44.062534
              ],
              [
                80.741729,
                44.016842
              ],
              [
                80.725482,
                43.969816
              ],
              [
                80.736237,
                43.921164
              ],
              [
                80.71999,
                43.890971
              ],
              [
                80.672391,
                43.844713
              ],
              [
                80.660949,
                43.778734
              ],
              [
                80.576735,
                43.783945
              ],
              [
                80.624792,
                43.754407
              ],
              [
                80.587491,
                43.725724
              ],
              [
                80.522042,
                43.816652
              ],
              [
                80.512202,
                43.904119
              ],
              [
                80.475359,
                43.939215
              ],
              [
                80.484741,
                43.957837
              ],
              [
                80.454763,
                43.985688
              ],
              [
                80.458654,
                44.047259
              ],
              [
                80.440804,
                44.083854
              ]
            ]
          ],
          [
            [
              [
                80.739899,
                43.888659
              ],
              [
                80.793905,
                43.906431
              ],
              [
                80.873771,
                43.91452
              ],
              [
                80.917021,
                43.889382
              ],
              [
                80.985674,
                43.893139
              ],
              [
                81.014508,
                43.873773
              ],
              [
                81.072175,
                43.895595
              ],
              [
                81.125953,
                43.870593
              ],
              [
                81.039909,
                43.849052
              ],
              [
                80.862328,
                43.867702
              ],
              [
                80.764156,
                43.854257
              ],
              [
                80.739899,
                43.888659
              ]
            ]
          ],
          [
            [
              [
                80.9351,
                43.929685
              ],
              [
                80.987047,
                43.990016
              ],
              [
                81.079269,
                43.96592
              ],
              [
                81.076295,
                43.96058
              ],
              [
                81.057987,
                43.95062
              ],
              [
                81.05547,
                43.944124
              ],
              [
                81.082931,
                43.930984
              ],
              [
                81.071031,
                43.907731
              ],
              [
                80.978122,
                43.908742
              ],
              [
                80.9351,
                43.929685
              ]
            ]
          ],
          [
            [
              [
                80.624792,
                43.754407
              ],
              [
                80.669873,
                43.753683
              ],
              [
                80.660949,
                43.778734
              ],
              [
                80.672391,
                43.844713
              ],
              [
                80.727084,
                43.811443
              ],
              [
                80.775369,
                43.80334
              ],
              [
                80.756833,
                43.784959
              ],
              [
                80.782463,
                43.696882
              ],
              [
                80.707632,
                43.673827
              ],
              [
                80.632344,
                43.663384
              ],
              [
                80.587491,
                43.725724
              ],
              [
                80.624792,
                43.754407
              ]
            ]
          ],
          [
            [
              [
                81.05547,
                43.944124
              ],
              [
                81.057987,
                43.95062
              ],
              [
                81.076295,
                43.96058
              ],
              [
                81.082931,
                43.930984
              ],
              [
                81.05547,
                43.944124
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 659009,
        "name": "昆玉市",
        "center": [
          79.287372,
          37.207994
        ],
        "centroid": [
          79.593726,
          37.372468
        ],
        "childrenNum": 0,
        "level": "city",
        "parent": {
          "adcode": 650000
        },
        "subFeatureIndex": 22,
        "acroutes": [
          100000,
          650000
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                79.618122,
                37.392438
              ],
              [
                79.610341,
                37.373797
              ],
              [
                79.580363,
                37.340008
              ],
              [
                79.572354,
                37.38256
              ],
              [
                79.618122,
                37.392438
              ]
            ]
          ],
          [
            [
              [
                79.694326,
                37.517546
              ],
              [
                79.686774,
                37.447537
              ],
              [
                79.643294,
                37.424292
              ],
              [
                79.632768,
                37.474275
              ],
              [
                79.661601,
                37.554116
              ],
              [
                79.699131,
                37.561269
              ],
              [
                79.694326,
                37.517546
              ]
            ]
          ],
          [
            [
              [
                78.543028,
                37.574301
              ],
              [
                78.521746,
                37.555706
              ],
              [
                78.488793,
                37.568739
              ],
              [
                78.491081,
                37.616879
              ],
              [
                78.441881,
                37.642128
              ],
              [
                78.414191,
                37.621167
              ],
              [
                78.330664,
                37.603537
              ],
              [
                78.359956,
                37.653876
              ],
              [
                78.350344,
                37.68546
              ],
              [
                78.350344,
                37.731146
              ],
              [
                78.54463,
                37.791066
              ],
              [
                78.543028,
                37.574301
              ]
            ]
          ],
          [
            [
              [
                79.367083,
                37.325021
              ],
              [
                79.374406,
                37.174033
              ],
              [
                79.254494,
                37.214283
              ],
              [
                79.251061,
                37.197036
              ],
              [
                79.197513,
                37.206299
              ],
              [
                79.211243,
                37.231367
              ],
              [
                79.256325,
                37.236316
              ],
              [
                79.249917,
                37.414896
              ],
              [
                79.377152,
                37.416489
              ],
              [
                79.370974,
                37.385428
              ],
              [
                79.33825,
                37.371406
              ],
              [
                79.36571,
                37.354354
              ],
              [
                79.367083,
                37.325021
              ]
            ]
          ],
          [
            [
              [
                81.047461,
                36.250771
              ],
              [
                81.031671,
                36.259341
              ],
              [
                81.03373,
                36.275992
              ],
              [
                81.033959,
                36.280033
              ],
              [
                81.049978,
                36.315101
              ],
              [
                81.047461,
                36.250771
              ]
            ]
          ],
          [
            [
              [
                79.783116,
                37.580499
              ],
              [
                79.818128,
                37.574937
              ],
              [
                79.818586,
                37.537742
              ],
              [
                79.783802,
                37.537265
              ],
              [
                79.783116,
                37.580499
              ]
            ]
          ]
        ]
      }
    }
  ]
}